
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4bm59", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $jMyy4 = parcelRequire("jMyy4");


var $kquO1 = parcelRequire("kquO1");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $bcpTP = parcelRequire("bcpTP");


var $3tIUC = parcelRequire("3tIUC");


var $iLuzG = parcelRequire("iLuzG");

const $1c214bffe3083150$export$fda0b2df9049e216 = (addresses)=>{
    const perAddress = addresses.map((address)=>{
        const providerKey = (0, $3tIUC.matchProviderKey)(address);
        return providerKey ? (0, $iLuzG.resolveProviderKeyToAppId)(providerKey) : undefined;
    });
    const matched = perAddress.filter((appId)=>appId !== undefined);
    // Every address either names one product or names none, so the shortfall is the unmatched count.
    return {
        appIds: new Set(matched),
        unmatchedAddressCount: addresses.length - matched.length
    };
};



var $dkZJV = parcelRequire("dkZJV");


var $aoy1P = parcelRequire("aoy1P");


var $lj5ER = parcelRequire("lj5ER");


var $lPAGb = parcelRequire("lPAGb");

const $cef0a55d9455e3c4$export$69b3f92ba1a7da00 = (rows)=>{
    const drafts = new Map();
    for (const row of rows){
        const { providerId: providerId } = row;
        if (!providerId) continue;
        let draft = drafts.get(providerId);
        if (!draft) {
            draft = {
                smartLinkGranted: false,
                hasFullConnector: false,
                fullConnectorGranted: false
            };
            drafts.set(providerId, draft);
        }
        const source = (0, $lj5ER.classifyConnectorRow)(row);
        if (source === (0, $aoy1P.FULL_CONNECTOR_SOURCE)) {
            draft.hasFullConnector = true;
            draft.fullConnectorGranted = draft.fullConnectorGranted || row.isUserOAuthed;
            draft.fullConnectorAuthUrl = draft.fullConnectorAuthUrl || row.outboundAuthUrl || undefined;
            continue;
        }
        // An unmappable Smart Links row must not hide a sibling that names a product.
        if (source === (0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE) && !draft.appId) {
            const appId = (0, $lPAGb.resolveAppIdForConnectorName)(row.name);
            if (appId) {
                draft.appId = appId;
                draft.smartLinkGranted = row.isUserOAuthed;
            }
        }
    }
    const pairs = [];
    for (const [providerId, draft] of drafts){
        const { appId: appId, hasFullConnector: hasFullConnector } = draft;
        if (appId && hasFullConnector) pairs.push({
            providerId: providerId,
            appId: appId,
            smartLinkGranted: draft.smartLinkGranted,
            fullConnectorGranted: draft.fullConnectorGranted,
            fullConnectorAuthUrl: draft.fullConnectorAuthUrl
        });
    }
    return pairs;
};
const $cef0a55d9455e3c4$export$bb7ca9899819b888 = (grants)=>grants.smartLinkGranted && !grants.fullConnectorGranted && Boolean(grants.fullConnectorAuthUrl);
const $cef0a55d9455e3c4$export$f62faeb8900f35b9 = (rows)=>{
    const seen = new Set();
    const products = [];
    for (const grants of $cef0a55d9455e3c4$export$69b3f92ba1a7da00(rows)){
        if (!$cef0a55d9455e3c4$export$bb7ca9899819b888(grants) || seen.has(grants.appId)) continue;
        seen.add(grants.appId);
        const appInfo = (0, $dkZJV.appIdToAppInfoMap)[grants.appId];
        products.push({
            appId: grants.appId,
            displayName: appInfo.normalizedAppName,
            iconUrl: appInfo.smartlinkLogo ?? appInfo.logo,
            outboundAuthUrl: grants.fullConnectorAuthUrl
        });
    }
    return products;
};


const $f3ee9023b35a1613$var$NO_PROMPT = {
    kind: 'none'
};
const $f3ee9023b35a1613$export$202d47f9b52a3b20 = ({ userId: userId, cloudId: cloudId, pageAddresses: pageAddresses })=>{
    const { rows: rows, failureReason: failureReason } = (0, $bcpTP.readConnectorRowsFromLocalStorage)({
        userId: userId,
        cloudId: cloudId
    });
    const products = (0, $cef0a55d9455e3c4$export$f62faeb8900f35b9)(rows);
    // Distinct, so a repeated link does not inflate the address counters.
    const addresses = products.length === 0 || !pageAddresses ? [] : [
        ...new Set(pageAddresses)
    ];
    const { appIds: appIds, unmatchedAddressCount: unmatchedAddressCount } = (0, $1c214bffe3083150$export$fda0b2df9049e216)(addresses);
    // `appId` is widened to `string` in the contract, so compare against a read-only view of the set.
    const linkedAppIds = appIds;
    const linked = products.filter(({ appId: appId })=>linkedAppIds.has(appId));
    const diagnostics = {
        connectorRowsFailureReason: failureReason,
        connectorRowCount: rows.length,
        candidateCount: products.length,
        addressCount: addresses.length,
        unmatchedAddressCount: unmatchedAddressCount
    };
    // Tenant-wide connectors are not page candidates. Hold until outgoing links exist.
    if (products.length > 0 && pageAddresses === undefined) return {
        state: {
            kind: 'pending'
        },
        count: products.length,
        diagnostics: diagnostics
    };
    const [product, ...rest] = linked;
    if (!product) return {
        state: $f3ee9023b35a1613$var$NO_PROMPT,
        count: 0,
        diagnostics: diagnostics
    };
    if (rest.length === 0) return {
        state: {
            kind: 'single',
            product: product
        },
        count: 1,
        diagnostics: diagnostics
    };
    return {
        state: {
            kind: 'many',
            candidates: linked
        },
        count: linked.length,
        diagnostics: diagnostics
    };
};


const $3e1b4e423af4bfb0$var$NO_PROMPT = {
    state: {
        kind: 'none'
    },
    count: 0,
    diagnostics: {
        connectorRowsFailureReason: null,
        connectorRowCount: 0,
        candidateCount: 0,
        addressCount: 0,
        unmatchedAddressCount: 0
    }
};
const $3e1b4e423af4bfb0$var$readAddresses = (data, contentId)=>{
    const nodes = data.content?.nodes;
    const currentPage = nodes?.find((node)=>node?.id === contentId);
    if (!currentPage && nodes?.length) return undefined;
    return(// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    currentPage?.outgoingLinks?.externalOutgoingLinks?.nodes?.map((node)=>node?.url)?.filter((url)=>Boolean(url)) ?? []);
};
const $3e1b4e423af4bfb0$export$e5c2529af57af7c0 = (contentId)=>{
    const $ = (0, $bDgLe.c)(16);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== contentId || $[3] !== userId) {
        t1 = !contentId || !userId || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_3p_in_related_content", "shouldEvaluate", true);
        $[2] = contentId;
        $[3] = userId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $kquO1.OutgoingLinksQuery), {
        ...t2,
        __callerPackage__: "experiment-related-content-connections"
    });
    let t3;
    let t4;
    if ($[8] !== cloudId || $[9] !== contentId || $[10] !== data || $[11] !== error || $[12] !== loading || $[13] !== userId) {
        t4 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const pageAddresses = data ? $3e1b4e423af4bfb0$var$readAddresses(data, contentId) : undefined;
            if (!contentId || !userId || error || !loading && data !== undefined && pageAddresses === undefined || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_3p_in_related_content", "shouldEvaluate", true)) {
                t4 = $3e1b4e423af4bfb0$var$NO_PROMPT;
                break bb0;
            }
            t3 = (0, $f3ee9023b35a1613$export$202d47f9b52a3b20)({
                userId: userId,
                cloudId: cloudId,
                pageAddresses: pageAddresses
            });
        }
        $[8] = cloudId;
        $[9] = contentId;
        $[10] = data;
        $[11] = error;
        $[12] = loading;
        $[13] = userId;
        $[14] = t3;
        $[15] = t4;
    } else {
        t3 = $[14];
        t4 = $[15];
    }
    if (t4 !== Symbol.for("react.early_return_sentinel")) return t4;
    return t3;
};
module.exports["useThirdPartyPromptState"] = $3e1b4e423af4bfb0$export$e5c2529af57af7c0;

});

parcelRegister("3dOiI", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $c992d301b5eec450$export$e03be33cf6ebb3ea = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY)
});
module.exports["END_OF_PAGE_RECOMMENDATIONS_METRIC"] = $c992d301b5eec450$export$e03be33cf6ebb3ea;

});

parcelRegister("dOvHJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $iODl6 = parcelRequire("iODl6");


var $57p4j = parcelRequire("57p4j");


var $isEtk = parcelRequire("isEtk");


var $fgRQY = parcelRequire("fgRQY");


var $1d2ww = parcelRequire("1d2ww");


var $kvJHJ = parcelRequire("kvJHJ");


var $luv00 = parcelRequire("luv00");


var $6mKj3 = parcelRequire("6mKj3");








var $3izAL = parcelRequire("3izAL");


var $9iaFM = parcelRequire("9iaFM");


var $buxP3 = parcelRequire("buxP3");




















var $3jwuS = parcelRequire("3jwuS");














var $hekY6 = parcelRequire("hekY6");








var $71GjD = parcelRequire("71GjD");


var $AXitC = parcelRequire("AXitC");











var $jJK3p = parcelRequire("jJK3p");




const $5113cbd45b7d83ee$var$linkStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5113cbd45b7d83ee$var$AuthorContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2sNsIg7NXe _42Yu6BdnbC _1ANEUSLRg7 _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYzZpcK _1mT5xdRAKS _4nTk44nQyn _1YaocbnQyn _0gKGieKYuM _0LWC4wu7m9 _1SMQPTLRg7 _09AWy0z8Lp _1EjoPeKYuM _1BrKNsKYuM _1E1xWzKYuM _3bFj0TKYuM",
            __cmplp.compact && "_2SjabCnQyn _3y1XktnQyn _2oI5unLRg7 _2bqyXyz8Lp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $5113cbd45b7d83ee$export$cae754750d6ddba6 = ()=>{
    const $ = (0, $bDgLe.c)(7);
    const pageCard = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    if ("history" in pageCard && "creatorId" in pageCard) {
        const hasAuthor = pageCard.history?.ownedBy?.displayName;
        let t0;
        if ($[0] !== hasAuthor || $[1] !== pageCard.creatorId || $[2] !== pageCard.history) {
            t0 = hasAuthor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5113cbd45b7d83ee$var$AuthorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
                userId: pageCard.creatorId,
                fullName: pageCard.history.ownedBy.displayName,
                referralSource: "pageCard"
            })) : null;
            $[0] = hasAuthor;
            $[1] = pageCard.creatorId;
            $[2] = pageCard.history;
            $[3] = t0;
        } else t0 = $[3];
        return t0;
    }
    if ("createdBy" in pageCard) {
        const hasAuthor_0 = pageCard.createdBy?.displayName;
        let t0;
        if ($[4] !== hasAuthor_0 || $[5] !== pageCard.createdBy) {
            t0 = hasAuthor_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5113cbd45b7d83ee$var$AuthorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
                userId: pageCard.createdBy.accountId,
                fullName: pageCard.createdBy.displayName,
                referralSource: "pageCard"
            })) : null;
            $[4] = hasAuthor_0;
            $[5] = pageCard.createdBy;
            $[6] = t0;
        } else t0 = $[6];
        return t0;
    }
    return null;
};


var $dDr80 = parcelRequire("dDr80");

var $aoeyL = parcelRequire("aoeyL");

var $9CEYG = parcelRequire("9CEYG");

var $63k9q = parcelRequire("63k9q");

const $673d28836402b3d5$var$StyledCard = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $dDr80.Card) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYE2ADO _3iDTPbQ4SZ _0jFU0VHMkp _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $673d28836402b3d5$var$StyledCardWithHover = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $673d28836402b3d5$var$StyledCard : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1eOmH6sumd",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $673d28836402b3d5$var$GridCardStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    maxHeight: '50px'
});
const $673d28836402b3d5$var$Header = (0, $buxP3.xcss)({
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 'space.150',
    paddingInlineStart: 'space.050'
});
const $673d28836402b3d5$var$HeaderSmallCard = (0, $buxP3.xcss)({
    marginBottom: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $673d28836402b3d5$var$IconContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1UtDYz4YkS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $673d28836402b3d5$var$TitlesContainer = (0, $buxP3.xcss)({
    overflow: 'hidden',
    overflowWrap: 'break-word',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.050'
});
const $673d28836402b3d5$var$TitlesContainerSmallCard = (0, $buxP3.xcss)({
    whiteSpace: 'nowrap'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $673d28836402b3d5$var$TitleContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbgJ9S _4Gn54RiZR3 _1U1ZhbbI28 _39HuIbz8Lp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $673d28836402b3d5$export$9f35c824a9d0b65b = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { showCardsAsListitem: t1 } = t0;
    const showCardsAsListitem = t1 === undefined ? true : t1;
    const { smallCard: smallCard } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const t2 = smallCard ? $673d28836402b3d5$var$StyledCardWithHover : $673d28836402b3d5$var$StyledCard;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9CEYG.PageLink), {
            featureAttributionCode: (0, $71GjD.FeatureCode).EOP_REC
        });
        $[0] = t3;
    } else t3 = $[0];
    let t4;
    if ($[1] !== smallCard) {
        t4 = [
            $673d28836402b3d5$var$Header,
            ...smallCard ? [
                $673d28836402b3d5$var$HeaderSmallCard
            ] : []
        ];
        $[1] = smallCard;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($673d28836402b3d5$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aoeyL.ContentIcon), null));
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== smallCard) {
        t6 = [
            $673d28836402b3d5$var$TitlesContainer,
            ...smallCard ? [
                $673d28836402b3d5$var$TitlesContainerSmallCard
            ] : []
        ];
        $[4] = smallCard;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($673d28836402b3d5$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63k9q.Title), null));
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5113cbd45b7d83ee$export$cae754750d6ddba6), null);
        $[6] = t7;
        $[7] = t8;
    } else {
        t7 = $[6];
        t8 = $[7];
    }
    let t9;
    if ($[8] !== t6) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t6
        }, t7, t8);
        $[8] = t6;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== t4 || $[11] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $673d28836402b3d5$var$GridCardStyles,
            testId: "page-card-end-of-page-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t4
        }, t5, t9));
        $[10] = t4;
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    let t11;
    if ($[13] !== showCardsAsListitem || $[14] !== t10 || $[15] !== t2) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dDr80.PageCardContainer), {
            StyledCard: t2,
            isListitem: showCardsAsListitem
        }, t3, t10);
        $[13] = showCardsAsListitem;
        $[14] = t10;
        $[15] = t2;
        $[16] = t11;
    } else t11 = $[16];
    return t11;
};


var $kzTi3 = parcelRequire("kzTi3");








var $4n1IT = parcelRequire("4n1IT");














var $bQm3c = parcelRequire("bQm3c");








var $55fM8 = parcelRequire("55fM8");

const $ea262e0136b0745d$var$HOVER_DELAY_TIME = 300;
const $ea262e0136b0745d$var$CLOSE_DELAY_TIME = 400;
const $ea262e0136b0745d$export$65b46b17148edcc8 = ()=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const isMouseInsideRef = (0, $cozmU.useRef)(false);
    const onMouseLeaveDebounce = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
        if (!isMouseInsideRef.current) setIsOpen(false);
    }, $ea262e0136b0745d$var$CLOSE_DELAY_TIME);
    const onMouseEnterDebounce = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
        if (isMouseInsideRef.current) setIsOpen(true);
    }, $ea262e0136b0745d$var$HOVER_DELAY_TIME);
    const onMouseEnter = ()=>{
        isMouseInsideRef.current = true;
        onMouseEnterDebounce();
    };
    const onMouseLeave = ()=>{
        isMouseInsideRef.current = false;
        onMouseLeaveDebounce();
    };
    const onMouseEnterIcon = ()=>{
        isMouseInsideRef.current = false;
        setIsOpen(false);
    };
    const onMouseLeaveIcon = ()=>{
        isMouseInsideRef.current = true;
        setIsOpen(true);
    };
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            onMouseLeaveDebounce.cancel();
        };
    }, [
        onMouseLeaveDebounce
    ]);
    return {
        isOpen: isOpen,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseEnterIcon: onMouseEnterIcon,
        onMouseLeaveIcon: onMouseLeaveIcon
    };
};



var $jb4sa = parcelRequire("jb4sa");

/**
 * @generated SignedSource<<754b40353cf23d6d7f6ba35a9d17b192>>
 * @relayHash ebdb3c83478a0febad213c0d0c5d0338
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8a0d1407b5ab19a4145ae8260858ede976c05eb6eab7abab7555c4d0cc53792b
const $ffc55089e01e6d65$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v2 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v10 = {
        "alias": "editorVersion",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "properties(key:\"editor\")"
    }, v11 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 372
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:372)"
    }, v13 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            }
        ]
    }, v14 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v17 = [
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v18 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v19 = {
        "concreteType": "LikesResponse",
        "kind": "LinkedField",
        "name": "likes",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ]
    }, v20 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                }
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "ebdb3c83478a0febad213c0d0c5d0338",
            "id": "8a0d1407b5ab19a4145ae8260858ede976c05eb6eab7abab7555c4d0cc53792b",
            "metadata": {},
            "name": "PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery",
            "operationKind": "query",
            "text": "query PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery($id:ID!){singleContent(id:$id){id,title,type,subType,status,links{webui,editui},editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},lastModifiedDate},history{createdBy{__typename,profilePicture{path},displayName,...on KnownUser{accountId}},ownedBy{__typename,profilePicture{path},displayName,...on KnownUser{accountId}}},space{id,key,alias,name},likes{count},version{by{__typename,profilePicture{path},displayName,...on KnownUser{accountId}}}}}"
        }
    };
}();
$ffc55089e01e6d65$var$node.hash = "f109efa4dac01c6b97a01fe95c90ba72";
var $ffc55089e01e6d65$export$2e2bcd8739ae039 = $ffc55089e01e6d65$var$node;






var $iMnC5 = parcelRequire("iMnC5");





var $fNTq8 = parcelRequire("fNTq8");


var $5GgqH = parcelRequire("5GgqH");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");





var $fOasY = parcelRequire("fOasY");





var $cxMI6 = parcelRequire("cxMI6");


var $jMyy4 = parcelRequire("jMyy4");

const $916e3938ee5654db$var$PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery = (0, $ffc55089e01e6d65$export$2e2bcd8739ae039);
const $916e3938ee5654db$export$fec5aea78c76fcc6 = ({ id: id, type: type, showAISnippets: showAISnippets, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, update: update })=>{
    const popupPageCardRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { getDwellTime: getDwellTime } = (0, $5GgqH.usePopupDwellTime)(popupPageCardRef);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'spacePageCard',
                    source: 'endOfPageRecommendations',
                    actionSubjectId: 'endOfPageRecommendations',
                    attributes: {
                        contentId: id,
                        dwellTime: getDwellTime(),
                        isAiSnippet: showAISnippets
                    }
                }
            }).fire();
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { loading: loading, data: data, error: error } = (0, $jMyy4.useQueryInterop)($916e3938ee5654db$var$PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery, {
        variables: {
            id: id
        },
        __callerPackage__: "page-card"
    });
    const shouldRenderContent = (0, $cozmU.useMemo)(()=>Boolean(!error && !loading && data?.singleContent), [
        error,
        loading,
        data
    ]);
    const aiAnalyticsConfig = (0, $cozmU.useMemo)(()=>({
            product: 'confluence',
            subproduct: 'confluence',
            source: 'confluencePage',
            aiFeatureName: 'aiSnippet',
            proactiveGeneratedAI: 1,
            userGeneratedAI: 0,
            additionalAttributes: {
                contentId: data?.singleContent?.id,
                contentType: data?.singleContent?.type,
                from: (0, $71GjD.FeatureCode).EOP_REC_CARD
            }
        }), [
        data?.singleContent?.id,
        data?.singleContent?.type
    ]);
    return shouldRenderContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: popupPageCardRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
        config: aiAnalyticsConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb4sa.PageCardContextProvider), {
        data: (0, $cxMI6.transformSpaceContent)(data?.singleContent),
        appearance: "popup-view",
        analyticsData: {
            attributes: {
                from: (0, $71GjD.FeatureCode).EOP_REC_CARD
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fOasY.PopupViewWithAISnippet), {
        isEndOfPage: true,
        contentId: id,
        contentType: type,
        onLoadComplete: ()=>update(),
        shouldUseAISnippetPlatformComponent: true
    }))))) : null;
};


const $f645ea7970507757$var$pageRecCardContainer = (0, $buxP3.xcss)({
    height: '100%'
});
const $f645ea7970507757$var$popupCardStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.large'
});
const $f645ea7970507757$export$2d4bbdf98c1d6ca4 = (t0)=>{
    const $ = (0, $bDgLe.c)(45);
    const { children: children, wrapperProps: wrapperProps, isCompactView: isCompactView } = t0;
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isOpen: isOpen, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseEnterIcon: onMouseEnterIcon, onMouseLeaveIcon: onMouseLeaveIcon } = (0, $ea262e0136b0745d$export$65b46b17148edcc8)();
    const [isHoveringInfoIcon, setIsHoveringInfoIcon] = (0, $cozmU.useState)(false);
    const { id: id, type: type } = wrapperProps.data;
    let t1;
    if ($[0] !== isAdminHubAIEnabled || $[1] !== isHoveringInfoIcon || $[2] !== onMouseEnter) {
        t1 = ()=>{
            if (isAdminHubAIEnabled) (0, $6mKj3.manuallyLogExpExposure)("confluence_ai_enabled_related_pages_snippets");
            else (0, $6mKj3.manuallyLogExpExposure)("confluence_ai_disabled_related_pages_snippets");
            if (isHoveringInfoIcon) return;
            onMouseEnter();
        };
        $[0] = isAdminHubAIEnabled;
        $[1] = isHoveringInfoIcon;
        $[2] = onMouseEnter;
        $[3] = t1;
    } else t1 = $[3];
    const onMouseEnterWrapper = t1;
    let t2;
    if ($[4] !== isHoveringInfoIcon || $[5] !== onMouseLeave) {
        t2 = ()=>{
            if (isHoveringInfoIcon) return;
            onMouseLeave();
        };
        $[4] = isHoveringInfoIcon;
        $[5] = onMouseLeave;
        $[6] = t2;
    } else t2 = $[6];
    const onMouseLeaveWrapper = t2;
    let t3;
    if ($[7] !== createAnalyticsEvent || $[8] !== id || $[9] !== type) {
        t3 = (action)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: action,
                    actionSubject: "globalPageCard",
                    source: "endOfPageRecommendations",
                    attributes: {
                        contentType: type,
                        contentId: id,
                        from: (0, $71GjD.FeatureCode).EOP_REC_CARD,
                        view: "end-of-page-rec-popup-view"
                    }
                }
            }).fire();
        };
        $[7] = createAnalyticsEvent;
        $[8] = id;
        $[9] = type;
        $[10] = t3;
    } else t3 = $[10];
    const fireAnalyticsEvent = t3;
    let t4;
    if ($[11] !== children || $[12] !== isCompactView || $[13] !== onMouseEnterIcon || $[14] !== onMouseEnterWrapper || $[15] !== onMouseLeaveIcon || $[16] !== onMouseLeaveWrapper || $[17] !== wrapperProps) {
        t4 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $f645ea7970507757$var$pageRecCardContainer,
                ...triggerProps,
                onMouseEnter: onMouseEnterWrapper,
                onMouseLeave: onMouseLeaveWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb4sa.PageCardContextProvider), {
                ...wrapperProps,
                appearance: isCompactView ? "compact-end-of-page" : "end-of-page"
            }, children(setIsHoveringInfoIcon, onMouseLeaveIcon, onMouseEnterIcon)));
        $[11] = children;
        $[12] = isCompactView;
        $[13] = onMouseEnterIcon;
        $[14] = onMouseEnterWrapper;
        $[15] = onMouseLeaveIcon;
        $[16] = onMouseLeaveWrapper;
        $[17] = wrapperProps;
        $[18] = t4;
    } else t4 = $[18];
    const triggerContent = t4;
    let t5;
    if ($[19] !== fireAnalyticsEvent) {
        t5 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t6, ref)=>{
            const { "data-testid": testId, shouldRenderToParent: _shouldRenderToParent, shouldFitContainer: _shouldFitContainer, shouldFitViewport: _shouldFitViewport, isReferenceHidden: _isReferenceHidden, ...props } = t6;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                testId: testId,
                ...props,
                ref: ref,
                xcss: $f645ea7970507757$var$popupCardStyles,
                onMouseEnter: ()=>fireAnalyticsEvent("hovered"),
                onClickCapture: ()=>fireAnalyticsEvent("clicked")
            });
        });
        $[19] = fireAnalyticsEvent;
        $[20] = t5;
    } else t5 = $[20];
    const PopupComponent = t5;
    const isInAIEnabledSnippetsExp = isAdminHubAIEnabled && type !== "blogpost";
    let t6;
    if ($[21] !== isInAIEnabledSnippetsExp) {
        t6 = isInAIEnabledSnippetsExp && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_ai_enabled_related_pages_snippets", "cohort", "show_ai_snippet");
        $[21] = isInAIEnabledSnippetsExp;
        $[22] = t6;
    } else t6 = $[22];
    const isAISnippetHoverEnabled = t6;
    const isAIWithExcerptExp = isInAIEnabledSnippetsExp && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_ai_enabled_related_pages_snippets", "cohort", "show_snippet");
    const isNonAIHoverEnabled = !isInAIEnabledSnippetsExp && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_ai_disabled_related_pages_snippets", "cohort", "show_snippet");
    if (isAISnippetHoverEnabled || isAIWithExcerptExp || isNonAIHoverEnabled) {
        let t7;
        if ($[23] !== triggerContent) {
            t7 = (triggerProps_0)=>triggerContent(triggerProps_0);
            $[23] = triggerContent;
            $[24] = t7;
        } else t7 = $[24];
        let t8;
        if ($[25] !== id || $[26] !== isAISnippetHoverEnabled || $[27] !== onMouseEnterWrapper || $[28] !== onMouseLeaveWrapper || $[29] !== type) {
            t8 = (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $916e3938ee5654db$export$fec5aea78c76fcc6), {
                    id: id,
                    type: type,
                    showAISnippets: isAISnippetHoverEnabled,
                    onMouseEnter: onMouseEnterWrapper,
                    onMouseLeave: onMouseLeaveWrapper,
                    update: props_0.update
                });
            $[25] = id;
            $[26] = isAISnippetHoverEnabled;
            $[27] = onMouseEnterWrapper;
            $[28] = onMouseLeaveWrapper;
            $[29] = type;
            $[30] = t8;
        } else t8 = $[30];
        let t9;
        if ($[31] !== PopupComponent || $[32] !== isOpen || $[33] !== t7 || $[34] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
                popupComponent: PopupComponent,
                trigger: t7,
                isOpen: isOpen,
                autoFocus: false,
                content: t8,
                placement: "top-start"
            });
            $[31] = PopupComponent;
            $[32] = isOpen;
            $[33] = t7;
            $[34] = t8;
            $[35] = t9;
        } else t9 = $[35];
        return t9;
    }
    let t7;
    if ($[36] !== children) {
        t7 = children();
        $[36] = children;
        $[37] = t7;
    } else t7 = $[37];
    let t8;
    if ($[38] !== t7 || $[39] !== wrapperProps) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb4sa.PageCardContextProvider), {
            ...wrapperProps,
            appearance: "end-of-page"
        }, t7);
        $[38] = t7;
        $[39] = wrapperProps;
        $[40] = t8;
    } else t8 = $[40];
    let t9;
    if ($[41] !== onMouseEnterWrapper || $[42] !== onMouseLeaveWrapper || $[43] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $f645ea7970507757$var$pageRecCardContainer,
            onMouseEnter: onMouseEnterWrapper,
            onMouseLeave: onMouseLeaveWrapper
        }, t8);
        $[41] = onMouseEnterWrapper;
        $[42] = onMouseLeaveWrapper;
        $[43] = t8;
        $[44] = t9;
    } else t9 = $[44];
    return t9;
};


const $cbfa55b3be44c29a$export$8da2c1e40d5a0791 = (wrapperProps)=>{
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] !== wrapperProps.isCompactView || $[1] !== wrapperProps.showCardsAsListitem) {
        t0 = ()=>wrapperProps.isCompactView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $673d28836402b3d5$export$9f35c824a9d0b65b), {
                showCardsAsListitem: wrapperProps.showCardsAsListitem
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kzTi3.EndOfPageView), {
                showCardsAsListitem: wrapperProps.showCardsAsListitem
            });
        $[0] = wrapperProps.isCompactView;
        $[1] = wrapperProps.showCardsAsListitem;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== t0 || $[4] !== wrapperProps) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f645ea7970507757$export$2d4bbdf98c1d6ca4), {
            wrapperProps: wrapperProps,
            isCompactView: true
        }, t0);
        $[3] = t0;
        $[4] = wrapperProps;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};








const $fac5703f4bfe6f64$export$863e19ab03ac3107 = {
    IDLE: 'idle',
    CONNECTING: 'connecting',
    CONNECTED: 'connected',
    ERROR: 'error'
};
const $fac5703f4bfe6f64$export$4b3baebc16f89880 = {
    POPUP_BLOCKED: 'popup-blocked',
    GENERIC: 'generic'
};
const $fac5703f4bfe6f64$export$266b3d969839d15e = {
    POPUP_BLOCKED: 'popup-blocked',
    UNMOUNTED_DURING_OAUTH: 'unmounted-during-oauth',
    RESOLVED_AFTER_UNMOUNT: 'resolved-after-unmount'
};
const $fac5703f4bfe6f64$export$81ddaaa9359a7ffc = {
    USER_CLOSED_WINDOW: 'user-closed-window'
};






var $bcpTP = parcelRequire("bcpTP");











var $kSwu1 = parcelRequire("kSwu1");


var $aZ9If = parcelRequire("aZ9If");


var $ez9xU = parcelRequire("ez9xU");



var $7aRa9 = parcelRequire("7aRa9");













const $0cf97f3e681d0132$var$styles = {
    root: "_3iDTPbvLZJ _39xV02N91d _0jFU0VIZbP"
};
const $0cf97f3e681d0132$export$f41806ed7e476830 = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $0cf97f3e681d0132$var$styles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "6.87573",
            y: "23.4559",
            width: "160",
            height: "104",
            rx: "12",
            transform: "rotate(-4 6.87573 23.4559)",
            fill: "var(--ds-surface-raised, #FFFFFF)"
        });
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "15.4143",
            y: "30.8784",
            width: "144",
            height: "88",
            rx: "12",
            transform: "rotate(-4 15.4143 30.8784)",
            fill: "var(--ds-surface-sunken, #F8F8F8)"
        });
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Cards",
            filter: "url(#filter0_dd_0_1)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_0_1)"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Frame 2117134038"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_0_1)"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Gestural Line/scribble 8",
            opacity: "0.05"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Scribble 8",
            clipPath: "url(#clip2_0_1)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Group 6272481"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Layer_1-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            id: "Vector",
            d: "M132.075 47.0156C131.236 45.8868 130.533 44.8729 129.917 44.0087C129.301 43.1489 128.804 42.4142 128.429 41.8133C127.673 40.6075 127.394 39.9287 127.55 39.7977C127.709 39.6665 128.308 40.0916 129.322 41.0971C129.828 41.5998 130.438 42.2465 131.148 43.0464C131.853 43.8466 132.629 44.8198 133.507 45.937C134.769 47.5078 135.944 49.1647 137.17 50.809C137.771 51.6388 138.351 52.4922 138.949 53.3444C139.245 53.7684 139.542 54.1969 139.839 54.6253C140.123 55.0636 140.412 55.5015 140.701 55.9439C143.027 59.4505 145.237 63.1877 147.221 67.2654C149.187 71.3398 150.987 75.7684 151.905 80.7567C152.35 83.243 152.592 85.8769 152.302 88.6013C152.021 91.3163 151.137 94.1357 149.458 96.5881C149.019 97.3082 148.442 97.8956 147.925 98.51C147.656 98.8045 147.349 99.0573 147.07 99.3259C146.781 99.5862 146.512 99.863 146.197 100.076C145.588 100.528 145.007 100.991 144.377 101.333C144.07 101.515 143.762 101.696 143.463 101.878C143.149 102.028 142.839 102.175 142.534 102.325C140.071 103.48 137.683 104.056 135.488 104.41C131.074 105.079 127.372 104.866 123.992 104.498C120.611 104.103 117.525 103.478 114.295 102.632C111.064 101.777 107.684 100.697 103.777 99.1464C97.1803 96.5255 89.754 92.6638 82.6828 87.6476C75.5998 82.6545 68.898 76.4961 63.5416 69.8611C60.8596 66.5528 58.5084 63.1412 56.5301 59.7837C56.0528 58.9364 55.5678 58.1075 55.1142 57.2808C54.682 56.4437 54.2597 55.6193 53.8474 54.812L53.6926 54.507L53.5351 54.1622C53.4258 53.9341 53.3426 53.6998 53.2551 53.4657C53.0845 52.9973 52.949 52.522 52.8444 52.0445C52.6397 51.0892 52.5678 50.1247 52.6138 49.1919C52.714 47.3169 53.3083 45.5763 54.2676 44.1571L54.44 43.8871L54.6487 43.6279C54.7925 43.4577 54.9321 43.2923 55.0762 43.1265C55.2298 42.969 55.4108 42.8229 55.5782 42.6733C55.7457 42.5238 55.9182 42.3827 56.1238 42.2705C56.32 42.15 56.5165 42.034 56.7136 41.9268C56.9255 41.8408 57.1424 41.7634 57.3553 41.6907C57.5672 41.6047 57.7822 41.563 57.9982 41.5345C58.2138 41.5017 58.4288 41.4599 58.6372 41.4498C59.4676 41.4318 60.2362 41.547 60.8738 41.7604C61.1968 41.8624 61.5152 41.9646 61.7828 42.1016C62.0586 42.2291 62.3467 42.3424 62.5791 42.4862C62.8201 42.625 63.0564 42.7598 63.2831 42.8862C63.4932 43.0272 63.6984 43.1641 63.8945 43.2971C64.295 43.5538 64.6119 43.8252 64.922 44.0614C66.3491 45.1981 67.5817 46.4774 68.7243 47.8074C69.7458 48.9946 71.1217 50.7353 72.6771 53.006C74.228 55.2771 75.9716 58.0773 77.7752 61.3537C79.5788 64.63 81.4642 68.3765 83.2984 72.5358C85.137 76.6948 86.9462 81.2606 88.558 86.1827C90.1609 91.1054 91.6148 96.3765 92.4868 101.977C92.6917 103.382 92.884 104.796 92.9852 106.243C93.0578 106.963 93.0731 107.692 93.1154 108.423C93.1177 109.156 93.1511 109.888 93.1187 110.633C93.089 112.116 92.9584 113.62 92.659 115.126C92.3596 116.632 91.9056 118.154 91.1343 119.591C90.9324 119.948 90.7489 120.312 90.4917 120.641C90.2531 120.983 90.0146 121.324 89.7202 121.629L89.2949 122.099C89.1404 122.244 88.9765 122.38 88.8129 122.52C88.6533 122.656 88.4815 122.806 88.334 122.923L87.9203 123.241C87.3722 123.671 86.8433 124.121 86.3333 124.588L85.9535 124.944L85.5097 125.34L85.0574 125.74C84.9017 125.867 84.7365 125.985 84.576 126.108C83.2874 127.078 81.8359 127.82 80.328 128.326C78.8203 128.836 77.2567 129.119 75.7082 129.236C72.602 129.467 69.5423 129.089 66.6212 128.404C63.6963 127.728 60.892 126.741 58.2016 125.604C54.4095 123.974 50.9759 122.066 47.8459 120.048C44.7197 118.02 41.8966 115.874 39.3868 113.63C36.8853 111.376 34.6716 109.04 32.9343 106.457C32.0825 105.152 31.3378 103.789 30.9004 102.241C30.6863 101.469 30.57 100.632 30.6294 99.7648C30.6759 98.9031 30.9722 97.9884 31.4816 97.259C31.9869 96.5343 32.6396 95.946 33.3122 95.5787C33.478 95.4693 33.6454 95.382 33.8137 95.308C33.9816 95.2295 34.1496 95.151 34.3176 95.0726C34.6513 94.9469 34.9856 94.8302 35.3164 94.727C36.6465 94.3493 38.0031 94.2233 39.2794 94.3475C41.8481 94.5727 44.0646 95.6764 45.7066 97.0871C45.9144 97.2594 46.1059 97.455 46.3007 97.6326C46.4866 97.8109 46.641 97.9825 46.8086 98.1531C47.1435 98.4899 47.4524 98.8375 47.7604 99.1718C48.3721 99.8406 48.9341 100.5 49.4588 101.135C50.5039 102.405 51.3923 103.597 52.1661 104.677C55.8023 109.8 58.5636 115.006 60.7321 120.129C62.879 125.263 64.4267 130.35 65.1414 135.419C65.4832 137.953 65.6289 140.482 65.408 142.984C65.2042 145.475 64.6217 147.958 63.4841 150.199C62.3598 152.439 60.6145 154.385 58.4972 155.654C57.4477 156.292 56.3311 156.797 55.1871 157.166C54.042 157.517 52.8773 157.781 51.7091 157.93C50.4261 158.091 49.2984 158.12 48.3441 158.085C47.8662 158.056 47.4294 158.042 47.0305 157.999C46.6358 157.951 46.2811 157.904 45.9664 157.855C44.714 157.627 44.114 157.38 44.1329 157.205C44.1512 157.022 44.7884 156.91 46.0245 156.842C46.6356 156.803 47.4019 156.759 48.3184 156.699C49.2302 156.635 50.2861 156.535 51.4737 156.345C52.556 156.176 53.6129 155.897 54.6386 155.554C55.6583 155.189 56.6304 154.717 57.5325 154.133C59.342 152.979 60.7766 151.296 61.7152 149.326C62.6627 147.357 63.1471 145.126 63.2887 142.825C63.448 140.523 63.2774 138.147 62.9139 135.748C62.1643 130.944 60.6208 126.044 58.5036 121.081C56.365 116.129 53.654 111.071 50.1373 106.131C49.4522 105.173 48.6521 104.1 47.7048 102.956C46.7626 101.821 45.6606 100.564 44.4113 99.3615C43.2401 98.2603 41.647 97.3576 39.8067 97.0549C38.889 96.9056 37.9176 96.8801 36.9525 97.0721C36.4688 97.1504 35.9858 97.3043 35.5222 97.479C35.2783 97.5539 35.0872 97.6829 34.8626 97.7787C34.7551 97.8307 34.6712 97.9032 34.5728 97.9591C34.4791 98.019 34.3719 98.0754 34.3016 98.1515C33.9418 98.4124 33.72 98.7392 33.5488 99.0892C33.5199 99.1846 33.4588 99.2645 33.4434 99.3634C33.4237 99.4627 33.3995 99.5622 33.3709 99.662C33.3551 99.8811 33.3165 100.093 33.3424 100.336C33.3319 100.568 33.3989 100.825 33.4298 101.077C33.5012 101.334 33.546 101.593 33.6537 101.862C33.8201 102.397 34.0893 102.939 34.3673 103.48C35.5602 105.656 37.376 107.77 39.4387 109.792C41.511 111.822 43.8837 113.76 46.4819 115.615C49.08 117.471 51.9114 119.225 54.9626 120.818C56.9479 121.857 58.9841 122.8 61.0562 123.62C63.124 124.441 65.2282 125.148 67.359 125.662C68.5045 125.951 69.6719 126.171 70.8526 126.329C72.034 126.495 73.2225 126.572 74.4133 126.556C76.7873 126.541 79.167 126.099 81.2515 125.059C82.2916 124.542 83.2593 123.878 84.1105 123.076C84.6027 122.61 85.1095 122.161 85.6355 121.733C85.8963 121.519 86.1619 121.309 86.4277 121.104L86.8334 120.799L87.1439 120.533C88.8116 119.131 89.7687 116.854 90.199 114.484C90.3314 113.897 90.3864 113.283 90.4732 112.681C90.5149 112.069 90.5882 111.464 90.5939 110.845C90.6548 109.618 90.6039 108.38 90.5444 107.148C90.3945 104.686 90.0418 102.251 89.6 99.8754C88.6986 95.126 87.4222 90.6119 86.0334 86.4615C83.2511 78.1566 80.0702 71.276 77.6297 66.5231C76.4048 64.1448 75.372 62.2867 74.6348 61.0306C74.2748 60.3976 73.979 59.9201 73.7872 59.5955C73.5911 59.2712 73.4902 59.1003 73.4902 59.1003C73.4902 59.1003 73.3347 58.8488 73.0437 58.3754C72.7523 57.8977 72.3165 57.1987 71.7387 56.314C70.579 54.5493 68.8704 51.9958 66.4156 49.2008C65.1851 47.8236 63.7531 46.3626 62.0367 45.2239C61.1843 44.6742 60.2405 44.2153 59.3334 44.092C58.4276 43.9863 57.6455 44.25 56.9559 44.9476C56.2856 45.6661 55.7186 46.7154 55.4261 47.8121C55.1342 48.9178 55.0803 50.118 55.2919 51.2996C55.3953 51.8884 55.5655 52.4769 55.8008 53.0431L55.986 53.466L56.2183 53.9257C56.3731 54.2306 56.5281 54.54 56.6832 54.8494C57.0019 55.4632 57.2908 56.0968 57.6401 56.7039C57.9809 57.3161 58.3265 57.9324 58.672 58.5487C60.1063 60.9969 61.6608 63.4456 63.4218 65.7954C64.2707 66.9947 65.2129 68.1297 66.1304 69.2931C66.6018 69.865 67.0945 70.4221 67.5744 70.989L68.3008 71.8366L69.0564 72.6555C73.0562 77.0637 77.546 81.0373 82.1431 84.5097C91.3753 91.4252 101.096 96.1049 108.59 98.6453C111.408 99.6314 114.097 100.373 116.633 100.961C117.9 101.268 119.138 101.484 120.333 101.711C120.931 101.812 121.52 101.891 122.1 101.979C122.68 102.072 123.249 102.139 123.809 102.193C128.293 102.707 132.169 102.552 135.409 102.005C138.652 101.445 141.23 100.406 143.196 99.192C145.165 97.9691 146.498 96.5505 147.422 95.1961C148.83 93.1362 149.601 90.7472 149.865 88.3448C150.132 85.9333 149.928 83.5191 149.525 81.1989C148.701 76.542 147.027 72.2514 145.165 68.2719C143.29 64.289 141.185 60.5845 138.966 57.0881C138.691 56.6493 138.42 56.2101 138.145 55.7757C137.861 55.3463 137.578 54.9169 137.295 54.4919C136.724 53.6423 136.175 52.7867 135.6 51.9507C134.422 50.2985 133.309 48.6284 132.099 47.0407L132.075 47.0156Z",
            fill: "var(--ds-text, #292A2E)"
        })))))))));
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "166.388",
            y: "13.1191",
            width: "160",
            height: "104",
            rx: "12",
            transform: "rotate(4 166.388 13.1191)",
            fill: "var(--ds-surface-raised, #FFFFFF)"
        });
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "173.81",
            y: "21.6577",
            width: "144",
            height: "88",
            rx: "12",
            transform: "rotate(4 173.81 21.6577)",
            fill: "var(--ds-surface-sunken, #F8F8F8)"
        });
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Cards_2",
            filter: "url(#filter1_dd_0_1)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip3_0_1)"
        }, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Frame 2117134038_2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip4_0_1)"
        }, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Gestural Line/scribble 8_2",
            opacity: "0.05"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Scribble 8_2",
            clipPath: "url(#clip5_0_1)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Group 6272481_2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Layer_1-2_2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            id: "Vector_2",
            d: "M287.09 53.8739C286.416 52.6392 285.862 51.5374 285.371 50.5958C284.881 49.6586 284.492 48.862 284.204 48.2147C283.623 46.9154 283.441 46.2044 283.613 46.0964C283.79 45.9886 284.324 46.493 285.187 47.6297C285.619 48.198 286.133 48.9234 286.725 49.8143C287.312 50.7048 287.944 51.7764 288.659 53.005C289.69 54.7361 290.622 56.5404 291.608 58.3395C292.087 59.2447 292.543 60.1706 293.016 61.0976C293.251 61.5588 293.485 62.0244 293.72 62.49C293.94 62.9635 294.165 63.4374 294.389 63.9156C296.205 67.712 297.873 71.7203 299.271 76.0344C300.651 80.3428 301.816 84.9788 302.031 90.0464C302.126 92.5704 301.999 95.2123 301.333 97.8699C300.676 100.519 299.409 103.188 297.405 105.383C296.87 106.035 296.217 106.537 295.619 107.073C295.312 107.327 294.973 107.535 294.659 107.762C294.337 107.98 294.031 108.216 293.691 108.384C293.025 108.746 292.385 109.124 291.713 109.375C291.383 109.512 291.054 109.649 290.733 109.787C290.401 109.893 290.073 109.994 289.75 110.101C287.15 110.902 284.705 111.14 282.482 111.185C278.018 111.233 274.382 110.507 271.086 109.672C267.793 108.81 264.824 107.762 261.743 106.474C258.662 105.178 255.466 103.638 251.813 101.559C245.645 98.0454 238.828 93.1878 232.524 87.2363C226.205 81.306 220.425 74.2748 216.044 66.959C213.849 63.3096 211.995 59.604 210.504 56.0038C210.149 55.0984 209.784 54.21 209.45 53.3282C209.138 52.4392 208.835 51.564 208.539 50.7071L208.428 50.3836L208.32 50.0202C208.244 49.7792 208.194 49.5355 208.14 49.2916C208.036 48.804 207.968 48.3144 207.931 47.827C207.861 46.8525 207.924 45.8874 208.099 44.97C208.46 43.1272 209.29 41.4863 210.438 40.2144L210.646 39.971L210.889 39.7434C211.055 39.5949 211.216 39.4505 211.382 39.3064C211.556 39.1718 211.756 39.0523 211.942 38.9275C212.129 38.8027 212.319 38.687 212.539 38.6045C212.75 38.5125 212.96 38.425 213.17 38.3462C213.392 38.2906 213.618 38.2441 213.839 38.2017C214.061 38.1461 214.279 38.1347 214.497 38.1366C214.715 38.134 214.934 38.1226 215.142 38.1416C215.967 38.2393 216.712 38.4604 217.313 38.7605C217.619 38.9064 217.92 39.052 218.166 39.2248C218.421 39.3895 218.691 39.5417 218.901 39.7166C219.12 39.8876 219.336 40.0538 219.543 40.2106C219.731 40.3795 219.915 40.5436 220.091 40.7026C220.452 41.0125 220.728 41.3254 221.002 41.6025C222.257 42.9267 223.299 44.3651 224.246 45.8412C225.092 47.159 226.213 49.0743 227.437 51.5394C228.656 54.0042 229.993 57.0198 231.323 60.5153C232.654 64.0107 233.999 67.9832 235.237 72.3573C236.479 76.7317 237.635 81.5048 238.546 86.6033C239.448 91.7012 240.154 97.1233 240.238 102.791C240.246 104.21 240.239 105.638 240.138 107.085C240.11 107.808 240.023 108.531 239.964 109.261C239.864 109.988 239.795 110.717 239.659 111.45C239.423 112.915 239.085 114.386 238.579 115.836C238.073 117.286 237.411 118.73 236.447 120.045C236.198 120.37 235.965 120.706 235.665 120.996C235.381 121.301 235.097 121.606 234.763 121.867L234.277 122.273C234.104 122.394 233.923 122.506 233.741 122.623C233.564 122.735 233.373 122.859 233.211 122.955L232.757 123.212C232.154 123.561 231.568 123.934 230.998 124.326L230.572 124.625L230.078 124.955L229.574 125.289C229.402 125.393 229.222 125.487 229.046 125.586C227.635 126.368 226.094 126.9 224.531 127.191C222.967 127.487 221.379 127.549 219.829 127.45C216.721 127.246 213.744 126.446 210.946 125.361C208.144 124.284 205.504 122.916 202.999 121.416C199.47 119.274 196.335 116.907 193.517 114.473C190.703 112.03 188.206 109.511 186.033 106.94C183.87 104.36 182.003 101.739 180.642 98.9395C179.98 97.5278 179.432 96.0751 179.214 94.481C179.11 93.6864 179.111 92.8415 179.291 91.9912C179.457 91.1444 179.877 90.2798 180.483 89.6283C181.085 88.981 181.813 88.4893 182.53 88.2192C182.709 88.1339 182.887 88.0707 183.064 88.0208C183.241 87.9665 183.419 87.9122 183.596 87.8579C183.944 87.7799 184.291 87.7108 184.633 87.6547C186.003 87.4658 187.364 87.5298 188.61 87.8305C191.123 88.4109 193.164 89.8123 194.594 91.4379C194.776 91.6374 194.938 91.8578 195.106 92.0608C195.266 92.2632 195.394 92.4545 195.537 92.6468C195.821 93.027 196.079 93.4142 196.338 93.7881C196.85 94.5355 197.315 95.2663 197.746 95.9681C198.604 97.3713 199.318 98.6755 199.934 99.8527C202.822 105.432 204.832 110.972 206.266 116.347C207.678 121.73 208.502 126.982 208.505 132.102C208.491 134.658 208.283 137.183 207.716 139.63C207.167 142.069 206.245 144.446 204.807 146.507C203.381 148.569 201.382 150.253 199.109 151.215C197.981 151.701 196.805 152.045 195.621 152.252C194.438 152.44 193.248 152.539 192.07 152.524C190.777 152.504 189.656 152.377 188.716 152.209C188.247 152.114 187.817 152.039 187.428 151.941C187.043 151.839 186.699 151.743 186.394 151.651C185.185 151.251 184.626 150.922 184.669 150.752C184.712 150.573 185.359 150.551 186.592 150.655C187.203 150.702 187.968 150.765 188.884 150.833C189.796 150.897 190.855 150.944 192.058 150.922C193.153 150.905 194.238 150.776 195.302 150.579C196.362 150.36 197.391 150.027 198.365 149.575C200.318 148.684 201.973 147.216 203.176 145.397C204.389 143.578 205.179 141.436 205.639 139.178C206.117 136.921 206.279 134.543 206.253 132.118C206.179 127.256 205.333 122.188 203.927 116.98C202.498 111.778 200.518 106.392 197.723 101.01C197.177 99.9668 196.535 98.7922 195.756 97.5279C194.981 96.2728 194.064 94.8745 192.995 93.5098C191.988 92.2564 190.536 91.1408 188.756 90.5849C187.868 90.3093 186.909 90.1489 185.927 90.2047C185.437 90.2149 184.937 90.3001 184.454 90.4086C184.202 90.4488 183.995 90.5499 183.759 90.6135C183.645 90.65 183.552 90.7102 183.447 90.7518C183.346 90.7981 183.232 90.839 183.152 90.9046C182.759 91.1129 182.494 91.4057 182.276 91.7284C182.234 91.8189 182.162 91.8895 182.133 91.9853C182.1 92.0808 182.062 92.1761 182.02 92.2709C181.974 92.4857 181.906 92.69 181.898 92.934C181.855 93.1623 181.886 93.4269 181.881 93.6801C181.916 93.9449 181.924 94.2079 181.994 94.4885C182.084 95.0419 182.275 95.6157 182.475 96.1901C183.354 98.5109 184.857 100.858 186.619 103.147C188.388 105.446 190.468 107.695 192.783 109.894C195.098 112.093 197.657 114.224 200.457 116.226C202.278 117.532 204.164 118.749 206.101 119.849C208.035 120.95 210.02 121.942 212.059 122.748C213.153 123.193 214.278 123.574 215.425 123.895C216.572 124.224 217.738 124.466 218.92 124.615C221.273 124.931 223.691 124.824 225.9 124.085C227.002 123.717 228.052 123.194 229.007 122.518C229.559 122.126 230.124 121.751 230.704 121.401C230.992 121.225 231.284 121.054 231.576 120.888L232.02 120.643L232.365 120.423C234.211 119.266 235.476 117.144 236.232 114.858C236.445 114.294 236.585 113.695 236.754 113.111C236.881 112.51 237.038 111.921 237.13 111.309C237.361 110.102 237.482 108.87 237.595 107.641C237.789 105.182 237.779 102.721 237.672 100.308C237.44 95.4792 236.805 90.8314 236.007 86.5281C234.408 77.9167 232.215 70.6605 230.46 65.6142C229.578 63.0885 228.814 61.1048 228.259 59.7583C227.99 59.0813 227.764 58.5673 227.619 58.2192C227.47 57.8707 227.394 57.6875 227.394 57.6875C227.394 57.6875 227.275 57.4168 227.052 56.9075C226.83 56.3939 226.496 55.6411 226.047 54.6845C225.144 52.7756 223.808 50.0091 221.766 46.8997C220.739 45.3646 219.524 43.7186 217.983 42.3521C217.215 41.6891 216.345 41.1034 215.464 40.855C214.581 40.6243 213.77 40.7766 212.99 41.3714C212.226 41.9896 211.519 42.9497 211.076 43.9951C210.634 45.0494 210.413 46.2304 210.458 47.43C210.479 48.0274 210.565 48.6339 210.719 49.2273L210.844 49.6719L211.01 50.1594C211.121 50.483 211.231 50.8109 211.342 51.1389C211.572 51.791 211.77 52.4586 212.031 53.1085C212.284 53.7621 212.54 54.4205 212.797 55.0789C213.876 57.7029 215.075 60.3442 216.492 62.9162C217.165 64.222 217.94 65.477 218.687 66.7568C219.074 67.3888 219.485 68.009 219.881 68.6371L220.482 69.5776L221.117 70.4937C224.464 75.4156 228.357 79.9754 232.426 84.0538C240.606 92.1869 249.581 98.1739 256.648 101.733C259.301 103.101 261.861 104.21 264.291 105.145C265.503 105.625 266.699 106.011 267.85 106.403C268.429 106.586 269 106.746 269.562 106.914C270.124 107.087 270.679 107.233 271.225 107.364C275.594 108.497 279.454 108.882 282.739 108.792C286.028 108.688 288.726 108.019 290.841 107.09C292.961 106.153 294.479 104.934 295.582 103.721C297.263 101.877 298.36 99.619 298.955 97.2767C299.555 94.9258 299.689 92.5067 299.613 90.153C299.446 85.4268 298.385 80.9449 297.095 76.7451C295.792 72.5399 294.223 68.5785 292.512 64.8073C292.301 64.3344 292.094 63.8618 291.882 63.3934C291.661 62.9287 291.44 62.464 291.219 62.0038C290.771 61.083 290.347 60.1593 289.894 59.2515C288.957 57.4514 288.087 55.6426 287.111 53.902L287.09 53.8739Z",
            fill: "var(--ds-text, #292A2E)"
        })))))))));
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "81.5081",
            y: "8",
            width: "160",
            height: "104",
            rx: "12",
            fill: "var(--ds-surface-raised, #FFFFFF)"
        });
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "89.5081",
            y: "16",
            width: "144",
            height: "88",
            rx: "12",
            fill: "var(--ds-surface-sunken, #F8F8F8)"
        });
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Card Stacks"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Property 1=Generic"
        }, t4, t7, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Cards_3",
            filter: "url(#filter2_dd_0_1)"
        }, t8, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Frame 2117134038_3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip6_0_1)"
        }, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Gestural Line/scribble 11",
            opacity: "0.04"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Scribble 11",
            clipPath: "url(#clip7_0_1)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Group 6272481_3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "Layer_1-2_3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            id: "Vector_3",
            d: "M269.793 65.9643C270.361 65.8064 270.817 65.5432 271.203 65.3384C271.595 65.1337 271.882 64.8822 272.098 64.6658C272.531 64.2271 272.659 63.8762 272.537 63.6305C272.414 63.3848 272.039 63.262 271.478 63.2854C270.916 63.3205 270.144 63.4433 269.15 63.6831C267.734 64.0224 266.255 64.1628 264.716 64.1628C263.178 64.1686 261.581 64.0399 259.902 63.8235C256.551 63.3848 252.913 62.525 248.655 61.788C243.811 60.9984 240.542 61.0569 237.769 61.5073C237.424 61.5657 237.085 61.6476 236.746 61.7178C236.406 61.7822 236.079 61.864 235.751 61.9635C235.424 62.0571 235.096 62.1507 234.769 62.2501C234.447 62.3729 234.125 62.4899 233.792 62.6186C232.493 63.145 231.125 63.7943 229.697 64.8413C229.551 64.9407 229.411 65.046 229.265 65.1513C229.13 65.2683 228.99 65.3852 228.849 65.5022C228.569 65.7362 228.288 65.976 227.995 66.2217C227.726 66.4907 227.457 66.7598 227.182 67.0405C227.036 67.1926 226.884 67.3389 226.732 67.4909L226.504 67.8009C226.475 67.8477 226.439 67.8887 226.404 67.9238C226.147 68.2572 225.673 68.3742 225.632 68.3274C225.632 68.304 225.609 68.3917 225.603 68.4034C225.603 68.4151 225.58 68.4443 225.574 68.4502L225.58 68.4443C225.562 68.4677 225.615 68.4034 225.65 68.3858C225.697 68.3625 225.691 68.3508 225.685 68.3449C225.667 68.2981 225.644 68.0817 225.685 67.8068V67.76L225.697 67.7073C225.796 66.4439 225.86 65.1337 225.79 63.765C225.685 62.3963 225.591 60.9516 224.679 59.3782C224.234 58.6002 223.328 57.8223 222.316 57.5532C221.316 57.2842 220.409 57.3895 219.66 57.5591C218.157 57.9276 217.017 58.5476 215.94 59.1325C213.829 60.3374 212.115 61.5599 210.676 62.525C209.249 63.496 208.132 64.233 207.43 64.6716C206.897 65.005 206.365 65.3443 205.827 65.6777C205.359 65.9643 204.687 66.3796 203.856 66.7656C203.446 66.9645 202.996 67.14 202.546 67.2628C202.107 67.3915 201.639 67.4383 201.382 67.3915C201.382 67.4032 201.294 67.3915 201.294 67.3506V67.3155C201.282 67.2277 201.282 66.9938 201.288 66.83C201.294 66.4673 201.323 66.0696 201.358 65.6601C201.434 64.8296 201.557 63.9346 201.662 62.9461C201.756 61.9518 201.867 60.8872 201.727 59.5946C201.639 58.9453 201.481 58.2083 201.042 57.4479C200.621 56.6876 199.838 55.9974 199.042 55.6815C198.252 55.3481 197.492 55.2545 196.808 55.2311C196.123 55.2253 195.486 55.2838 194.872 55.3832C194.573 55.4417 194.257 55.4826 193.965 55.5528L193.526 55.6581L193.322 55.7049L192.509 55.7751C192.181 55.8043 191.859 55.8336 191.538 55.9213C190.9 56.0617 190.251 56.2021 189.654 56.4536C189.35 56.5706 189.034 56.67 188.748 56.8104L187.882 57.2432C185.589 58.4364 183.77 60.1327 182.074 61.7588C180.383 63.4024 178.845 65.0635 177.248 66.3679C176.692 66.8241 176.143 67.2394 175.599 67.5494L175.4 67.6723L175.3 67.7366L175.265 67.7541C175.224 67.7775 175.183 67.7834 175.148 67.7951C175.072 67.8126 174.99 67.8126 174.908 67.7892C174.745 67.7424 174.61 67.6255 174.54 67.4675C174.4 67.1517 174.265 66.8475 174.131 66.5375C174.055 66.3679 173.984 66.2041 173.908 66.0345C173.821 65.8707 173.727 65.7069 173.639 65.5432C172.967 64.2505 172.048 63.0339 170.814 62.139C169.592 61.2323 168.047 60.7995 166.714 60.8288C165.351 60.8229 164.263 61.2265 163.286 61.5833C162.83 61.7997 162.368 61.9927 161.97 62.2208C161.578 62.449 161.192 62.6654 160.841 62.8877C160.157 63.3497 159.537 63.7767 159.022 64.2037C158.478 64.6132 158.04 65.0167 157.63 65.3735L157.466 65.5198C157.449 65.5373 157.443 65.5315 157.39 65.5549L157.069 65.6952L156.735 65.8005C156.291 65.9526 155.829 66.0345 155.366 66.0988C154.431 66.2158 153.466 66.1866 152.5 66.0696C150.564 65.8298 148.652 65.3033 146.762 64.8179C144.867 64.3324 142.984 63.8469 141.024 63.648C140.048 63.5486 139.047 63.5194 138.053 63.6071C137.053 63.6948 136.053 63.9288 135.111 64.3031C134.59 64.4962 134.175 64.7711 133.836 65.005C133.514 65.2741 133.257 65.5022 133.093 65.7362C132.765 66.2041 132.713 66.5375 132.859 66.7247C133.005 66.9119 133.356 66.9587 133.836 66.8475C134.076 66.789 134.374 66.7364 134.684 66.6253C135.017 66.5434 135.374 66.403 135.801 66.3036C137.328 65.859 138.977 65.9234 140.662 66.2334C142.352 66.5375 144.089 67.099 145.944 67.6781C147.804 68.2513 149.786 68.9006 152.079 69.2457C153.22 69.4095 154.454 69.4855 155.747 69.3451C156.39 69.2691 157.051 69.1521 157.706 68.9415L158.197 68.7894L158.677 68.5906L159.01 68.4502C159.127 68.4034 159.256 68.3625 159.344 68.263L159.824 67.8419C160.163 67.5494 160.543 67.2043 160.999 66.8826C161.221 66.7188 161.461 66.5434 161.707 66.3562C161.964 66.1924 162.228 66.0228 162.508 65.8415C162.783 65.6484 163.087 65.5139 163.392 65.3443C163.696 65.163 164.023 65.0401 164.351 64.8998C165.012 64.619 165.725 64.4435 166.41 64.3967C167.106 64.3324 167.714 64.5079 168.299 64.8471C168.872 65.2039 169.457 65.7654 169.948 66.596C170.089 66.7773 170.182 67.0288 170.305 67.2453C170.422 67.4734 170.551 67.684 170.644 67.9472C170.75 68.1987 170.849 68.4502 170.96 68.7017C170.99 68.766 171.124 69.1053 171.253 69.3451C171.387 69.6025 171.551 69.8423 171.738 70.0704C172.487 70.9829 173.633 71.5853 174.885 71.6438C175.505 71.6731 176.149 71.5619 176.733 71.3221C176.874 71.2578 177.032 71.1876 177.149 71.1233L177.406 70.9712L177.927 70.6553C179.711 69.5264 181.056 68.146 182.296 66.8183C183.63 65.3735 184.922 63.9054 186.332 62.6244C187.73 61.3376 189.245 60.2438 190.871 59.6297C191.269 59.4484 191.69 59.3606 192.099 59.2553C192.509 59.1208 192.936 59.1266 193.351 59.0682L193.883 59.0155C193.936 59.0155 193.988 58.9921 194.041 58.9804L194.176 58.9512L194.339 58.9102C194.556 58.8634 194.778 58.7932 194.994 58.7582C195.427 58.6704 195.843 58.6119 196.24 58.5768C197.024 58.5183 197.708 58.6412 197.942 58.8459C198.071 58.9453 198.171 59.0682 198.264 59.2904C198.358 59.5068 198.422 59.8168 198.451 60.1561C198.516 60.8346 198.451 61.6125 198.381 62.3671C198.299 63.1275 198.194 63.882 198.106 64.619C198.018 65.356 197.942 66.0696 197.919 66.7715C197.919 66.947 197.907 67.1166 197.907 67.2921C197.907 67.409 197.907 67.526 197.907 67.643C197.907 67.7717 197.925 67.8945 197.937 68.0174C197.966 68.263 197.972 68.5087 198.018 68.731C198.065 68.9532 198.118 69.1696 198.165 69.3861C198.504 69.6727 198.832 69.93 199.159 70.1523C199.504 70.3512 199.838 70.5266 200.177 70.6319C200.92 70.8659 201.364 70.86 201.756 70.8659C202.148 70.8659 202.423 70.8249 202.616 70.8015C202.803 70.7782 202.897 70.7548 202.897 70.7548C204.493 70.4331 205.774 69.7779 206.997 69.0994C208.208 68.4092 209.337 67.6547 210.43 66.8943C212.624 65.3677 214.706 63.7592 216.841 62.3963C217.9 61.7237 218.994 61.1037 220.017 60.7527C220.526 60.5772 221.006 60.5012 221.327 60.5363C221.491 60.5538 221.608 60.5831 221.702 60.6474C221.801 60.6942 221.895 60.782 222 60.9106C222.205 61.168 222.404 61.6184 222.532 62.1331C222.667 62.6478 222.755 63.2269 222.795 63.8235C222.895 65.0167 222.866 66.2802 222.784 67.5436L222.795 67.4324C222.731 68.0583 222.696 68.7836 223.065 69.6083C223.158 69.813 223.269 70.0119 223.433 70.1991C223.573 70.3921 223.766 70.5559 223.965 70.708C224.158 70.8717 224.386 70.9536 224.609 71.0589C224.831 71.135 225.059 71.1934 225.281 71.2227C226.17 71.3221 226.925 71.0589 227.533 70.6963C227.843 70.5149 228.107 70.2927 228.352 70.0529L228.691 69.6785C228.785 69.5557 228.914 69.3568 228.896 69.3861L229.697 68.5672C229.978 68.2513 230.317 68.0174 230.622 67.7424C230.926 67.4617 231.265 67.2277 231.604 66.9996L232.107 66.6428L232.64 66.3386C234.5 65.2741 236.336 64.7769 237.986 64.543C239.641 64.3148 241.115 64.3324 242.39 64.385C244.946 64.5254 246.736 64.8413 248.099 65.0577C252.223 65.7537 255.966 66.5551 259.557 66.8651C261.353 67.023 263.108 67.0639 264.816 66.9411C266.524 66.8241 268.202 66.5258 269.782 65.9877L269.793 65.9643Z",
            fill: "var(--ds-text, #292A2E)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            id: "Vector_4",
            d: "M105.268 47.7969C105.14 47.6741 105.023 47.5746 104.9 47.405C104.765 47.2471 104.648 47.0774 104.508 46.9488C104.257 46.6739 103.97 46.5159 103.701 46.5335C103.432 46.551 103.174 46.7499 103.017 47.1886C102.952 47.4167 102.9 47.6916 102.946 48.0601C102.976 48.411 103.157 48.9316 103.508 49.382C104.011 50.0313 104.812 50.4641 105.649 50.5694C106.456 50.6747 107.093 50.5869 107.713 50.4582C108.93 50.1892 109.989 49.7447 111.042 49.2709C111.55 49.0311 112.065 48.7854 112.592 48.5397C112.843 48.4227 113.095 48.3058 113.346 48.1829L113.709 48.025L113.884 47.9548C113.931 47.9373 113.896 47.9548 113.919 47.9431H113.978L114.153 47.9139L114.534 47.8554C114.762 47.8554 115.031 47.8027 115.224 47.832C115.674 47.832 115.972 47.9314 116.06 48.0192C116.124 48.0601 116.189 48.1244 116.277 48.2473C116.358 48.3935 116.452 48.5748 116.54 48.8263C116.628 49.0603 116.709 49.3411 116.844 49.733C116.92 49.9377 117.025 50.2067 117.125 50.429C117.253 50.6396 117.341 50.8735 117.499 51.0432L117.71 51.3122C117.786 51.3941 117.873 51.4643 117.955 51.5403C118.107 51.6983 118.3 51.8036 118.482 51.9147C118.669 52.0083 118.868 52.0726 119.061 52.1311C119.26 52.1604 119.459 52.1954 119.652 52.2247C120.049 52.2247 120.429 52.2071 120.798 52.0902C120.973 52.0434 121.178 52.0083 121.324 51.9556C121.453 51.903 121.588 51.8503 121.716 51.7977C122.699 51.3766 123.342 50.9554 124.085 50.4875C124.448 50.2594 124.822 50.0196 125.202 49.7622C125.594 49.5107 125.998 49.2416 126.437 48.9492C127.179 48.452 127.963 47.9022 128.788 47.3231C129.595 46.744 130.443 46.1416 131.303 45.5216C131.362 45.4806 131.438 45.4338 131.508 45.4455H131.555L131.718 45.428C131.835 45.4104 131.941 45.4163 132.052 45.4163C132.274 45.4104 132.49 45.4046 132.683 45.4338C132.894 45.4397 133.075 45.4923 133.251 45.5274C133.953 45.7204 134.356 46.0714 134.813 46.7616C135.041 47.1067 135.257 47.5161 135.526 47.9899C135.795 48.4578 136.117 48.996 136.632 49.5224C137.135 50.0547 137.901 50.5109 138.655 50.6864C139.006 50.7507 139.392 50.8209 139.697 50.8033C139.854 50.8033 140.018 50.8033 140.17 50.7975C140.311 50.78 140.451 50.7624 140.591 50.7449C141.679 50.5811 142.475 50.2886 143.112 50.0313C143.762 49.7797 144.23 49.5341 144.586 49.3703C144.996 49.1656 145.376 48.9375 145.762 48.7035C146.423 48.2648 147.64 47.4635 149.131 46.3229C149.225 46.2527 149.318 46.1825 149.418 46.1065C149.418 46.1065 149.418 46.1065 149.418 46.0948C149.558 46.0421 149.71 45.9837 149.857 45.9252C150.219 45.7965 150.594 45.7146 150.845 45.697C150.927 45.6736 150.95 45.7087 151.003 45.7029C151.044 45.7087 151.102 45.6912 151.12 45.7146C151.143 45.7321 151.178 45.7204 151.214 45.738C151.243 45.7672 151.278 45.7848 151.319 45.7965C151.5 45.9193 151.804 46.2937 152.208 46.8318C152.617 47.3582 153.167 48.0542 153.992 48.6275C154.208 48.7561 154.431 48.8848 154.653 49.0077C154.881 49.1246 155.121 49.1948 155.361 49.2826C155.6 49.3762 155.84 49.423 156.08 49.458L156.56 49.5341L156.805 49.575C156.846 49.575 156.887 49.5926 156.922 49.5926L157.039 49.5692C157.788 49.4054 158.543 49.2358 159.309 49.0662C159.63 48.9843 159.964 48.9316 160.303 48.8907C160.642 48.8439 160.976 48.7971 161.315 48.7503C164.041 48.4052 166.907 48.3175 169.691 48.4461C173.622 48.5514 176.862 48.7971 179.43 48.9316C182.003 49.0779 183.922 49.1422 185.238 49.1714C188.35 49.2358 191.105 49.0603 193.632 48.7328C194.263 48.645 194.883 48.5163 195.486 48.4052C196.088 48.2824 196.685 48.2005 197.264 48.0192C198.422 47.6799 199.557 47.4225 200.639 46.9546C203.049 46.0129 202.382 44.4336 200.054 44.925C198.995 45.194 197.89 45.2759 196.784 45.4572C196.234 45.5567 195.661 45.5742 195.082 45.6327C194.503 45.6795 193.924 45.7497 193.327 45.7848C190.923 45.9018 188.321 45.9661 185.308 45.8901C184.133 45.8608 182.337 45.6853 179.95 45.4221C177.564 45.1706 174.604 44.808 171.048 44.6383C169.896 44.574 168.72 44.6091 167.568 44.6617C166.942 44.7085 166.304 44.7612 165.655 44.8138C165.333 44.8372 165.006 44.8606 164.684 44.884C164.357 44.9191 164.029 44.96 163.696 45.001C163.035 45.0829 162.374 45.1355 161.713 45.235C161.052 45.3461 160.391 45.4572 159.73 45.5684C159.069 45.6561 158.426 45.8491 157.782 45.9953C157.472 46.0714 157.162 46.1416 156.858 46.2176C156.858 46.2176 156.864 46.2176 156.87 46.2176H156.84C156.84 46.2176 156.805 46.2352 156.782 46.2293L156.624 46.2059C156.25 46.124 155.957 46.0187 155.676 45.7672C155.384 45.5333 155.109 45.1999 154.776 44.7553C154.431 44.3225 154.097 43.8136 153.512 43.3223C153.389 43.1995 153.214 43.0942 153.056 42.9889C152.886 42.8895 152.74 42.7725 152.553 42.7081C152.372 42.6379 152.19 42.5677 152.009 42.5093C151.828 42.4449 151.658 42.4391 151.483 42.4098C151.313 42.3864 151.132 42.3572 150.974 42.3572C150.822 42.363 150.67 42.3747 150.523 42.3806C150.377 42.3923 150.231 42.404 150.09 42.4098C149.956 42.4274 149.839 42.4625 149.716 42.4859C149.476 42.5444 149.242 42.597 149.02 42.6496C148.821 42.7198 148.628 42.7842 148.447 42.8485C148.219 42.9304 148.002 43.0064 147.798 43.0825C147.616 43.2112 147.441 43.334 147.283 43.4451C147.072 43.5913 146.891 43.72 146.745 43.8253C146.452 44.03 146.294 44.1412 146.294 44.1412C146.294 44.1412 146.055 44.3049 145.628 44.5974C145.201 44.8957 144.581 45.2993 143.809 45.7789C143.036 46.241 142.101 46.7733 141.1 47.1593C140.603 47.364 140.088 47.481 139.691 47.5044L139.544 47.5161C139.504 47.5103 139.468 47.4986 139.427 47.4986C139.34 47.4986 139.287 47.4693 139.223 47.4576C139.106 47.4108 139.006 47.364 138.866 47.2237C138.585 46.978 138.246 46.3989 137.842 45.738C137.445 45.0829 136.895 44.2757 136.082 43.6381C135.275 42.983 134.222 42.6087 133.286 42.5093C132.824 42.4683 132.356 42.4391 131.923 42.48C131.707 42.4917 131.484 42.4976 131.28 42.5327C130.981 42.5736 130.683 42.6145 130.391 42.6555C130.221 42.6438 130.11 42.7666 129.987 42.8602L129.613 43.141L129.139 43.4978C128.858 43.7083 128.583 43.9189 128.314 44.1236C127.764 44.5272 127.238 44.9191 126.729 45.2935C125.705 46.0246 124.764 46.6797 123.956 47.2003C122.757 47.9841 121.629 48.6275 120.804 48.9492C120.716 48.9843 120.622 49.0135 120.541 49.0486C120.476 49.072 120.459 49.072 120.424 49.0837C120.353 49.1012 120.283 49.1071 120.219 49.1012C120.084 49.0954 119.979 48.996 119.932 48.8965C119.909 48.8439 119.885 48.7912 119.874 48.7444C119.833 48.6158 119.798 48.4871 119.763 48.3701C119.663 48.025 119.54 47.6331 119.394 47.2705C119.108 46.5335 118.581 45.7965 117.967 45.3812C117.745 45.2174 117.499 45.1004 117.265 44.9776C117.031 44.8899 116.791 44.808 116.557 44.7378C116.335 44.6968 116.107 44.6559 115.885 44.6266C115.668 44.6033 115.469 44.6091 115.265 44.5974C114.844 44.574 114.498 44.6442 114.118 44.6676C113.943 44.6968 113.773 44.7319 113.598 44.7612L113.329 44.808C113.217 44.8314 113.095 44.8431 112.966 44.884L112.615 45.0302L112.381 45.1355L111.942 45.3461C111.673 45.4865 111.404 45.6327 111.141 45.7731C110.638 46.048 110.147 46.3171 109.667 46.5803C108.725 47.0891 107.83 47.5454 107 47.8203C106.596 47.9548 106.181 48.0367 105.918 48.0367C105.672 48.0601 105.444 47.9782 105.251 47.8203L105.268 47.7969Z",
            fill: "var(--ds-text, #292A2E)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            id: "Vector_5",
            d: "M208.916 43.9482C208.758 43.9014 208.605 43.8955 208.459 43.9072C208.313 43.9072 208.173 43.9306 208.038 43.9716C207.769 44.0593 207.523 44.2231 207.365 44.4395C207.208 44.6559 207.143 44.9367 207.237 45.2525C207.284 45.4046 207.371 45.5801 207.506 45.7322C207.652 45.8784 207.839 46.0246 208.079 46.1533C208.769 46.475 209.541 46.6973 210.313 46.7441C211.086 46.7908 211.863 46.7324 212.606 46.5744C214.104 46.2703 215.519 45.6678 216.976 44.9893C218.59 44.1646 219.479 43.644 220.263 43.2814C220.649 43.1117 221.006 42.9655 221.363 42.8953C221.731 42.8076 222.082 42.8134 222.433 42.9187C222.749 43.0006 223.047 43.1702 223.34 43.5153C223.416 43.5855 223.486 43.6849 223.556 43.7902C223.626 43.8955 223.708 43.9774 223.767 44.1119C223.831 44.2348 223.895 44.3576 223.965 44.4863C224.047 44.6793 224.135 44.8782 224.223 45.077C224.498 45.7965 224.983 46.3931 225.667 46.7441C226.334 47.095 227.141 47.1827 227.878 46.9897C228.247 46.8903 228.598 46.7324 228.931 46.5101L229.195 46.3463L229.323 46.2644L229.388 46.2293L229.645 46.0773C229.972 45.8667 230.323 45.7146 230.651 45.5567C231.961 44.9542 233.096 44.6793 233.628 44.5916C233.845 44.5565 234.055 44.5038 234.26 44.4336C234.64 44.3401 235.336 44.1412 236.301 44.0067C237.272 43.8838 238.501 43.7902 239.916 43.8721C242.741 44.0008 246.216 44.7553 249.462 45.621C254.077 46.7674 257.124 47.2997 258.727 47.4518C260.622 47.6565 262.342 47.6448 263.909 47.4226C265.483 47.1944 266.898 46.7558 268.202 46.1474C269.647 45.4163 268.893 43.878 267.553 44.1412C265.044 44.5389 262.541 44.5916 259.095 44.188C257.738 44.0534 255.059 43.1293 251.082 42.053C250.427 41.8834 249.766 41.7547 249.093 41.667C247.637 41.4857 246.075 41.2342 244.525 41.0177C242.975 40.8013 241.443 40.6317 240.08 40.5498C238.717 40.4679 237.518 40.4913 236.67 40.5381C236.243 40.5498 235.903 40.5966 235.675 40.62C235.441 40.6434 235.319 40.6551 235.319 40.6551C233.283 40.9125 231.248 41.5266 229.417 42.5151C228.972 42.7783 228.504 43.0123 228.077 43.3106L227.504 43.7083C227.469 43.7317 227.405 43.7785 227.352 43.8078C227.118 43.9423 226.808 43.7844 226.75 43.527L226.691 43.3983C226.638 43.2989 226.603 43.1995 226.545 43.1L226.188 42.5034C225.919 42.1115 225.632 41.7138 225.24 41.357C224.503 40.6258 223.392 40.1053 222.339 40.0234C221.099 39.9122 220.193 40.1813 219.45 40.3919C218.719 40.6258 218.134 40.8598 217.654 41.0762C216.683 41.5032 216.069 41.8074 215.589 42.0296C212.758 43.4042 210.74 44.3284 208.933 43.9482H208.916Z",
            fill: "var(--ds-text, #292A2E)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            id: "Vector_6",
            d: "M105.508 86.5768C103.356 88.665 104.701 90.0922 107.012 88.4076C108.673 87.2319 110.398 86.0796 112.311 85.0209C113.27 84.4945 114.276 83.9973 115.341 83.5879C116.399 83.1843 117.534 82.8626 118.634 82.8158C119.886 82.7281 120.704 83.0088 121.313 83.3949C121.921 83.7868 122.336 84.3307 122.635 84.9098C122.933 85.4947 123.103 86.1323 123.149 86.8166C123.196 87.4893 123.097 88.2731 122.763 88.8872C122.681 89.0159 122.635 89.0978 122.582 89.1504C122.529 89.2089 122.465 89.2616 122.389 89.2967C122.243 89.3727 122.056 89.3727 121.898 89.3025C121.775 89.2674 121.383 89.0101 121.155 88.7586C120.909 88.5012 120.699 88.197 120.57 87.8519C120.313 87.1617 120.313 86.3312 120.605 85.6234C120.751 85.2725 120.956 84.9508 121.207 84.6758L121.406 84.477L121.693 84.2255C121.886 84.0617 122.073 83.8979 122.26 83.7341C123.781 82.4356 125.372 81.7981 126.565 81.7162C127.776 81.6635 128.741 82.0554 129.297 82.2952C129.461 82.3713 129.624 82.4415 129.794 82.5175C129.964 82.6052 130.139 82.6871 130.315 82.7632C130.946 83.0439 132.104 83.6815 133.766 84.6875C134.602 85.1847 135.573 85.7579 136.708 86.3195C137.842 86.881 139.176 87.4191 140.691 87.7291C142.2 88.0391 143.896 88.0742 145.528 87.7525C147.166 87.4366 148.745 86.8225 150.19 86.0328C150.553 85.8398 150.892 85.6176 151.249 85.407C151.6 85.1964 151.951 84.98 152.272 84.7402L153.173 84.1026C153.173 84.1026 153.191 84.0909 153.202 84.0851L153.319 84.0441C153.46 83.9856 153.594 83.9447 153.723 83.9155C154.255 83.7692 154.67 83.7751 154.881 83.8628C154.992 83.9038 155.092 83.9798 155.209 84.0792C155.326 84.2138 155.46 84.36 155.583 84.5881C155.77 84.8923 155.946 85.2725 156.104 85.6702L156.221 85.9802C156.267 86.103 156.349 86.3195 156.425 86.4774C156.583 86.8166 156.782 87.1325 157.004 87.4191C157.449 87.9982 158.004 88.4544 158.607 88.7878C158.911 88.9516 159.221 89.092 159.537 89.1855C159.695 89.2382 159.859 89.2791 160.017 89.3142C160.175 89.3435 160.362 89.3786 160.444 89.3903C162.163 89.6476 163.702 89.8348 165.059 89.9693C167.778 90.2442 169.791 90.3144 171.177 90.3671C174.446 90.4431 177.33 90.2676 179.974 89.8406C182.618 89.4078 185.045 88.7293 187.285 87.6063C187.595 87.4659 187.847 87.2904 188.052 87.1091C188.256 86.9336 188.408 86.764 188.514 86.6002C188.724 86.2785 188.753 85.9978 188.636 85.7872C188.52 85.5825 188.256 85.4479 187.888 85.4187C187.706 85.4011 187.496 85.4187 187.262 85.4596C187.034 85.5064 186.776 85.5825 186.472 85.6585C184.343 86.3312 182.085 86.6821 179.605 86.8985C177.12 87.1091 174.394 87.1676 171.27 87.0857C170.054 87.0389 168.182 86.8576 165.737 86.4891C164.515 86.2961 163.152 86.0855 161.66 85.8047C160.724 85.6527 160.596 85.6059 160.28 85.3602C160.145 85.2491 160.028 85.1087 159.946 84.9625C159.905 84.8864 159.87 84.8045 159.841 84.7226C159.765 84.5238 159.677 84.2606 159.578 84.0207C159.315 83.3773 158.993 82.693 158.449 82.0086C157.923 81.3301 157.092 80.6399 156.092 80.3358C155.016 80.0024 153.98 80.1194 153.138 80.3358C152.729 80.4586 152.319 80.5873 151.956 80.7511L151.535 80.9207C151.389 81.0026 151.307 81.0903 151.138 81.2073L150.728 81.529L149.991 82.1081C149.74 82.2894 149.476 82.4473 149.219 82.6228C148.71 82.9854 148.166 83.2487 147.634 83.5411C146.552 84.05 145.452 84.4477 144.37 84.594C143.288 84.7343 142.241 84.6758 141.264 84.4653C139.311 84.0441 137.69 83.0732 136.532 82.3888C135.374 81.6811 134.672 81.219 134.672 81.219C134.672 81.219 134.403 81.0552 133.924 80.7569C133.432 80.4645 132.724 80.0258 131.748 79.552C130.783 79.0899 129.525 78.5518 127.952 78.3939C126.384 78.2184 124.571 78.5869 123.05 79.3941C122.646 79.5695 122.307 79.8211 121.939 80.0492C121.564 80.2714 121.243 80.5405 120.909 80.8037L120.406 81.2015L119.944 81.6284L119.482 82.0554C119.33 82.2017 119.178 82.3303 119.002 82.5409C118.312 83.3013 117.809 84.243 117.575 85.2374C117.341 86.2317 117.353 87.2729 117.61 88.2555C117.862 89.2323 118.406 90.1331 119.096 90.8175C119.271 90.9929 119.447 91.1567 119.64 91.2912C119.827 91.4375 120.02 91.5778 120.237 91.6948C120.675 91.9522 121.272 92.1862 121.839 92.2388C122.991 92.3792 124.079 91.8177 124.735 91.0163C125.08 90.601 125.261 90.2559 125.431 89.905C125.583 89.554 125.705 89.2148 125.782 88.8989C126.249 86.9687 125.986 85.3134 125.472 83.933C124.945 82.5526 124.062 81.4822 123.12 80.8154C122.178 80.1369 121.231 79.8327 120.453 79.6807C119.663 79.5286 119.014 79.5344 118.47 79.5578C116.809 79.6514 115.399 80.1077 114.142 80.6341C112.884 81.1664 111.773 81.7864 110.755 82.4356C108.725 83.7458 107.041 85.1496 105.503 86.6002L105.508 86.5768Z",
            fill: "var(--ds-text, #292A2E)"
        }))))))))));
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: "filter0_dd_0_1",
            x: "-1.12427",
            y: "4.29492",
            width: "182.865",
            height: "130.908",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_0_1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "0.5"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "effect1_dropShadow_0_1",
            result: "effect2_dropShadow_0_1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect2_dropShadow_0_1",
            result: "shape"
        }));
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: "filter1_dd_0_1",
            x: "151.133",
            y: "5.11914",
            width: "182.865",
            height: "130.908",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_0_1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "0.5"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "effect1_dropShadow_0_1",
            result: "effect2_dropShadow_0_1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect2_dropShadow_0_1",
            result: "shape"
        }));
        $[11] = t12;
    } else t12 = $[11];
    let t13;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: "filter2_dd_0_1",
            x: "73.5081",
            y: "0",
            width: "176",
            height: "120",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_0_1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "0.5"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "effect1_dropShadow_0_1",
            result: "effect2_dropShadow_0_1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect2_dropShadow_0_1",
            result: "shape"
        }));
        $[12] = t13;
    } else t13 = $[12];
    let t14;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_0_1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "6.87573",
            y: "23.4559",
            width: "160",
            height: "104",
            rx: "12",
            transform: "rotate(-4 6.87573 23.4559)",
            fill: "white"
        }));
        $[13] = t14;
    } else t14 = $[13];
    let t15;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_0_1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "15.4143",
            y: "30.8784",
            width: "144",
            height: "88",
            rx: "12",
            transform: "rotate(-4 15.4143 30.8784)",
            fill: "white"
        }));
        $[14] = t15;
    } else t15 = $[14];
    let t16;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_0_1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "122.577",
            height: "115.757",
            fill: "white",
            transform: "matrix(-0.997564 0.0697565 0.0697565 0.997564 148.924 35.132)"
        }));
        $[15] = t16;
    } else t16 = $[15];
    let t17;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip3_0_1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "166.388",
            y: "13.1191",
            width: "160",
            height: "104",
            rx: "12",
            transform: "rotate(4 166.388 13.1191)",
            fill: "white"
        }));
        $[16] = t17;
    } else t17 = $[16];
    let t18;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip4_0_1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "173.81",
            y: "21.6577",
            width: "144",
            height: "88",
            rx: "12",
            transform: "rotate(4 173.81 21.6577)",
            fill: "white"
        }));
        $[17] = t18;
    } else t18 = $[17];
    let t19;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip5_0_1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "122.577",
            height: "115.757",
            fill: "white",
            transform: "matrix(-0.997564 -0.0697565 -0.0697565 0.997564 305.429 44.4507)"
        }));
        $[18] = t19;
    } else t19 = $[18];
    let t20;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip6_0_1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "89.5081",
            y: "16",
            width: "144",
            height: "88",
            rx: "12",
            fill: "white"
        }));
        $[19] = t20;
    } else t20 = $[19];
    let t21;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t11, t12, t13, t14, t15, t16, t17, t18, t19, t20, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip7_0_1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "170.087",
            height: "52.2388",
            fill: "white",
            transform: "translate(102.923 40)"
        })));
        $[20] = t21;
    } else t21 = $[20];
    let t22;
    if ($[21] !== testId) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "333",
            height: "135",
            viewBox: "0 0 333 135",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            "data-testid": testId,
            className: t1
        }, t10, t21);
        $[21] = testId;
        $[22] = t22;
    } else t22 = $[22];
    return t22;
};











const $6761756d86ac1d92$var$styles = {
    root: "_3iDTPbvLZJ _39xV02N91d _0jFU0VIZbP",
    mask: "_2ALXOx0I82"
};
const $6761756d86ac1d92$export$5bbc52ae928d0392 = (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $6761756d86ac1d92$var$styles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "6.87573",
            y: "23.4559",
            width: "160",
            height: "104",
            rx: "12",
            transform: "rotate(-4 6.87573 23.4559)",
            fill: "var(--ds-surface-raised, #FFFFFF)"
        });
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "15.4143",
            y: "30.8784",
            width: "144",
            height: "88",
            rx: "12",
            transform: "rotate(-4 15.4143 30.8784)",
            fill: "var(--ds-surface-sunken, #F8F8F8)"
        });
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    let t4;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            opacity: "0.05"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M38.8956 102.68C36.1437 102.975 36.1392 105.108 38.9545 105.263C42.9394 105.477 47.087 105.456 52.4182 105.237C58.4486 104.854 59.9302 104.34 64.0239 104.189C70.9348 103.853 82.6141 103.855 85.4256 103.864C85.842 103.867 86.257 103.85 86.6708 103.815C89.6387 103.588 102.67 102.594 113.906 102.212C121.832 101.843 126.741 101.621 129.306 101.5C135.346 101.244 139.883 100.837 144.245 100.404C146.456 100.249 146.897 98.4063 144.269 98.097C139.76 97.7144 135.225 97.6922 129.152 97.912C126.796 98.0127 121.864 97.7109 114.933 97.9522C113.803 97.9928 112.675 98.078 111.564 98.2134C101.939 99.3731 89.4004 99.8144 89.4004 99.8144C89.4004 99.8144 70.7047 100.744 62.8116 101.136C56.8705 101.423 54.0119 101.566 52.257 101.65C46.9408 101.9 42.8099 102.253 38.8951 102.674L38.8956 102.68Z",
            fill: "var(--ds-text, #292A2E)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M36.846 73.3697C34.0942 73.6646 34.0896 75.7971 36.905 75.9524C40.8898 76.1668 45.0375 76.1457 50.3686 75.9266C56.399 75.5433 57.8807 75.0299 61.9744 74.8781C68.8853 74.5421 80.5645 74.545 83.376 74.5533C83.7924 74.5562 84.2075 74.54 84.6212 74.5047C87.5891 74.2779 100.62 73.2835 111.856 72.9011C119.783 72.5325 124.691 72.311 127.257 72.1892C133.296 71.9334 137.833 71.5265 142.195 71.0934C144.406 70.9388 144.847 69.0959 142.22 68.7866C137.711 68.404 133.176 68.3817 127.102 68.6016C124.746 68.7023 119.814 68.4004 112.884 68.6417C111.753 68.6824 110.626 68.7676 109.515 68.9029C99.889 70.0627 87.3508 70.504 87.3508 70.504C87.3508 70.504 68.6551 71.4336 60.762 71.8254C54.8209 72.1128 51.9624 72.2551 50.2074 72.3394C44.8912 72.5895 40.7604 72.9424 36.8456 73.3634L36.846 73.3697Z",
            fill: "var(--ds-text, #292A2E)"
        }));
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M30.8806 51.3574C30.8097 50.3436 30.7743 49.8367 30.9053 49.4235C30.9992 49.1275 31.1528 48.8539 31.3565 48.6196C31.5602 48.3853 31.8098 48.1952 32.0898 48.061C32.4807 47.8737 32.9876 47.8382 34.0014 47.7673L40.8937 47.2854C41.9075 47.2145 42.4144 47.179 42.8276 47.3101C43.1236 47.4039 43.3972 47.5575 43.6316 47.7612C43.8659 47.9649 44.056 48.2145 44.1902 48.4945C44.3774 48.8855 44.4129 49.3923 44.4838 50.4062L44.8231 55.258C44.8939 56.2717 44.9294 56.7787 44.7983 57.1919C44.7045 57.4879 44.5509 57.7615 44.3472 57.9958C44.1435 58.2302 43.8939 58.4203 43.6139 58.5544C43.223 58.7417 42.716 58.7772 41.7022 58.848L34.81 59.33C33.7962 59.4009 33.2893 59.4363 32.8759 59.3053C32.58 59.2114 32.3064 59.0579 32.0721 58.8542C31.8378 58.6504 31.6477 58.4009 31.5135 58.1209C31.3262 57.7299 31.2908 57.223 31.2199 56.2092L30.8806 51.3574Z",
            fill: "#009954"
        });
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask0_70_9512",
            maskUnits: "userSpaceOnUse",
            x: "32",
            y: "45",
            width: "20",
            height: "16",
            className: (0, $hekY6.default)([
                $6761756d86ac1d92$var$styles.mask
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M48.227 45.2925L34.6239 46.2437C33.3717 46.3312 32.4277 47.4173 32.5152 48.6694L33.2128 58.6451C33.3003 59.8972 34.3864 60.8413 35.6385 60.7537L49.2417 59.8025C50.4938 59.7149 51.4379 58.6289 51.3503 57.3768L50.6528 47.4011C50.5652 46.149 49.4792 45.2049 48.227 45.2925Z",
            fill: "#0EBC5F"
        }));
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M32.3567 46.4022L50.4942 45.1339L51.5089 59.6439L33.3713 60.9122L32.3567 46.4022Z",
            fill: "#0EBC5F"
        });
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            filter: "url(#filter0_dd_70_9512)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_70_9512)"
        }, t2, t3, t4, t5, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask0_70_9512)"
        }, t7, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            filter: "url(#filter1_f_70_9512)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M44.8764 58.6265L34.3566 59.3621C32.7539 59.4742 31.3637 58.2658 31.2517 56.6631L30.849 50.9044C30.7369 49.3017 31.9453 47.9115 33.5481 47.7995L44.0678 47.0638C45.6706 46.9518 47.0607 48.1602 47.1728 49.7629L47.5754 55.5216C47.6875 57.1243 46.4791 58.5144 44.8764 58.6265Z",
            fill: "url(#paint0_linear_70_9512)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M39.4104 56.0466L48.9326 55.3808M46.816 57.6931L46.3087 50.4381",
            stroke: "white",
            strokeWidth: "3.27273",
            strokeLinecap: "round"
        })));
        $[7] = t8;
    } else t8 = $[7];
    let t10;
    let t9;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "166.388",
            y: "13.1191",
            width: "160",
            height: "104",
            rx: "12",
            transform: "rotate(4 166.388 13.1191)",
            fill: "var(--ds-surface-raised, #FFFFFF)"
        });
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "173.81",
            y: "21.6577",
            width: "144",
            height: "88",
            rx: "12",
            transform: "rotate(4 173.81 21.6577)",
            fill: "var(--ds-surface-sunken, #F8F8F8)"
        });
        $[8] = t10;
        $[9] = t9;
    } else {
        t10 = $[8];
        t9 = $[9];
    }
    let t11;
    let t12;
    let t13;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            opacity: "0.05"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M190.873 98.1791C188.107 98.0881 187.806 100.199 190.572 100.745C194.488 101.512 198.598 102.068 203.908 102.593C209.933 103.053 211.472 102.751 215.547 103.17C222.437 103.799 234.003 105.427 236.786 105.827C237.197 105.888 237.611 105.929 238.025 105.952C240.996 106.141 254.038 106.969 265.218 108.154C273.119 108.893 278.011 109.356 280.568 109.593C286.584 110.18 291.134 110.408 295.514 110.587C297.725 110.741 298.418 108.978 295.859 108.306C291.447 107.299 286.96 106.646 280.914 106.019C278.568 105.79 273.725 104.805 266.829 104.08C265.704 103.962 264.575 103.89 263.456 103.869C253.763 103.678 241.285 102.37 241.285 102.37C241.285 102.37 222.642 100.689 214.771 99.9783C208.848 99.436 205.997 99.1791 204.248 99.0183C198.949 98.5261 194.809 98.3006 190.874 98.1727L190.873 98.1791Z",
            fill: "var(--ds-text, #292A2E)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M192.923 68.8687C190.157 68.7777 189.855 70.8888 192.622 71.4344C196.538 72.2013 200.648 72.7576 205.958 73.2826C211.983 73.7423 213.522 73.4401 217.596 73.8596C224.487 74.4887 236.052 76.1169 238.835 76.5164C239.247 76.5773 239.66 76.619 240.075 76.6416C243.046 76.8301 256.088 77.6589 267.268 78.844C275.169 79.5822 280.06 80.0459 282.618 80.2824C288.634 80.8695 293.183 81.098 297.563 81.2762C299.774 81.4308 300.468 79.6673 297.909 78.9953C293.497 77.9889 289.009 77.3357 282.964 76.7081C280.617 76.48 275.775 75.4947 268.878 74.7691C267.753 74.652 266.625 74.5795 265.506 74.5589C255.812 74.3677 243.335 73.0597 243.335 73.0597C243.335 73.0597 224.692 71.3783 216.821 70.6679C210.898 70.1256 208.047 69.8686 206.297 69.7079C200.998 69.2157 196.858 68.9902 192.923 68.8623L192.923 68.8687Z",
            fill: "var(--ds-text, #292A2E)"
        }));
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M282.222 49.4012C282.052 47.568 283.401 45.9446 285.234 45.7753L296.852 44.7022C298.685 44.533 300.309 45.8818 300.478 47.7148L301.479 58.5478C301.648 60.381 300.299 62.0043 298.466 62.1736L286.848 63.2468C285.015 63.4161 283.392 62.0673 283.222 60.2341L282.222 49.4012Z",
            fill: "url(#paint1_linear_70_9512)"
        });
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M282.166 49.1913C282.24 48.1292 282.277 47.5981 282.474 47.1886C282.614 46.8952 282.813 46.6338 283.059 46.4204C283.304 46.207 283.591 46.0462 283.901 45.9478C284.334 45.8104 284.865 45.8476 285.927 45.9218L298.848 46.8253C299.91 46.8996 300.441 46.9367 300.85 47.1329C301.144 47.2735 301.405 47.4727 301.619 47.7182C301.832 47.9637 301.993 48.2503 302.091 48.5604C302.228 48.9932 302.191 49.5243 302.117 50.5864L301.546 58.7569C301.471 59.819 301.434 60.35 301.238 60.7596C301.098 61.053 300.898 61.3144 300.653 61.5278C300.407 61.7413 300.121 61.9021 299.811 62.0004C299.378 62.1377 298.847 62.1006 297.785 62.0263L284.864 61.1228C283.802 61.0485 283.271 61.0114 282.861 60.8152C282.568 60.6746 282.306 60.4755 282.093 60.23C281.88 59.9845 281.719 59.6979 281.62 59.3878C281.483 58.9549 281.52 58.4238 281.594 57.3618L282.166 49.1913Z",
            fill: "url(#paint2_linear_70_9512)"
        });
        $[10] = t11;
        $[11] = t12;
        $[12] = t13;
    } else {
        t11 = $[10];
        t12 = $[11];
        t13 = $[12];
    }
    let t14;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask1_70_9512",
            maskUnits: "userSpaceOnUse",
            x: "281",
            y: "45",
            width: "22",
            height: "18",
            className: (0, $hekY6.default)([
                $6761756d86ac1d92$var$styles.mask
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M282.166 49.1913C282.24 48.1292 282.277 47.5981 282.474 47.1886C282.614 46.8952 282.813 46.6338 283.059 46.4204C283.304 46.207 283.591 46.0462 283.901 45.9478C284.334 45.8104 284.865 45.8476 285.927 45.9218L298.848 46.8253C299.91 46.8996 300.441 46.9367 300.85 47.1329C301.144 47.2735 301.405 47.4727 301.619 47.7182C301.832 47.9637 301.993 48.2503 302.091 48.5604C302.228 48.9932 302.191 49.5243 302.117 50.5864L301.546 58.7569C301.471 59.819 301.434 60.35 301.238 60.7596C301.098 61.053 300.898 61.3144 300.653 61.5278C300.407 61.7413 300.121 61.9021 299.811 62.0004C299.378 62.1377 298.847 62.1006 297.785 62.0263L284.864 61.1228C283.802 61.0485 283.271 61.0114 282.861 60.8152C282.568 60.6746 282.306 60.4755 282.093 60.23C281.88 59.9845 281.719 59.6979 281.62 59.3878C281.483 58.9549 281.52 58.4238 281.594 57.3618L282.166 49.1913Z",
            fill: "#FEC700"
        }));
        $[13] = t14;
    } else t14 = $[13];
    let t15;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            filter: "url(#filter2_dd_70_9512)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_70_9512)"
        }, t9, t10, t11, t12, t13, t14, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask1_70_9512)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            filter: "url(#filter3_f_70_9512)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M283.669 64.801L300.996 63.4373L299.427 43.4989L282.099 44.8626L283.669 64.801Z",
            fill: "#FFBE00"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M283.669 64.801L300.996 63.4373L299.427 43.4989L282.099 44.8626L283.669 64.801Z",
            fill: "url(#paint3_linear_70_9512)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M298.347 49.8931C298.536 49.9063 298.712 49.9941 298.836 50.137C298.96 50.28 299.022 50.4665 299.009 50.6555L298.478 58.256C298.465 58.4449 298.377 58.6209 298.234 58.7452C298.091 58.8695 297.904 58.9319 297.715 58.9187L285.365 58.055L285.328 58.0515C285.146 58.0293 284.98 57.9383 284.863 57.797C284.747 57.6558 284.689 57.4753 284.702 57.2926L285.233 49.6922C285.246 49.5095 285.329 49.3388 285.464 49.2152C285.599 49.0915 285.776 49.0245 285.959 49.0278L285.996 49.0294L298.347 49.8931ZM286.177 56.6798L297.103 57.4438L297.534 51.2684L286.609 50.5044L286.177 56.6798Z",
            fill: "white"
        })));
        $[14] = t15;
    } else t15 = $[14];
    let t16;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "81.5081",
            y: "8",
            width: "160",
            height: "104",
            rx: "12",
            fill: "var(--ds-surface-raised, #FFFFFF)"
        });
        $[15] = t16;
    } else t16 = $[15];
    let t17;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "89.5081",
            y: "16",
            width: "144",
            height: "88",
            rx: "12",
            fill: "var(--ds-surface-sunken, #F8F8F8)"
        });
        $[16] = t17;
    } else t17 = $[16];
    let t18;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            opacity: "0.05"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip3_70_9512)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M204.759 40.2357C204 39.0511 203.37 37.9907 202.816 37.0856C202.261 36.1849 201.817 35.4173 201.485 34.7917C200.815 33.5361 200.584 32.8395 200.748 32.7197C200.917 32.5999 201.485 33.0658 202.425 34.1395C202.896 34.6763 203.459 35.3641 204.111 36.2115C204.759 37.0589 205.464 38.0838 206.263 39.2596C207.412 40.9145 208.468 42.6494 209.577 44.3753C210.119 45.2449 210.638 46.1367 211.175 47.0285C211.441 47.4722 211.707 47.9203 211.973 48.3684C212.226 48.8254 212.484 49.2824 212.741 49.7439C214.817 53.4043 216.761 57.2865 218.456 61.4926C220.133 65.6943 221.619 70.2376 222.187 75.2779C222.458 77.7891 222.515 80.4335 222.036 83.1311C221.566 85.8198 220.488 88.5706 218.642 90.9C218.154 91.5877 217.537 92.1334 216.978 92.7102C216.69 92.9853 216.366 93.216 216.069 93.4645C215.762 93.7041 215.474 93.9614 215.146 94.1522C214.507 94.5604 213.894 94.9819 213.242 95.2792C212.923 95.4389 212.603 95.5986 212.293 95.7583C211.969 95.887 211.649 96.0112 211.334 96.1399C208.797 97.1204 206.374 97.5286 204.16 97.7283C199.71 98.0877 196.032 97.6174 192.686 97.014C189.341 96.3839 186.306 95.5454 183.143 94.4761C179.979 93.3979 176.683 92.0846 172.894 90.2655C166.496 87.1908 159.357 82.8205 152.653 77.3233C145.935 71.8482 139.679 65.2373 134.799 58.2448C132.354 54.7575 130.247 51.1903 128.507 47.7029C128.09 46.8244 127.664 45.9637 127.27 45.1074C126.897 44.2422 126.533 43.3903 126.178 42.5562L126.045 42.2412L125.912 41.8862C125.819 41.6511 125.752 41.4115 125.681 41.1719C125.544 40.6927 125.442 40.2091 125.371 39.7255C125.233 38.7582 125.229 37.791 125.34 36.8637C125.57 35.0002 126.285 33.3054 127.341 31.9566L127.531 31.6992L127.758 31.4552C127.913 31.2955 128.064 31.1402 128.219 30.9849C128.383 30.8385 128.574 30.7054 128.752 30.5678C128.929 30.4303 129.111 30.3016 129.324 30.204C129.528 30.0975 129.732 29.9955 129.936 29.9023C130.154 29.8313 130.375 29.7692 130.593 29.7115C130.81 29.6405 131.028 29.6139 131.245 29.6006C131.462 29.5829 131.68 29.5562 131.888 29.5607C132.718 29.6006 133.477 29.7692 134.098 30.0265C134.413 30.1508 134.724 30.275 134.981 30.4303C135.247 30.5767 135.527 30.7098 135.748 30.8695C135.979 31.0248 136.205 31.1757 136.423 31.3177C136.622 31.473 136.818 31.6238 137.004 31.7702C137.386 32.0542 137.683 32.347 137.976 32.6043C139.32 33.8378 140.46 35.1999 141.507 36.6064C142.444 37.862 143.695 39.6944 145.088 42.0681C146.477 44.4418 148.021 47.3568 149.591 50.751C151.162 54.1452 152.781 58.0141 154.321 62.2912C155.865 66.5684 157.351 71.2492 158.616 76.2717C159.872 81.2942 160.954 86.6539 161.433 92.302C161.54 93.7174 161.633 95.1416 161.633 96.5925C161.655 97.3157 161.62 98.0433 161.611 98.7754C161.562 99.5075 161.544 100.24 161.46 100.98C161.327 102.458 161.092 103.949 160.688 105.431C160.284 106.913 159.725 108.399 158.855 109.779C158.629 110.12 158.421 110.471 158.141 110.781C157.879 111.105 157.618 111.429 157.303 111.713L156.846 112.152C156.681 112.286 156.508 112.41 156.335 112.538C156.167 112.663 155.985 112.8 155.83 112.907L155.395 113.195C154.818 113.586 154.259 113.998 153.718 114.429L153.314 114.757L152.844 115.121L152.364 115.489C152.2 115.604 152.027 115.711 151.859 115.822C150.505 116.7 149.006 117.339 147.466 117.738C145.927 118.142 144.347 118.315 142.794 118.324C139.679 118.337 136.654 117.747 133.787 116.86C130.917 115.981 128.188 114.801 125.584 113.479C121.914 111.589 118.622 109.446 115.641 107.214C112.664 104.974 109.997 102.635 107.65 100.222C105.312 97.7993 103.266 95.3147 101.713 92.6171C100.955 91.2549 100.307 89.844 99.9786 88.2689C99.8189 87.4836 99.7612 86.6406 99.881 85.7799C99.9875 84.9236 100.347 84.0318 100.906 83.3396C101.461 82.6519 102.153 82.1106 102.849 81.7912C103.022 81.6936 103.195 81.6181 103.368 81.556C103.541 81.4895 103.714 81.4229 103.887 81.3563C104.229 81.2543 104.571 81.1611 104.908 81.0813C106.261 80.7973 107.623 80.7663 108.888 80.9792C111.435 81.383 113.569 82.6386 115.108 84.1604C115.303 84.3468 115.481 84.5553 115.663 84.7461C115.836 84.9369 115.978 85.1188 116.133 85.3007C116.444 85.6601 116.728 86.0283 117.012 86.3833C117.575 87.0932 118.09 87.7898 118.569 88.4597C119.523 89.7997 120.326 91.0508 121.023 92.1822C124.292 97.5464 126.684 102.933 128.49 108.195C130.273 113.466 131.462 118.648 131.822 123.755C131.986 126.306 131.955 128.839 131.56 131.32C131.183 133.791 130.429 136.227 129.138 138.383C127.86 140.539 125.983 142.358 123.782 143.477C122.691 144.04 121.542 144.466 120.375 144.754C119.208 145.025 118.028 145.207 116.852 145.273C115.561 145.344 114.434 145.296 113.484 145.194C113.01 145.132 112.575 145.087 112.18 145.016C111.789 144.941 111.439 144.87 111.128 144.799C109.895 144.484 109.314 144.195 109.345 144.022C109.376 143.84 110.019 143.774 111.257 143.792C111.869 143.796 112.637 143.805 113.555 143.809C114.469 143.809 115.53 143.783 116.728 143.676C117.819 143.583 118.893 143.379 119.94 143.108C120.983 142.815 121.985 142.412 122.926 141.893C124.812 140.868 126.36 139.288 127.434 137.389C128.516 135.49 129.155 133.298 129.457 131.013C129.776 128.728 129.772 126.346 129.577 123.928C129.164 119.083 127.966 114.087 126.2 108.989C124.412 103.9 122.061 98.6645 118.897 93.4911C118.281 92.4884 117.557 91.3614 116.692 90.1546C115.831 88.9567 114.82 87.6256 113.657 86.3389C112.566 85.1587 111.04 84.1471 109.225 83.7167C108.32 83.5038 107.353 83.4106 106.377 83.5348C105.888 83.5792 105.396 83.699 104.921 83.841C104.673 83.8987 104.473 84.014 104.242 84.0939C104.131 84.1382 104.043 84.2048 103.941 84.2536C103.843 84.3068 103.732 84.3557 103.657 84.4266C103.28 84.6618 103.036 84.9724 102.84 85.3096C102.805 85.4027 102.738 85.4782 102.716 85.5758C102.69 85.6734 102.658 85.771 102.623 85.8686C102.592 86.086 102.539 86.2945 102.548 86.5386C102.521 86.7693 102.57 87.0311 102.583 87.284C102.636 87.5457 102.663 87.8075 102.752 88.0826C102.88 88.6283 103.111 89.1874 103.351 89.7464C104.389 92.0003 106.053 94.2365 107.969 96.3972C109.895 98.5668 112.127 100.665 114.589 102.698C117.052 104.73 119.754 106.677 122.686 108.479C124.594 109.655 126.56 110.737 128.57 111.7C130.575 112.663 132.625 113.515 134.715 114.176C135.837 114.544 136.986 114.846 138.153 115.085C139.32 115.334 140.5 115.493 141.689 115.56C144.059 115.711 146.463 115.436 148.615 114.544C149.689 114.1 150.701 113.506 151.606 112.765C152.129 112.334 152.666 111.922 153.221 111.531C153.496 111.336 153.775 111.145 154.055 110.959L154.481 110.684L154.809 110.44C156.571 109.158 157.684 106.952 158.279 104.619C158.452 104.042 158.549 103.434 158.678 102.84C158.762 102.232 158.878 101.633 158.926 101.016C159.073 99.7959 159.108 98.558 159.135 97.3245C159.157 94.8577 158.975 92.4041 158.7 90.0038C158.132 85.2031 157.174 80.611 156.078 76.3738C153.882 67.895 151.189 60.8093 149.086 55.8978C148.03 53.4397 147.129 51.5142 146.481 50.2097C146.166 49.5531 145.904 49.0562 145.736 48.719C145.563 48.3818 145.474 48.2043 145.474 48.2043C145.474 48.2043 145.336 47.9425 145.079 47.45C144.822 46.9531 144.436 46.2254 143.921 45.3026C142.887 43.4613 141.361 40.7948 139.107 37.8354C137.976 36.3757 136.649 34.8183 135.016 33.5627C134.204 32.9549 133.295 32.4313 132.399 32.245C131.502 32.0764 130.704 32.2849 129.967 32.9327C129.248 33.6026 128.61 34.6098 128.241 35.6835C127.873 36.7661 127.735 37.9596 127.864 39.1531C127.926 39.7477 128.055 40.3466 128.25 40.9279L128.405 41.3627L128.605 41.8374C128.738 42.1524 128.871 42.4719 129.004 42.7913C129.28 43.4258 129.524 44.078 129.83 44.708C130.127 45.3425 130.429 45.9814 130.73 46.6203C131.99 49.1626 133.37 51.7138 134.963 54.1807C135.726 55.4363 136.587 56.6343 137.421 57.8588C137.851 58.4623 138.304 59.0524 138.743 59.6513L139.409 60.5476L140.105 61.4172C143.788 66.0936 147.99 70.3707 152.333 74.1554C161.061 81.698 170.431 87.0444 177.73 90.1014C180.472 91.2816 183.103 92.2089 185.592 92.972C186.834 93.3669 188.054 93.6686 189.23 93.9792C189.82 94.1211 190.401 94.2409 190.974 94.3696C191.546 94.5027 192.11 94.6092 192.664 94.7024C197.101 95.5276 200.979 95.643 204.249 95.3235C207.523 94.9908 210.168 94.1345 212.213 93.0607C214.263 91.9781 215.691 90.656 216.707 89.3693C218.256 87.4126 219.192 85.0833 219.622 82.7052C220.057 80.3181 220.022 77.8956 219.782 75.553C219.285 70.8499 217.914 66.453 216.335 62.3534C214.742 58.2493 212.901 54.407 210.931 50.7643C210.687 50.3073 210.447 49.8503 210.203 49.3978C209.95 48.9497 209.697 48.5015 209.444 48.0579C208.934 47.1705 208.446 46.2787 207.931 45.4046C206.871 43.6743 205.877 41.9306 204.781 40.2623L204.759 40.2357Z",
            fill: "var(--ds-text, #292A2E)"
        })));
        $[17] = t18;
    } else t18 = $[17];
    let t19;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask2_70_9512",
            maskUnits: "userSpaceOnUse",
            x: "106",
            y: "30",
            width: "15",
            height: "20",
            className: (0, $hekY6.default)([
                $6761756d86ac1d92$var$styles.mask
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M117.348 50H109.538C108.522 50 108.013 50 107.611 49.8409C107.322 49.7266 107.06 49.5543 106.84 49.3346C106.62 49.1149 106.448 48.8525 106.334 48.5636C106.175 48.1602 106.175 47.6523 106.175 46.6364V33.3636C106.175 32.3477 106.175 31.8386 106.334 31.4364C106.448 31.1475 106.62 30.8851 106.84 30.6654C107.06 30.4457 107.322 30.2734 107.611 30.1591C108.013 30 108.522 30 109.538 30H113.902L120.129 36.2273C120.317 36.4148 120.411 36.5091 120.484 36.6159C120.589 36.77 120.661 36.9441 120.696 37.1273C120.719 37.2545 120.719 37.3886 120.719 37.6591C120.715 43.2182 120.713 43.2727 120.713 46.633C120.713 47.6511 120.713 48.1614 120.554 48.5648C120.44 48.8535 120.267 49.1156 120.048 49.3351C119.828 49.5546 119.566 49.7267 119.277 49.8409C118.873 50 118.365 50 117.348 50Z",
            fill: "#3186FF"
        }));
        $[18] = t19;
    } else t19 = $[18];
    let t20;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M120.713 50H106.175V30H113.902L120.72 36.8182L120.713 50Z",
            fill: "#3186FF"
        });
        $[19] = t20;
    } else t20 = $[19];
    let t21;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            filter: "url(#filter4_dd_70_9512)"
        }, t16, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_70_9512)"
        }, t17, t18, t19, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask2_70_9512)"
        }, t20, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            filter: "url(#filter5_f_70_9512)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M107.425 50.9095H119.47V31.364H107.425V50.9095Z",
            fill: "url(#paint4_linear_70_9512)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M120.152 36.25C119.867 36.0352 119.513 35.9091 119.129 35.9091H115.356C114.971 35.9091 114.601 35.7558 114.328 35.4831C114.055 35.2103 113.902 34.8403 113.902 34.4545V30L120.152 36.25Z",
            fill: "#76BBFF"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M116.402 42.0454H110.493C110.116 42.0454 109.811 42.3507 109.811 42.7272C109.811 43.1038 110.116 43.409 110.493 43.409H116.402C116.779 43.409 117.084 43.1038 117.084 42.7272C117.084 42.3507 116.779 42.0454 116.402 42.0454Z",
            fill: "white"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M114.584 45.3409H110.493C110.116 45.3409 109.811 45.6462 109.811 46.0228C109.811 46.3993 110.116 46.7046 110.493 46.7046H114.584C114.96 46.7046 115.266 46.3993 115.266 46.0228C115.266 45.6462 114.96 45.3409 114.584 45.3409Z",
            fill: "white"
        })));
        $[20] = t21;
    } else t21 = $[20];
    let t22;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: "filter0_dd_70_9512",
            x: "-1.12427",
            y: "4.29492",
            width: "182.865",
            height: "130.908",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_70_9512"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "0.5"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "effect1_dropShadow_70_9512",
            result: "effect2_dropShadow_70_9512"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect2_dropShadow_70_9512",
            result: "shape"
        }));
        $[21] = t22;
    } else t22 = $[21];
    let t23;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: "filter1_f_70_9512",
            x: "27.5691",
            y: "43.7839",
            width: "23.2864",
            height: "18.8582",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "BackgroundImageFix",
            result: "shape"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "1.63636",
            result: "effect1_foregroundBlur_70_9512"
        }));
        $[22] = t23;
    } else t23 = $[22];
    let t24;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: "filter2_dd_70_9512",
            x: "151.133",
            y: "5.11914",
            width: "182.865",
            height: "130.908",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_70_9512"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "0.5"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "effect1_dropShadow_70_9512",
            result: "effect2_dropShadow_70_9512"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect2_dropShadow_70_9512",
            result: "shape"
        }));
        $[23] = t24;
    } else t24 = $[23];
    let t25;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: "filter3_f_70_9512",
            x: "278.671",
            y: "40.0703",
            width: "25.7539",
            height: "28.1593",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "BackgroundImageFix",
            result: "shape"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "1.71429",
            result: "effect1_foregroundBlur_70_9512"
        }));
        $[24] = t25;
    } else t25 = $[24];
    let t26;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: "filter4_dd_70_9512",
            x: "73.5081",
            y: "0",
            width: "176",
            height: "120",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_70_9512"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "0.5"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "effect1_dropShadow_70_9512",
            result: "effect2_dropShadow_70_9512"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect2_dropShadow_70_9512",
            result: "shape"
        }));
        $[25] = t26;
    } else t26 = $[25];
    let t27;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: "filter5_f_70_9512",
            x: "104.152",
            y: "28.0913",
            width: "18.5909",
            height: "26.0909",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "BackgroundImageFix",
            result: "shape"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "1.63636",
            result: "effect1_foregroundBlur_70_9512"
        }));
        $[26] = t27;
    } else t27 = $[26];
    let t28;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint0_linear_70_9512",
            x1: "44.9683",
            y1: "53.6865",
            x2: "33.4646",
            y2: "54.4909",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#0EBC5F"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.95",
            stopColor: "#78C9FF"
        }));
        $[27] = t28;
    } else t28 = $[27];
    let t29;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint1_linear_70_9512",
            x1: "291.043",
            y1: "45.2387",
            x2: "298.585",
            y2: "62.1811",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.2",
            stopColor: "#FFDB0F"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.67",
            stopColor: "#FFBE00"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.91",
            stopColor: "#FFA8E3"
        }));
        $[28] = t29;
    } else t29 = $[28];
    let t30;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint2_linear_70_9512",
            x1: "292.387",
            y1: "46.3736",
            x2: "291.324",
            y2: "61.5746",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#FFBE00"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "#FEC700"
        }));
        $[29] = t30;
    } else t30 = $[29];
    let t31;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint3_linear_70_9512",
            x1: "292.743",
            y1: "62.6483",
            x2: "291.013",
            y2: "45.4751",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.07",
            stopColor: "#FFF549"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.78",
            stopColor: "#FFBE00",
            stopOpacity: "0"
        }));
        $[30] = t31;
    } else t31 = $[30];
    let t32;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint4_linear_70_9512",
            x1: "113.447",
            y1: "35.8277",
            x2: "108.744",
            y2: "48.5617",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.33",
            stopColor: "#3186FF"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "#A9A8FF"
        }));
        $[31] = t32;
    } else t32 = $[31];
    let t33;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_70_9512"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "6.87573",
            y: "23.4559",
            width: "160",
            height: "104",
            rx: "12",
            transform: "rotate(-4 6.87573 23.4559)",
            fill: "white"
        }));
        $[32] = t33;
    } else t33 = $[32];
    let t34;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_70_9512"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "166.388",
            y: "13.1191",
            width: "160",
            height: "104",
            rx: "12",
            transform: "rotate(4 166.388 13.1191)",
            fill: "white"
        }));
        $[33] = t34;
    } else t34 = $[33];
    let t35;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_70_9512"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "89.5081",
            y: "16",
            width: "144",
            height: "88",
            rx: "12",
            fill: "white"
        }));
        $[34] = t35;
    } else t35 = $[34];
    let t36;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t22, t23, t24, t25, t26, t27, t28, t29, t30, t31, t32, t33, t34, t35, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip3_70_9512"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "122.577",
            height: "115.757",
            fill: "white",
            transform: "matrix(-1 0 0 1 222.396 29.5563)"
        })));
        $[35] = t36;
    } else t36 = $[35];
    let t37;
    if ($[36] !== testId) {
        t37 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "333",
            height: "135",
            viewBox: "0 0 333 135",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            "data-testid": testId,
            className: t1
        }, t8, t15, t21, t36);
        $[36] = testId;
        $[37] = t37;
    } else t37 = $[37];
    return t37;
};











const $2aea9f1687f7ee64$var$styles = {
    root: "_3iDTPbvLZJ _39xV02N91d _0jFU0VIZbP"
};
const $2aea9f1687f7ee64$export$fa4931584e43eea = (t0)=>{
    const $ = (0, $bDgLe.c)(47);
    const { testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $2aea9f1687f7ee64$var$styles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "6.87573",
            y: "23.4559",
            width: "160",
            height: "104",
            rx: "12",
            transform: "rotate(-4 6.87573 23.4559)",
            fill: "var(--ds-surface-raised, #FFFFFF)"
        });
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "15.4143",
            y: "30.8784",
            width: "144",
            height: "88",
            rx: "12",
            transform: "rotate(-4 15.4143 30.8784)",
            fill: "var(--ds-surface-sunken, #F8F8F8)"
        });
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            filter: "url(#filter0_dd_70_9506)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_70_9506)"
        }, t2, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            opacity: "0.05"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M38.8956 102.68C36.1437 102.975 36.1392 105.108 38.9545 105.263C42.9394 105.477 47.087 105.456 52.4182 105.237C58.4486 104.854 59.9302 104.34 64.0239 104.189C70.9348 103.853 82.6141 103.855 85.4256 103.864C85.842 103.867 86.257 103.85 86.6708 103.815C89.6387 103.588 102.67 102.594 113.906 102.212C121.832 101.843 126.741 101.621 129.306 101.5C135.346 101.244 139.883 100.837 144.245 100.404C146.456 100.249 146.897 98.4063 144.269 98.097C139.76 97.7144 135.225 97.6922 129.152 97.912C126.796 98.0127 121.864 97.7109 114.933 97.9522C113.803 97.9928 112.675 98.078 111.564 98.2134C101.939 99.3731 89.4004 99.8144 89.4004 99.8144C89.4004 99.8144 70.7047 100.744 62.8116 101.136C56.8705 101.423 54.0119 101.566 52.257 101.65C46.9408 101.9 42.8099 102.253 38.8951 102.674L38.8956 102.68Z",
            fill: "var(--ds-text, #292A2E)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M36.846 73.3697C34.0942 73.6646 34.0896 75.7971 36.905 75.9524C40.8898 76.1668 45.0375 76.1457 50.3686 75.9266C56.399 75.5433 57.8807 75.0299 61.9744 74.8781C68.8853 74.5421 80.5645 74.545 83.376 74.5533C83.7924 74.5562 84.2075 74.54 84.6212 74.5047C87.5891 74.2779 100.62 73.2835 111.856 72.9011C119.783 72.5325 124.691 72.311 127.257 72.1892C133.296 71.9334 137.833 71.5265 142.195 71.0934C144.406 70.9388 144.847 69.0959 142.22 68.7866C137.711 68.404 133.176 68.3817 127.102 68.6016C124.746 68.7023 119.814 68.4004 112.884 68.6417C111.753 68.6824 110.626 68.7676 109.515 68.9029C99.889 70.0627 87.3508 70.504 87.3508 70.504C87.3508 70.504 68.6551 71.4336 60.762 71.8254C54.8209 72.1128 51.9624 72.2551 50.2074 72.3394C44.8912 72.5895 40.7604 72.9424 36.8456 73.3634L36.846 73.3697Z",
            fill: "var(--ds-text, #292A2E)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M33.1303 50.3547C33.0413 49.0829 34.0001 47.9799 35.2717 47.891L48.3175 46.9787L49.2479 60.2832C49.3071 61.1311 48.668 61.8666 47.8203 61.9259L37.0763 62.6772C35.3812 62.7957 33.9108 61.5172 33.7923 59.8217L33.1303 50.3547Z",
            fill: "url(#paint0_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M33.1303 50.3547C33.0413 49.0829 34.0001 47.9799 35.2717 47.891L48.3175 46.9787L49.2479 60.2832C49.3071 61.1311 48.668 61.8666 47.8203 61.9259L37.0763 62.6772C35.3812 62.7957 33.9108 61.5172 33.7923 59.8217L33.1303 50.3547Z",
            fill: "url(#paint1_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M33.3092 52.914C33.2203 51.6421 34.1791 50.5392 35.4506 50.4503L42.3572 49.9674C41.5095 50.0267 40.8703 50.7621 40.9296 51.6099L41.1443 54.6801C41.2036 55.5278 40.5646 56.2634 39.7168 56.3226L36.6474 56.5373C34.9522 56.6558 33.6741 58.1265 33.7927 59.8221L33.3096 52.914L33.3092 52.914Z",
            fill: "url(#paint2_linear_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M33.3092 52.914C33.2203 51.6421 34.1791 50.5392 35.4506 50.4503L42.3572 49.9674C41.5095 50.0267 40.8703 50.7621 40.9296 51.6099L41.1443 54.6801C41.2036 55.5278 40.5646 56.2634 39.7168 56.3226L36.6474 56.5373C34.9522 56.6558 33.6741 58.1265 33.7927 59.8221L33.3096 52.914L33.3092 52.914Z",
            fill: "url(#paint3_linear_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M32.9334 47.5402C32.8149 45.8447 34.093 44.374 35.7881 44.2555L41.9274 43.8262L42.3568 49.9669L36.2175 50.3962C34.5224 50.5147 33.2443 51.9854 33.3628 53.6809L32.9334 47.5402Z",
            fill: "url(#paint4_linear_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M32.9334 47.5402C32.8149 45.8447 34.093 44.374 35.7881 44.2555L41.9274 43.8262L42.3568 49.9669L36.2175 50.3962C34.5224 50.5147 33.2443 51.9854 33.3628 53.6809L32.9334 47.5402Z",
            fill: "url(#paint5_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M32.9334 47.5402C32.8149 45.8447 34.093 44.374 35.7881 44.2555L41.9274 43.8262L42.3568 49.9669L36.2175 50.3962C34.5224 50.5147 33.2443 51.9854 33.3628 53.6809L32.9334 47.5402Z",
            fill: "url(#paint6_linear_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M41.9275 43.8261L46.5317 43.5042C47.3794 43.4449 48.1147 44.0841 48.174 44.9317L48.3887 48.0027C48.448 48.8504 47.8088 49.5857 46.9611 49.6449L42.3569 49.9669C41.5092 50.0262 40.7739 49.387 40.7147 48.5393L40.4999 45.4684C40.4406 44.6207 41.0798 43.8854 41.9275 43.8261Z",
            fill: "url(#paint7_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M32.432 53.2333L37.292 52.8935C38.2103 52.8293 39.0069 53.5217 39.0711 54.4399L39.4111 59.3018C39.4753 60.2202 38.7829 61.0166 37.8645 61.0808L33.0045 61.4206C32.0863 61.4848 31.2897 60.7925 31.2255 59.8742L30.8856 55.0123C30.8213 54.0941 31.5138 53.2975 32.432 53.2333Z",
            fill: "url(#paint8_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M32.432 53.2333L37.292 52.8935C38.2103 52.8293 39.0069 53.5217 39.0711 54.4399L39.4111 59.3018C39.4753 60.2202 38.7829 61.0166 37.8645 61.0808L33.0045 61.4206C32.0863 61.4848 31.2897 60.7925 31.2255 59.8742L30.8856 55.0123C30.8213 54.0941 31.5138 53.2975 32.432 53.2333Z",
            fill: "url(#paint9_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M37.4635 59.3469L36.2016 59.4351L35.3052 57.9994C35.2732 57.9491 35.2486 57.9093 35.2314 57.8799C35.2161 57.8483 35.1991 57.8121 35.1811 57.7719L35.1683 57.7728C35.1524 57.8265 35.137 57.8701 35.122 57.9037C35.1068 57.9378 35.0891 57.9793 35.0685 58.0289L34.3502 59.5642L33.1602 59.6474L34.4245 57.2051L32.931 54.9621L34.1764 54.8751L34.9735 56.1571C35.0057 56.2095 35.033 56.2557 35.0554 56.2957C35.0798 56.3332 35.1048 56.3784 35.1304 56.4315L35.1433 56.4305C35.1691 56.3655 35.1895 56.3136 35.2046 56.2756C35.2216 56.2373 35.2444 56.1866 35.2725 56.1236L35.9106 54.7545L37.0974 54.6715L35.9086 57.0662L37.4638 59.3472L37.4635 59.3469Z",
            fill: "white"
        })));
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "166.388",
            y: "13.1191",
            width: "160",
            height: "104",
            rx: "12",
            transform: "rotate(4 166.388 13.1191)",
            fill: "var(--ds-surface-raised, #FFFFFF)"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "173.81",
            y: "21.6577",
            width: "144",
            height: "88",
            rx: "12",
            transform: "rotate(4 173.81 21.6577)",
            fill: "var(--ds-surface-sunken, #F8F8F8)"
        });
        $[4] = t5;
        $[5] = t6;
    } else {
        t5 = $[4];
        t6 = $[5];
    }
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            filter: "url(#filter1_dd_70_9506)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_70_9506)"
        }, t5, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            opacity: "0.05"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M190.873 98.1791C188.107 98.0881 187.806 100.199 190.572 100.745C194.488 101.512 198.598 102.068 203.908 102.593C209.933 103.053 211.472 102.751 215.547 103.17C222.437 103.799 234.003 105.427 236.786 105.827C237.197 105.888 237.611 105.929 238.025 105.952C240.996 106.141 254.038 106.969 265.218 108.154C273.119 108.893 278.011 109.356 280.568 109.593C286.584 110.18 291.134 110.408 295.514 110.587C297.725 110.741 298.418 108.978 295.859 108.306C291.447 107.299 286.96 106.646 280.914 106.019C278.568 105.79 273.725 104.805 266.829 104.08C265.704 103.962 264.575 103.89 263.456 103.869C253.763 103.678 241.285 102.37 241.285 102.37C241.285 102.37 222.642 100.689 214.771 99.9783C208.848 99.436 205.997 99.1791 204.248 99.0183C198.949 98.5261 194.809 98.3006 190.874 98.1727L190.873 98.1791Z",
            fill: "var(--ds-text, #292A2E)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M192.923 68.8687C190.157 68.7777 189.855 70.8888 192.622 71.4344C196.538 72.2013 200.648 72.7576 205.958 73.2826C211.983 73.7423 213.522 73.4401 217.596 73.8596C224.487 74.4887 236.052 76.1169 238.835 76.5164C239.247 76.5773 239.66 76.619 240.075 76.6416C243.046 76.8301 256.088 77.6589 267.268 78.844C275.169 79.5822 280.06 80.0459 282.618 80.2824C288.634 80.8695 293.183 81.098 297.563 81.2762C299.774 81.4308 300.468 79.6673 297.909 78.9953C293.497 77.9889 289.009 77.3357 282.964 76.7081C280.617 76.48 275.775 75.4947 268.878 74.7691C267.753 74.652 266.625 74.5795 265.506 74.5589C255.812 74.3677 243.335 73.0597 243.335 73.0597C243.335 73.0597 224.692 71.3783 216.821 70.6679C210.898 70.1256 208.047 69.8686 206.297 69.7079C200.998 69.2157 196.858 68.9902 192.923 68.8623L192.923 68.8687Z",
            fill: "var(--ds-text, #292A2E)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M301.848 54.6696C302.233 49.1601 298.079 44.3817 292.571 43.9965C287.062 43.6112 282.283 47.7651 281.898 53.2746C281.513 58.7841 285.666 63.5625 291.175 63.9477C296.684 64.333 301.462 60.1791 301.848 54.6696Z",
            fill: "url(#paint10_linear_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M301.848 54.6696C302.233 49.1601 298.079 44.3817 292.571 43.9965C287.062 43.6112 282.283 47.7651 281.898 53.2746C281.513 58.7841 285.666 63.5625 291.175 63.9477C296.684 64.333 301.462 60.1791 301.848 54.6696Z",
            fill: "url(#paint11_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M301.848 54.6696C302.233 49.1601 298.079 44.3817 292.571 43.9965C287.062 43.6112 282.283 47.7651 281.898 53.2746C281.513 58.7841 285.666 63.5625 291.175 63.9477C296.684 64.333 301.462 60.1791 301.848 54.6696Z",
            fill: "url(#paint12_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M292.572 43.9965C298.081 44.3819 302.234 49.1603 301.849 54.6697C301.721 56.5024 301.106 58.1844 300.14 59.6L300.327 59.2523C301.468 57.1295 300.037 54.5369 297.632 54.3706L293.662 54.0961C292.675 54.0279 291.93 53.1718 291.999 52.1849L292.278 48.2076C292.446 45.8027 290.075 44.0263 287.814 44.8635L287.485 44.9857C289.013 44.2375 290.753 43.8693 292.572 43.9965Z",
            fill: "url(#paint13_linear_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M292.572 43.9965C298.081 44.3819 302.234 49.1603 301.849 54.6697C301.721 56.5024 301.106 58.1844 300.14 59.6L300.327 59.2523C301.468 57.1295 300.037 54.5369 297.632 54.3706L293.662 54.0961C292.675 54.0279 291.93 53.1718 291.999 52.1849L292.278 48.2076C292.446 45.8027 290.075 44.0263 287.814 44.8635L287.485 44.9857C289.013 44.2375 290.753 43.8693 292.572 43.9965Z",
            fill: "url(#paint14_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M292.572 43.9965C298.081 44.3819 302.234 49.1603 301.849 54.6697C301.721 56.5024 301.106 58.1844 300.14 59.6L300.327 59.2523C301.468 57.1295 300.037 54.5369 297.632 54.3706L293.662 54.0961C292.675 54.0279 291.93 53.1718 291.999 52.1849L292.278 48.2076C292.446 45.8027 290.075 44.0263 287.814 44.8635L287.485 44.9857C289.013 44.2375 290.753 43.8693 292.572 43.9965Z",
            fill: "url(#paint15_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M292.572 43.9965C298.081 44.3819 302.234 49.1603 301.849 54.6697C301.721 56.5024 301.106 58.1844 300.14 59.6L300.327 59.2523C301.468 57.1295 300.037 54.5369 297.632 54.3706L293.662 54.0961C292.675 54.0279 291.93 53.1718 291.999 52.1849L292.278 48.2076C292.446 45.8027 290.075 44.0263 287.814 44.8635L287.485 44.9857C289.013 44.2375 290.753 43.8693 292.572 43.9965Z",
            fill: "url(#paint16_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M292.572 43.9965C298.081 44.3819 302.234 49.1603 301.849 54.6697C301.721 56.5024 301.106 58.1844 300.14 59.6L300.327 59.2523C301.468 57.1295 300.037 54.5369 297.632 54.3706L293.662 54.0961C292.675 54.0279 291.93 53.1718 291.999 52.1849L292.278 48.2076C292.446 45.8027 290.075 44.0263 287.814 44.8635L287.485 44.9857C289.013 44.2375 290.753 43.8693 292.572 43.9965Z",
            fill: "url(#paint17_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M283 52.8159L288.054 53.1693C289.009 53.2361 289.729 54.0643 289.662 55.0193L289.309 60.0736C289.242 61.0287 288.414 61.7486 287.459 61.6818L282.404 61.3284C281.449 61.2616 280.729 60.4334 280.796 59.4784L281.15 54.4241C281.216 53.469 282.045 52.7491 283 52.8159Z",
            fill: "url(#paint18_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M283 52.8159L288.054 53.1693C289.009 53.2361 289.729 54.0643 289.662 55.0193L289.309 60.0736C289.242 61.0287 288.414 61.7486 287.459 61.6818L282.404 61.3284C281.449 61.2616 280.729 60.4334 280.796 59.4784L281.15 54.4241C281.216 53.469 282.045 52.7491 283 52.8159Z",
            fill: "url(#paint19_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M284.755 58.0675L284.644 59.6516L283.549 59.5751L283.889 54.7107L285.581 54.829C286.187 54.8714 286.638 55.0359 286.936 55.3227C287.237 55.6095 287.368 56.013 287.332 56.5331C287.295 57.0691 287.087 57.4749 286.709 57.7508C286.333 58.0267 285.845 58.1437 285.246 58.1018L284.755 58.0675ZM284.925 55.6285L284.813 57.2262L285.271 57.2582C285.542 57.2771 285.757 57.2207 285.913 57.0884C286.07 56.9562 286.158 56.7567 286.177 56.4899C286.194 56.2434 286.135 56.0484 286 55.9047C285.866 55.7613 285.667 55.6804 285.4 55.6617L284.925 55.6285Z",
            fill: "white"
        })));
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "81.5081",
            y: "8",
            width: "160",
            height: "104",
            rx: "12",
            fill: "var(--ds-surface-raised, #FFFFFF)"
        });
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "89.5081",
            y: "16",
            width: "144",
            height: "88",
            rx: "12",
            fill: "var(--ds-surface-sunken, #F8F8F8)"
        });
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            filter: "url(#filter2_dd_70_9506)"
        }, t8, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_70_9506)"
        }, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            opacity: "0.05"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip3_70_9506)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M204.759 40.2357C204 39.0511 203.37 37.9907 202.816 37.0856C202.261 36.1849 201.817 35.4173 201.485 34.7917C200.815 33.5361 200.584 32.8395 200.748 32.7197C200.917 32.5999 201.485 33.0658 202.425 34.1395C202.896 34.6763 203.459 35.3641 204.111 36.2115C204.759 37.0589 205.464 38.0838 206.263 39.2596C207.412 40.9145 208.468 42.6494 209.577 44.3753C210.119 45.2449 210.638 46.1367 211.175 47.0285C211.441 47.4722 211.707 47.9203 211.973 48.3684C212.226 48.8254 212.484 49.2824 212.741 49.7439C214.817 53.4043 216.761 57.2865 218.456 61.4926C220.133 65.6943 221.619 70.2376 222.187 75.2779C222.458 77.7891 222.515 80.4335 222.036 83.1311C221.566 85.8198 220.488 88.5706 218.642 90.9C218.154 91.5877 217.537 92.1334 216.978 92.7102C216.69 92.9853 216.366 93.216 216.069 93.4645C215.762 93.7041 215.474 93.9614 215.146 94.1522C214.507 94.5604 213.894 94.9819 213.242 95.2792C212.923 95.4389 212.603 95.5986 212.293 95.7583C211.969 95.887 211.649 96.0112 211.334 96.1399C208.797 97.1204 206.374 97.5286 204.16 97.7283C199.71 98.0877 196.032 97.6174 192.686 97.014C189.341 96.3839 186.306 95.5454 183.143 94.4761C179.979 93.3979 176.683 92.0846 172.894 90.2655C166.496 87.1908 159.357 82.8205 152.653 77.3233C145.935 71.8482 139.679 65.2373 134.799 58.2448C132.354 54.7575 130.247 51.1903 128.507 47.7029C128.09 46.8244 127.664 45.9637 127.27 45.1074C126.897 44.2422 126.533 43.3903 126.178 42.5562L126.045 42.2412L125.912 41.8862C125.819 41.6511 125.752 41.4115 125.681 41.1719C125.544 40.6927 125.442 40.2091 125.371 39.7255C125.233 38.7582 125.229 37.791 125.34 36.8637C125.57 35.0002 126.285 33.3054 127.341 31.9566L127.531 31.6992L127.758 31.4552C127.913 31.2955 128.064 31.1402 128.219 30.9849C128.383 30.8385 128.574 30.7054 128.752 30.5678C128.929 30.4303 129.111 30.3016 129.324 30.204C129.528 30.0975 129.732 29.9955 129.936 29.9023C130.154 29.8313 130.375 29.7692 130.593 29.7115C130.81 29.6405 131.028 29.6139 131.245 29.6006C131.462 29.5829 131.68 29.5562 131.888 29.5607C132.718 29.6006 133.477 29.7692 134.098 30.0265C134.413 30.1508 134.724 30.275 134.981 30.4303C135.247 30.5767 135.527 30.7098 135.748 30.8695C135.979 31.0248 136.205 31.1757 136.423 31.3177C136.622 31.473 136.818 31.6238 137.004 31.7702C137.386 32.0542 137.683 32.347 137.976 32.6043C139.32 33.8378 140.46 35.1999 141.507 36.6064C142.444 37.862 143.695 39.6944 145.088 42.0681C146.477 44.4418 148.021 47.3568 149.591 50.751C151.162 54.1452 152.781 58.0141 154.321 62.2912C155.865 66.5684 157.351 71.2492 158.616 76.2717C159.872 81.2942 160.954 86.6539 161.433 92.302C161.54 93.7174 161.633 95.1416 161.633 96.5925C161.655 97.3157 161.62 98.0433 161.611 98.7754C161.562 99.5075 161.544 100.24 161.46 100.98C161.327 102.458 161.092 103.949 160.688 105.431C160.284 106.913 159.725 108.399 158.855 109.779C158.629 110.12 158.421 110.471 158.141 110.781C157.879 111.105 157.618 111.429 157.303 111.713L156.846 112.152C156.681 112.286 156.508 112.41 156.335 112.538C156.167 112.663 155.985 112.8 155.83 112.907L155.395 113.195C154.818 113.586 154.259 113.998 153.718 114.429L153.314 114.757L152.844 115.121L152.364 115.489C152.2 115.604 152.027 115.711 151.859 115.822C150.505 116.7 149.006 117.339 147.466 117.738C145.927 118.142 144.347 118.315 142.794 118.324C139.679 118.337 136.654 117.747 133.787 116.86C130.917 115.981 128.188 114.801 125.584 113.479C121.914 111.589 118.622 109.446 115.641 107.214C112.664 104.974 109.997 102.635 107.65 100.222C105.312 97.7993 103.266 95.3147 101.713 92.6171C100.955 91.2549 100.307 89.844 99.9786 88.2689C99.8189 87.4836 99.7612 86.6406 99.881 85.7799C99.9875 84.9236 100.347 84.0318 100.906 83.3396C101.461 82.6519 102.153 82.1106 102.849 81.7912C103.022 81.6936 103.195 81.6181 103.368 81.556C103.541 81.4895 103.714 81.4229 103.887 81.3563C104.229 81.2543 104.571 81.1611 104.908 81.0813C106.261 80.7973 107.623 80.7663 108.888 80.9792C111.435 81.383 113.569 82.6386 115.108 84.1604C115.303 84.3468 115.481 84.5553 115.663 84.7461C115.836 84.9369 115.978 85.1188 116.133 85.3007C116.444 85.6601 116.728 86.0283 117.012 86.3833C117.575 87.0932 118.09 87.7898 118.569 88.4597C119.523 89.7997 120.326 91.0508 121.023 92.1822C124.292 97.5464 126.684 102.933 128.49 108.195C130.273 113.466 131.462 118.648 131.822 123.755C131.986 126.306 131.955 128.839 131.56 131.32C131.183 133.791 130.429 136.227 129.138 138.383C127.86 140.539 125.983 142.358 123.782 143.477C122.691 144.04 121.542 144.466 120.375 144.754C119.208 145.025 118.028 145.207 116.852 145.273C115.561 145.344 114.434 145.296 113.484 145.194C113.01 145.132 112.575 145.087 112.18 145.016C111.789 144.941 111.439 144.87 111.128 144.799C109.895 144.484 109.314 144.195 109.345 144.022C109.376 143.84 110.019 143.774 111.257 143.792C111.869 143.796 112.637 143.805 113.555 143.809C114.469 143.809 115.53 143.783 116.728 143.676C117.819 143.583 118.893 143.379 119.94 143.108C120.983 142.815 121.985 142.412 122.926 141.893C124.812 140.868 126.36 139.288 127.434 137.389C128.516 135.49 129.155 133.298 129.457 131.013C129.776 128.728 129.772 126.346 129.577 123.928C129.164 119.083 127.966 114.087 126.2 108.989C124.412 103.9 122.061 98.6645 118.897 93.4911C118.281 92.4884 117.557 91.3614 116.692 90.1546C115.831 88.9567 114.82 87.6256 113.657 86.3389C112.566 85.1587 111.04 84.1471 109.225 83.7167C108.32 83.5038 107.353 83.4106 106.377 83.5348C105.888 83.5792 105.396 83.699 104.921 83.841C104.673 83.8987 104.473 84.014 104.242 84.0939C104.131 84.1382 104.043 84.2048 103.941 84.2536C103.843 84.3068 103.732 84.3557 103.657 84.4266C103.28 84.6618 103.036 84.9724 102.84 85.3096C102.805 85.4027 102.738 85.4782 102.716 85.5758C102.69 85.6734 102.658 85.771 102.623 85.8686C102.592 86.086 102.539 86.2945 102.548 86.5386C102.521 86.7693 102.57 87.0311 102.583 87.284C102.636 87.5457 102.663 87.8075 102.752 88.0826C102.88 88.6283 103.111 89.1874 103.351 89.7464C104.389 92.0003 106.053 94.2365 107.969 96.3972C109.895 98.5668 112.127 100.665 114.589 102.698C117.052 104.73 119.754 106.677 122.686 108.479C124.594 109.655 126.56 110.737 128.57 111.7C130.575 112.663 132.625 113.515 134.715 114.176C135.837 114.544 136.986 114.846 138.153 115.085C139.32 115.334 140.5 115.493 141.689 115.56C144.059 115.711 146.463 115.436 148.615 114.544C149.689 114.1 150.701 113.506 151.606 112.765C152.129 112.334 152.666 111.922 153.221 111.531C153.496 111.336 153.775 111.145 154.055 110.959L154.481 110.684L154.809 110.44C156.571 109.158 157.684 106.952 158.279 104.619C158.452 104.042 158.549 103.434 158.678 102.84C158.762 102.232 158.878 101.633 158.926 101.016C159.073 99.7959 159.108 98.558 159.135 97.3245C159.157 94.8577 158.975 92.4041 158.7 90.0038C158.132 85.2031 157.174 80.611 156.078 76.3738C153.882 67.895 151.189 60.8093 149.086 55.8978C148.03 53.4397 147.129 51.5142 146.481 50.2097C146.166 49.5531 145.904 49.0562 145.736 48.719C145.563 48.3818 145.474 48.2043 145.474 48.2043C145.474 48.2043 145.336 47.9425 145.079 47.45C144.822 46.9531 144.436 46.2254 143.921 45.3026C142.887 43.4613 141.361 40.7948 139.107 37.8354C137.976 36.3757 136.649 34.8183 135.016 33.5627C134.204 32.9549 133.295 32.4313 132.399 32.245C131.502 32.0764 130.704 32.2849 129.967 32.9327C129.248 33.6026 128.61 34.6098 128.241 35.6835C127.873 36.7661 127.735 37.9596 127.864 39.1531C127.926 39.7477 128.055 40.3466 128.25 40.9279L128.405 41.3627L128.605 41.8374C128.738 42.1524 128.871 42.4719 129.004 42.7913C129.28 43.4258 129.524 44.078 129.83 44.708C130.127 45.3425 130.429 45.9814 130.73 46.6203C131.99 49.1626 133.37 51.7138 134.963 54.1807C135.726 55.4363 136.587 56.6343 137.421 57.8588C137.851 58.4623 138.304 59.0524 138.743 59.6513L139.409 60.5476L140.105 61.4172C143.788 66.0936 147.99 70.3707 152.333 74.1554C161.061 81.698 170.431 87.0444 177.73 90.1014C180.472 91.2816 183.103 92.2089 185.592 92.972C186.834 93.3669 188.054 93.6686 189.23 93.9792C189.82 94.1211 190.401 94.2409 190.974 94.3696C191.546 94.5027 192.11 94.6092 192.664 94.7024C197.101 95.5276 200.979 95.643 204.249 95.3235C207.523 94.9908 210.168 94.1345 212.213 93.0607C214.263 91.9781 215.691 90.656 216.707 89.3693C218.256 87.4126 219.192 85.0833 219.622 82.7052C220.057 80.3181 220.022 77.8956 219.782 75.553C219.285 70.8499 217.914 66.453 216.335 62.3534C214.742 58.2493 212.901 54.407 210.931 50.7643C210.687 50.3073 210.447 49.8503 210.203 49.3978C209.95 48.9497 209.697 48.5015 209.444 48.0579C208.934 47.1705 208.446 46.2787 207.931 45.4046C206.871 43.6743 205.877 41.9306 204.781 40.2623L204.759 40.2357Z",
            fill: "var(--ds-text, #292A2E)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M106.008 44.545L113.008 36L121.008 41V47.25C121.008 48.215 120.223 49 119.258 49H109.008C107.353 49 106.008 47.655 106.008 46V44.545Z",
            fill: "url(#paint20_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M106.008 38.52C106.008 37.275 107.013 36.27 108.258 36.27H118.453L121.008 35V41.25C121.008 42.215 120.223 43 119.258 43H109.008C107.353 43 106.008 44.345 106.008 46V38.52Z",
            fill: "url(#paint21_linear_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M106.008 38.52C106.008 37.275 107.013 36.27 108.258 36.27H118.453L121.008 35V41.25C121.008 42.215 120.223 43 119.258 43H109.008C107.353 43 106.008 44.345 106.008 46V38.52Z",
            fill: "url(#paint22_radial_70_9506)",
            fillOpacity: "0.6"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M106.008 38.52C106.008 37.275 107.013 36.27 108.258 36.27H118.453L121.008 35V41.25C121.008 42.215 120.223 43 119.258 43H109.008C107.353 43 106.008 44.345 106.008 46V38.52Z",
            fill: "url(#paint23_radial_70_9506)",
            fillOpacity: "0.1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M106.008 34C106.008 32.345 107.353 31 109.008 31H119.258C120.223 31 121.008 31.785 121.008 32.75V35.25C121.008 36.215 120.223 37 119.258 37H109.008C107.353 37 106.008 38.345 106.008 40V34Z",
            fill: "url(#paint24_linear_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M106.008 34C106.008 32.345 107.353 31 109.008 31H119.258C120.223 31 121.008 31.785 121.008 32.75V35.25C121.008 36.215 120.223 37 119.258 37H109.008C107.353 37 106.008 38.345 106.008 40V34Z",
            fill: "url(#paint25_radial_70_9506)",
            fillOpacity: "0.8"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M109.883 39.5H105.133C104.236 39.5 103.508 40.2275 103.508 41.125V45.875C103.508 46.7725 104.236 47.5 105.133 47.5H109.883C110.781 47.5 111.508 46.7725 111.508 45.875V41.125C111.508 40.2275 110.781 39.5 109.883 39.5Z",
            fill: "url(#paint26_radial_70_9506)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M109.883 39.5H105.133C104.236 39.5 103.508 40.2275 103.508 41.125V45.875C103.508 46.7725 104.236 47.5 105.133 47.5H109.883C110.781 47.5 111.508 46.7725 111.508 45.875V41.125C111.508 40.2275 110.781 39.5 109.883 39.5Z",
            fill: "url(#paint27_radial_70_9506)",
            fillOpacity: "0.65"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M110.253 41.2157L109.268 45.7857H108.093L107.513 43.0457L106.903 45.7907H105.713L104.768 41.2207H105.738L106.323 44.2357L106.903 41.2207H108.093L108.698 44.2357L109.268 41.2207H110.253V41.2157Z",
            fill: "white"
        })));
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: "filter0_dd_70_9506",
            x: "-1.12427",
            y: "4.29492",
            width: "182.865",
            height: "130.908",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_70_9506"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "0.5"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "effect1_dropShadow_70_9506",
            result: "effect2_dropShadow_70_9506"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect2_dropShadow_70_9506",
            result: "shape"
        }));
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: "filter1_dd_70_9506",
            x: "151.133",
            y: "5.11914",
            width: "182.865",
            height: "130.908",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_70_9506"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "0.5"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "effect1_dropShadow_70_9506",
            result: "effect2_dropShadow_70_9506"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect2_dropShadow_70_9506",
            result: "shape"
        }));
        $[11] = t12;
    } else t12 = $[11];
    let t13;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: "filter2_dd_70_9506",
            x: "73.5081",
            y: "0",
            width: "176",
            height: "120",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_70_9506"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "0.5"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in2: "effect1_dropShadow_70_9506",
            result: "effect2_dropShadow_70_9506"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect2_dropShadow_70_9506",
            result: "shape"
        }));
        $[12] = t13;
    } else t13 = $[12];
    let t14;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint0_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(-15.5626 -14.2405 -11.0448 12.0756 49.4818 62.9869)",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.06",
            stopColor: "#379539"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.42",
            stopColor: "#297C2D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.7",
            stopColor: "#15561C"
        }));
        $[13] = t14;
    } else t14 = $[13];
    let t15;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint1_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(-6.54327 -5.49824 -4.2529 5.06355 37.989 53.1246)",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#073B10",
            stopOpacity: "0.698039"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.99",
            stopColor: "#084A13",
            stopOpacity: "0"
        }));
        $[14] = t15;
    } else t15 = $[14];
    let t16;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint2_linear_70_9506",
            x1: "33.4702",
            y1: "55.2167",
            x2: "40.5224",
            y2: "54.7235",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#52D17C"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.33",
            stopColor: "#4AA647"
        }));
        $[15] = t16;
    } else t16 = $[15];
    let t17;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint3_linear_70_9506",
            x1: "37.7525",
            y1: "50.2893",
            x2: "38.1999",
            y2: "56.6871",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#29852F",
            stopOpacity: "0.301961"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.5",
            stopColor: "#4AA647",
            stopOpacity: "0"
        }));
        $[16] = t17;
    } else t17 = $[16];
    let t18;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint4_linear_70_9506",
            x1: "33.6538",
            y1: "51.9864",
            x2: "41.6471",
            y2: "44.0109",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#66D052"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "#85E972"
        }));
        $[17] = t18;
    } else t18 = $[17];
    let t19;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint5_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(41.961 47.6412) rotate(176) scale(4.62729 9.79324)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.29",
            stopColor: "#4EB43B"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "#72CC61",
            stopOpacity: "0"
        }));
        $[18] = t19;
    } else t19 = $[18];
    let t20;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint6_linear_70_9506",
            x1: "37.1923",
            y1: "48.7852",
            x2: "33.0408",
            y2: "49.0755",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.18",
            stopColor: "#C0E075",
            stopOpacity: "0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "#D1EB95"
        }));
        $[19] = t20;
    } else t20 = $[19];
    let t21;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint7_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(-9.14219 -6.39668 6.37744 -9.11809 49.642 50.3988)",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.44",
            stopColor: "#79E96D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "#D0EB76"
        }));
        $[20] = t21;
    } else t21 = $[20];
    let t22;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint8_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(8.75643 7.61453 21.6761 -24.9391 31.0129 53.3767)",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#20A85E"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.94",
            stopColor: "#09442A"
        }));
        $[21] = t22;
    } else t22 = $[21];
    let t23;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint9_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(35.299 57.9698) rotate(86) scale(5.74564 6.61775)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.58",
            stopColor: "#33A662",
            stopOpacity: "0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.97",
            stopColor: "#98F0B0",
            stopOpacity: "0.301961"
        }));
        $[22] = t23;
    } else t23 = $[22];
    let t24;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint10_linear_70_9506",
            x1: "291.603",
            y1: "43.2906",
            x2: "278.563",
            y2: "54.1282",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.0582736",
            stopColor: "#FF7F48"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "#E5495B"
        }));
        $[23] = t24;
    } else t24 = $[23];
    let t25;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint11_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(296.109 50.0611) rotate(139) scale(20.0775 33.7931)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.151523",
            stopColor: "#AA1D2D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.380855",
            stopColor: "#D12B18",
            stopOpacity: "0.439216"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.601996",
            stopColor: "#FF3C00",
            stopOpacity: "0"
        }));
        $[24] = t25;
    } else t25 = $[24];
    let t26;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint12_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(277.849 61.14) rotate(-21.2832) scale(19.0325 34.4801)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.4067",
            stopColor: "#FF66FB",
            stopOpacity: "0.501961"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "#EA3D01",
            stopOpacity: "0"
        }));
        $[25] = t26;
    } else t26 = $[25];
    let t27;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint13_linear_70_9506",
            x1: "293.607",
            y1: "56.324",
            x2: "304.9",
            y2: "49.1173",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.310768",
            stopColor: "#FF6E30"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.634576",
            stopColor: "#FFA05C"
        }));
        $[26] = t27;
    } else t27 = $[26];
    let t28;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint14_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(290.115 55.0478) rotate(15.8349) scale(12.9275 12.3244)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.78593",
            stopColor: "#FFA05C",
            stopOpacity: "0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.904889",
            stopColor: "#FFCE84"
        }));
        $[27] = t28;
    } else t28 = $[27];
    let t29;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint15_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(292.232 53.8468) rotate(-29.1977) scale(13.0536 12.4833)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.295239",
            stopColor: "#FF99E9",
            stopOpacity: "0.8"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.727968",
            stopColor: "#FF99E9",
            stopOpacity: "0"
        }));
        $[28] = t29;
    } else t29 = $[28];
    let t30;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint16_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(290.663 55.2675) rotate(-44.864) scale(13.8981 12.6929)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#FD6EF9"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.637205",
            stopColor: "#FF9944"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.85186",
            stopColor: "#FCC479"
        }));
        $[29] = t30;
    } else t30 = $[29];
    let t31;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint17_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(290.457 45.1735) rotate(102.395) scale(7.07381 15.9869)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.144283",
            stopColor: "#FF8D13"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.537266",
            stopColor: "#FF7F29",
            stopOpacity: "0"
        }));
        $[30] = t31;
    } else t31 = $[30];
    let t32;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint18_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(281.269 52.6949) rotate(49) scale(12.0679)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#F8193E"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.939062",
            stopColor: "#920616"
        }));
        $[31] = t32;
    } else t32 = $[31];
    let t33;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint19_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(285.169 58.1) rotate(94) scale(5.97333 6.8)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.575893",
            stopColor: "#FFB055",
            stopOpacity: "0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.973806",
            stopColor: "#FFF2BE",
            stopOpacity: "0.301961"
        }));
        $[32] = t33;
    } else t33 = $[32];
    let t34;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint20_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(121.565 48.882) scale(23.785 10.075)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.18",
            stopColor: "#1657F4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.57",
            stopColor: "#0036C4"
        }));
        $[33] = t34;
    } else t34 = $[33];
    let t35;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint21_linear_70_9506",
            x1: "106.008",
            y1: "40.5",
            x2: "117.493",
            y2: "40.5",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#66C0FF"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.26",
            stopColor: "#0094F0"
        }));
        $[34] = t35;
    } else t35 = $[34];
    let t36;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint22_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(119.76 38.0381) rotate(133.55) scale(14.68 36.16)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.14",
            stopColor: "#D471FF"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.83",
            stopColor: "#509DF5",
            stopOpacity: "0"
        }));
        $[35] = t36;
    } else t36 = $[35];
    let t37;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t37 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint23_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(119.422 41.2494) rotate(90) scale(9.31 50.825)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.28",
            stopColor: "#4F006F",
            stopOpacity: "0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "#4F006F"
        }));
        $[36] = t37;
    } else t37 = $[36];
    let t38;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint24_linear_70_9506",
            x1: "106.008",
            y1: "35.39",
            x2: "121.008",
            y2: "35.64",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#9DEAFF"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.2",
            stopColor: "#3BD5FF"
        }));
        $[37] = t38;
    } else t38 = $[37];
    let t39;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t39 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint25_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(120.513 29.4736) rotate(166.85) scale(14.745 35.32)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.06",
            stopColor: "#E4A7FE"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.54",
            stopColor: "#E4A7FE",
            stopOpacity: "0"
        }));
        $[38] = t39;
    } else t39 = $[38];
    let t40;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t40 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint26_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(103.42 38.4355) rotate(45) scale(11.315)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.08",
            stopColor: "#367AF2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.87",
            stopColor: "#001A8F"
        }));
        $[39] = t40;
    } else t40 = $[39];
    let t41;
    if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
        t41 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint27_radial_70_9506",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(108.925 44.276) rotate(90) scale(5.6 6.385)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.59",
            stopColor: "#2763E5",
            stopOpacity: "0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.97",
            stopColor: "#58AAFE"
        }));
        $[40] = t41;
    } else t41 = $[40];
    let t42;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t42 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_70_9506"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "6.87573",
            y: "23.4559",
            width: "160",
            height: "104",
            rx: "12",
            transform: "rotate(-4 6.87573 23.4559)",
            fill: "white"
        }));
        $[41] = t42;
    } else t42 = $[41];
    let t43;
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
        t43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_70_9506"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "166.388",
            y: "13.1191",
            width: "160",
            height: "104",
            rx: "12",
            transform: "rotate(4 166.388 13.1191)",
            fill: "white"
        }));
        $[42] = t43;
    } else t43 = $[42];
    let t44;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t44 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_70_9506"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "89.5081",
            y: "16",
            width: "144",
            height: "88",
            rx: "12",
            fill: "white"
        }));
        $[43] = t44;
    } else t44 = $[43];
    let t45;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t45 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t11, t12, t13, t14, t15, t16, t17, t18, t19, t20, t21, t22, t23, t24, t25, t26, t27, t28, t29, t30, t31, t32, t33, t34, t35, t36, t37, t38, t39, t40, t41, t42, t43, t44, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip3_70_9506"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "122.577",
            height: "115.757",
            fill: "white",
            transform: "matrix(-1 0 0 1 222.396 29.5563)"
        })));
        $[44] = t45;
    } else t45 = $[44];
    let t46;
    if ($[45] !== testId) {
        t46 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "333",
            height: "135",
            viewBox: "0 0 333 135",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            "data-testid": testId,
            className: t1
        }, t4, t7, t10, t45);
        $[45] = testId;
        $[46] = t46;
    } else t46 = $[46];
    return t46;
};


// Products whose stack shows one logo per card, so each ships its own artwork.
const $3af8cc4e150a6e0a$var$bespokeCardStacks = {
    drive: (0, $6761756d86ac1d92$export$5bbc52ae928d0392),
    sharepoint: (0, $2aea9f1687f7ee64$export$fa4931584e43eea)
};
const $3af8cc4e150a6e0a$export$c09a8d1c07bbbaa5 = (appId)=>$3af8cc4e150a6e0a$var$bespokeCardStacks[appId] ?? (0, $0cf97f3e681d0132$export$f41806ed7e476830);
const $3af8cc4e150a6e0a$export$cb1b4d66a6f4792c = (appId)=>!(appId in $3af8cc4e150a6e0a$var$bespokeCardStacks);





const $21000665fab0f571$export$3bcf7713e55466a2 = (0, $kSwu1.defineMessages)({
    connectCta: {
        id: "experiment-related-content-connections.prompt-card.connect-cta",
        defaultMessage: "Supercharge your recommendations and search results by connecting {appName}"
    },
    connectSuccessTitle: {
        id: "experiment-related-content-connections.prompt-card.connect-success.title",
        defaultMessage: "Connected to {appName}"
    },
    connectSuccessDescription: {
        id: "experiment-related-content-connections.prompt-card.connect-success.description",
        defaultMessage: "Now you can access your {appName} content without leaving Confluence"
    },
    connectSuccessConnectMoreApps: {
        id: "experiment-related-content-connections.prompt-card.connect-success.connect-more-apps",
        defaultMessage: "Connect more apps"
    },
    connectErrorTitle: {
        id: "experiment-related-content-connections.prompt-card.connect-error.title",
        defaultMessage: "Couldn\u2019t connect to {appName}"
    },
    connectErrorDescription: {
        id: "experiment-related-content-connections.prompt-card.connect-error.description",
        defaultMessage: "We couldn\u2019t connect to {appName}. Please try connecting your account again."
    },
    connectErrorTryAgain: {
        id: "experiment-related-content-connections.prompt-card.connect-error.try-again",
        defaultMessage: "Try again"
    }
});


// Geometry shared by the prompt card, its skeleton, and their tests. Used as element attributes and
// props, not inside styles — style values are restated as local literals per component, because
// `ui-styling-standard/no-imported-style-values` bans imported values there.
const $1c9acfdcde48d614$export$eaa4687bc053c129 = 2;
const $1c9acfdcde48d614$export$a815dc25d1c899a0 = 24;
const $1c9acfdcde48d614$export$b68d5d4095dbd713 = 'space.100';
const $1c9acfdcde48d614$export$1093249ca96bf785 = 333;
const $1c9acfdcde48d614$export$584df2fa9ba8d40e = 135;
const $1c9acfdcde48d614$export$fffd1ecf4e179973 = 24;


const $9f4b8ce466873861$var$CONNECT_MORE_APPS_SURFACE = 'confluence-related-content-connections';
const $9f4b8ce466873861$var$APPS_TAB_ID = 'discovery';
const $9f4b8ce466873861$var$RegisterOpenModal = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { open: open, onRegister: onRegister } = t0;
    let t1;
    let t2;
    if ($[0] !== onRegister || $[1] !== open) {
        t1 = ()=>{
            onRegister(open);
            return ()=>onRegister(null);
        };
        t2 = [
            open,
            onRegister
        ];
        $[0] = onRegister;
        $[1] = open;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
};
// Style values must be local literals: `ui-styling-standard/no-imported-style-values` rejects
// imported constants in styles, including the `style` prop.
const $9f4b8ce466873861$var$CARD_HEIGHT = 68;
const $9f4b8ce466873861$var$STACK_WIDTH = 333; // How far the clip reaches into the card, hiding the artwork's card feet behind it (incl. ~8px bleed).
const $9f4b8ce466873861$var$STACK_OVERLAP = 48;
const $9f4b8ce466873861$var$STACK_ASPECT = '333 / 135';
const $9f4b8ce466873861$var$STACK_ICON_TOP = '20.74%';
const $9f4b8ce466873861$var$STACK_ICON_LEFT = '30.48%';
const $9f4b8ce466873861$var$STACK_ICON_WIDTH = '7.21%';
const $9f4b8ce466873861$var$STACK_ICON_HEIGHT = '17.78%'; // The artwork slides up from behind the card on hover and focus. State and an inline transform drive
// it, because `cssMap` types reject a custom property inside a pseudo block.
const $9f4b8ce466873861$var$styles = {
    wrapper: "_1mT5xdRAKS _39xV02N91d",
    stackClip: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _0Bm75Gc2az _3OE6xY715P _1VJPcajssS _39xV02ph9c _1EqgXlN91d _3v5uP0JBku _1pp6NdYbGa",
    stackLayerRaised: "_23rrnHYb1T _1mT5xdRAKS _39xV02N91d _1SdfoHYbGa",
    stackLayerLowered: "_23rrnHtzU4 _1mT5xdRAKS _39xV02N91d _1SdfoHYbGa",
    stackIcon: "_1mT5xdWVPG _2IhTonWLd5 _3OE6xYtL8w _39xV02BI5g _0jFU0V2Xfq",
    card: "_4FKVYE2ADO _0bjKvD8fU6 _3vBAKH9r67 _3hxITisurO _2V7sgONvrM _1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _0jFU0VN91d _0KLXrulfZc _24h04i2Njc _1UtDYzy7kJ _2fwxA5ecOK _0wOv4Q7zJH _3fSdSTFYNq",
    icon: "_3YEZNOdnbC",
    row: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT",
    label: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbgJ9S _1U1ZhbbI28 _4Gn54RiZR3"
};
const $9f4b8ce466873861$var$PromoCard = ({ product: product, status: status, onConnect: onConnect, showCardAsListitem: showCardAsListitem = true, testId: testId = 'third-party-related-content-promo-card', flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [isRaised, setIsRaised] = (0, $cozmU.useState)(false);
    const { appId: appId, displayName: displayName, iconUrl: iconUrl } = product;
    const isConnecting = status === (0, $fac5703f4bfe6f64$export$863e19ab03ac3107).CONNECTING;
    const raise = (0, $cozmU.useCallback)(()=>setIsRaised(true), []);
    const lower = (0, $cozmU.useCallback)(()=>setIsRaised(false), []); // The error flag's "Try again" reruns the flow. The ref lets the flag call the latest `onConnect`
    // without the effect depending on it.
    const connectRef = (0, $cozmU.useRef)(onConnect);
    connectRef.current = onConnect;
    const openModalRef = (0, $cozmU.useRef)(null);
    const registerOpenModal = (0, $cozmU.useCallback)((open)=>{
        openModalRef.current = open;
    }, []);
    const openUniversalConnectorModal = (0, $cozmU.useCallback)(()=>{
        openModalRef.current?.({
            defaultTab: $9f4b8ce466873861$var$APPS_TAB_ID
        });
    }, []); // The flags follow the state machine, as `create-space`'s ConnectorRow does. A cancelled window
    // returns the status to idle, so neither transition fires and the card stays as it was.
    const previousStatusRef = (0, $cozmU.useRef)(status);
    (0, $cozmU.useEffect)(()=>{
        const wasConnecting = previousStatusRef.current === (0, $fac5703f4bfe6f64$export$863e19ab03ac3107).CONNECTING;
        previousStatusRef.current = status;
        if (!wasConnecting) return;
        if (status === (0, $fac5703f4bfe6f64$export$863e19ab03ac3107).CONNECTED) {
            flags.showSuccessFlag({
                title: formatMessage((0, $21000665fab0f571$export$3bcf7713e55466a2).connectSuccessTitle, {
                    appName: displayName
                }),
                description: formatMessage((0, $21000665fab0f571$export$3bcf7713e55466a2).connectSuccessDescription, {
                    appName: displayName
                }),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $21000665fab0f571$export$3bcf7713e55466a2).connectSuccessConnectMoreApps),
                        onClick: openUniversalConnectorModal
                    }
                ]
            });
            return;
        }
        if (status === (0, $fac5703f4bfe6f64$export$863e19ab03ac3107).ERROR) flags.showErrorFlag({
            title: formatMessage((0, $21000665fab0f571$export$3bcf7713e55466a2).connectErrorTitle, {
                appName: displayName
            }),
            description: formatMessage((0, $21000665fab0f571$export$3bcf7713e55466a2).connectErrorDescription, {
                appName: displayName
            }),
            actions: [
                {
                    content: formatMessage((0, $21000665fab0f571$export$3bcf7713e55466a2).connectErrorTryAgain),
                    onClick: ()=>connectRef.current()
                }
            ]
        });
    }, [
        displayName,
        flags,
        formatMessage,
        openUniversalConnectorModal,
        status
    ]);
    const CardStack = (0, $3af8cc4e150a6e0a$export$c09a8d1c07bbbaa5)(appId);
    const label = formatMessage((0, $21000665fab0f571$export$3bcf7713e55466a2).connectCta, {
        appName: displayName
    }); // Success replaces the prompt.
    const card = status === (0, $fac5703f4bfe6f64$export$863e19ab03ac3107).CONNECTED ? null : /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            height: `${$9f4b8ce466873861$var$CARD_HEIGHT}px`
        },
        role: showCardAsListitem ? 'listitem' : undefined,
        onMouseEnter: raise,
        onMouseLeave: lower,
        onFocus: raise,
        onBlur: lower,
        "data-testid": `${testId}-wrapper`,
        className: (0, $hekY6.default)([
            $9f4b8ce466873861$var$styles.wrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": true,
        "data-testid": `${testId}-stack-clip`,
        className: (0, $hekY6.default)([
            $9f4b8ce466873861$var$styles.stackClip
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            transform: `translateY(${isRaised ? '0%' : '100%'})`,
            opacity: isRaised ? 1 : 0
        },
        "data-testid": `${testId}-stack-layer`,
        className: (0, $hekY6.default)([
            $9f4b8ce466873861$var$styles[isRaised ? 'stackLayerRaised' : 'stackLayerLowered']
        ])
    }, /*#__PURE__*/ $cozmU.createElement(CardStack, {
        testId: `${testId}-stack`
    }), (0, $3af8cc4e150a6e0a$export$cb1b4d66a6f4792c)(appId) && iconUrl && /*#__PURE__*/ $cozmU.createElement("img", {
        src: iconUrl,
        alt: "",
        width: (0, $1c9acfdcde48d614$export$fffd1ecf4e179973),
        height: (0, $1c9acfdcde48d614$export$fffd1ecf4e179973),
        "data-testid": `${testId}-stack-icon`,
        className: (0, $hekY6.default)([
            $9f4b8ce466873861$var$styles.stackIcon
        ])
    }))), /*#__PURE__*/ $cozmU.createElement("button", {
        type: "button",
        onClick: onConnect,
        disabled: isConnecting,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $9f4b8ce466873861$var$styles.card
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $9f4b8ce466873861$var$styles.row
        ])
    }, iconUrl ? /*#__PURE__*/ $cozmU.createElement("img", {
        src: iconUrl,
        alt: "",
        width: (0, $1c9acfdcde48d614$export$a815dc25d1c899a0),
        height: (0, $1c9acfdcde48d614$export$a815dc25d1c899a0),
        "data-testid": `${testId}-icon`,
        className: (0, $hekY6.default)([
            $9f4b8ce466873861$var$styles.icon
        ])
    }) : // Fallback when a product has no icon, matching Figma node 72:10938.
    /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ9If))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        testId: `${testId}-icon-fallback`
    }), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $9f4b8ce466873861$var$styles.label
        ])
    }, label)))); // The host renders no markup of its own and loads the modal only on the first open, so keeping it
    // mounted past success costs a component, not a chunk.
    return /*#__PURE__*/ $cozmU.createElement((0, $ez9xU.RovoSettingsModal), {
        product: "confluence",
        cloudId: cloudId,
        surface: $9f4b8ce466873861$var$CONNECT_MORE_APPS_SURFACE
    }, ({ open: open_0 })=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement($9f4b8ce466873861$var$RegisterOpenModal, {
            open: open_0,
            onRegister: registerOpenModal
        }), card));
};
const $9f4b8ce466873861$export$58286e4ca8c16000 = (0, $7aRa9.withFlags)($9f4b8ce466873861$var$PromoCard);












var $a9aSv = parcelRequire("a9aSv");


var $e4o8D = parcelRequire("e4o8D");


const $3ddbe371db1d7d75$var$TITLE_PLACEHOLDER_WIDTH = '60%';
const $3ddbe371db1d7d75$var$TITLE_PLACEHOLDER_HEIGHT = 12; // Matches the card's 68px border box. Local because styles cannot import values.
const $3ddbe371db1d7d75$var$CARD_HEIGHT = 68;
const $3ddbe371db1d7d75$var$styles = {
    card: "_2mHwu82ADO _4FKVYE2ADO _0bjKvD8fU6 _3vBAKH9r67 _3hxITisurO _2V7sgONvrM _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _0KLXrulfZc _24h04i2Njc",
    title: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG"
}; // Holds the prompt card's place while several products wait for the document chooser. No artwork,
const $3ddbe371db1d7d75$export$da0df8956ee4e28a = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { testId: t1 } = t0;
    const testId = t1 === undefined ? "third-party-related-content-promo-card-skeleton" : t1;
    const isShimmering = !(0, $e4o8D.useRenderServerPlaceholder)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            height: `${$3ddbe371db1d7d75$var$CARD_HEIGHT}px`
        };
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $3ddbe371db1d7d75$var$styles.card
        ]);
        $[1] = t3;
    } else t3 = $[1];
    const t4 = `${testId}-icon`;
    let t5;
    if ($[2] !== isShimmering || $[3] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: `${(0, $1c9acfdcde48d614$export$a815dc25d1c899a0)}px`,
            height: `${(0, $1c9acfdcde48d614$export$a815dc25d1c899a0)}px`,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: isShimmering,
            testId: t4
        });
        $[2] = isShimmering;
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $3ddbe371db1d7d75$var$styles.title
        ]);
        $[5] = t6;
    } else t6 = $[5];
    const t7 = `${testId}-title`;
    let t8;
    if ($[6] !== isShimmering || $[7] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t6
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: $3ddbe371db1d7d75$var$TITLE_PLACEHOLDER_WIDTH,
            height: `${$3ddbe371db1d7d75$var$TITLE_PLACEHOLDER_HEIGHT}px`,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: isShimmering,
            testId: t7
        }));
        $[6] = isShimmering;
        $[7] = t7;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t5 || $[10] !== t8 || $[11] !== testId) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t2,
            "aria-hidden": true,
            "data-testid": testId,
            className: t3
        }, t5, t8);
        $[9] = t5;
        $[10] = t8;
        $[11] = testId;
        $[12] = t9;
    } else t9 = $[12];
    return t9;
};






var $jjosg = parcelRequire("jjosg");


var $aoy1P = parcelRequire("aoy1P");


var $kQgL7 = parcelRequire("kQgL7");





var $eEPSE = parcelRequire("eEPSE");


var $7zxJs = parcelRequire("7zxJs");


var $i9pyX = parcelRequire("i9pyX");


const $3c744fefcee877cb$var$AUTH_ERROR_TYPE = {
    AUTH_WINDOW_CLOSED: 'auth_window_closed',
    WINDOW_BLOCKED: 'window_blocked'
};
const $3c744fefcee877cb$var$CONNECTOR_OAUTH_WINDOW_WIDTH = 800;
const $3c744fefcee877cb$var$CONNECTOR_OAUTH_WINDOW_HEIGHT = 800;
const $3c744fefcee877cb$var$getBrowserWindowMetrics = ()=>({
        outerHeight: window.outerHeight,
        outerWidth: window.outerWidth,
        screenX: window.screenX,
        screenY: window.screenY
    });
const $3c744fefcee877cb$export$41d621931d4a5649 = ({ outerHeight: outerHeight, outerWidth: outerWidth, screenX: screenX, screenY: screenY })=>{
    const left = Math.round(screenX + (outerWidth - $3c744fefcee877cb$var$CONNECTOR_OAUTH_WINDOW_WIDTH) / 2);
    const top = Math.round(screenY + (outerHeight - $3c744fefcee877cb$var$CONNECTOR_OAUTH_WINDOW_HEIGHT) / 2);
    return `popup=yes,width=${$3c744fefcee877cb$var$CONNECTOR_OAUTH_WINDOW_WIDTH},height=${$3c744fefcee877cb$var$CONNECTOR_OAUTH_WINDOW_HEIGHT},left=${left},top=${top},status=no,resizable=yes,scrollbars=yes`;
};
const $3c744fefcee877cb$var$getAuthErrorType = (authError)=>authError instanceof (0, $7zxJs.AuthError) ? authError.type : undefined;
const $3c744fefcee877cb$var$getError = (error)=>error instanceof Error ? error : new Error('Unknown connector OAuth error');
const $3c744fefcee877cb$var$getInitialStatus = (userNeedsOAuth)=>userNeedsOAuth === false ? (0, $fac5703f4bfe6f64$export$863e19ab03ac3107).CONNECTED : (0, $fac5703f4bfe6f64$export$863e19ab03ac3107).IDLE;
const $3c744fefcee877cb$var$markConnectorAsAuthed = (config, resourceType)=>config.map((resource)=>resource.type === resourceType ? {
            ...resource,
            isUserOAuthed: true,
            userNeedsOAuth: false
        } : resource);
const $3c744fefcee877cb$export$251c4f89f010321a = ({ connector: connector, cloudId: cloudId, userId: userId, onLifecycleEvent: onLifecycleEvent })=>{
    const { outboundAuthUrl: outboundAuthUrl, productKey: productKey, resourceType: resourceType, userNeedsOAuth: userNeedsOAuth } = connector;
    const [status, setStatus] = (0, $cozmU.useState)(()=>$3c744fefcee877cb$var$getInitialStatus(userNeedsOAuth));
    const [errorSubtype, setErrorSubtype] = (0, $cozmU.useState)(null);
    const [remountKey, setRemountKey] = (0, $cozmU.useState)(0);
    const statusRef = (0, $cozmU.useRef)(status);
    const isMountedRef = (0, $cozmU.useRef)(false);
    const onLifecycleEventRef = (0, $cozmU.useRef)(onLifecycleEvent);
    onLifecycleEventRef.current = onLifecycleEvent;
    (0, $cozmU.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    const emitLifecycleEvent = (0, $cozmU.useCallback)((event)=>{
        onLifecycleEventRef.current?.(event, {
            productKey: productKey,
            resourceType: resourceType
        });
    }, [
        productKey,
        resourceType
    ]);
    const setStatusAndRef = (0, $cozmU.useCallback)((nextStatus)=>{
        statusRef.current = nextStatus;
        setStatus(nextStatus);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (userNeedsOAuth === false && statusRef.current !== (0, $fac5703f4bfe6f64$export$863e19ab03ac3107).CONNECTED) {
            /* eslint-disable @atlassian/perf-linting/no-chain-state-updates -- Preserve the existing OAuth state transition during extraction. */ setErrorSubtype(null);
            setStatusAndRef((0, $fac5703f4bfe6f64$export$863e19ab03ac3107).CONNECTED);
        /* eslint-enable @atlassian/perf-linting/no-chain-state-updates */ }
    }, [
        setStatusAndRef,
        userNeedsOAuth
    ]);
    const transitionToIdleFromCancel = (0, $cozmU.useCallback)(()=>{
        if (!isMountedRef.current) return;
        const previousStatus = statusRef.current;
        setErrorSubtype(null);
        setStatusAndRef((0, $fac5703f4bfe6f64$export$863e19ab03ac3107).IDLE);
        if (previousStatus !== (0, $fac5703f4bfe6f64$export$863e19ab03ac3107).IDLE) setRemountKey((key)=>key + 1);
    }, [
        setStatusAndRef
    ]);
    const connect = (0, $cozmU.useCallback)(async ()=>{
        if (!cloudId || !userId || !outboundAuthUrl || statusRef.current === (0, $fac5703f4bfe6f64$export$863e19ab03ac3107).CONNECTING || statusRef.current === (0, $fac5703f4bfe6f64$export$863e19ab03ac3107).CONNECTED) return;
        setErrorSubtype(null);
        setStatusAndRef((0, $fac5703f4bfe6f64$export$863e19ab03ac3107).CONNECTING);
        const authStartTime = Date.now();
        emitLifecycleEvent({
            type: 'auth-started'
        });
        try {
            await (0, $eEPSE.auth)(outboundAuthUrl, $3c744fefcee877cb$export$41d621931d4a5649($3c744fefcee877cb$var$getBrowserWindowMetrics()));
        } catch (authError) {
            const authErrorType = $3c744fefcee877cb$var$getAuthErrorType(authError);
            if (authErrorType === $3c744fefcee877cb$var$AUTH_ERROR_TYPE.AUTH_WINDOW_CLOSED) {
                emitLifecycleEvent({
                    type: 'auth-cancelled',
                    reason: (0, $fac5703f4bfe6f64$export$81ddaaa9359a7ffc).USER_CLOSED_WINDOW
                });
                transitionToIdleFromCancel();
                return;
            }
            if (!isMountedRef.current) {
                emitLifecycleEvent({
                    type: 'auth-aborted',
                    reason: (0, $fac5703f4bfe6f64$export$266b3d969839d15e).UNMOUNTED_DURING_OAUTH
                });
                return;
            }
            const error = $3c744fefcee877cb$var$getError(authError);
            const nextErrorSubtype = authErrorType === $3c744fefcee877cb$var$AUTH_ERROR_TYPE.WINDOW_BLOCKED ? (0, $fac5703f4bfe6f64$export$4b3baebc16f89880).POPUP_BLOCKED : (0, $fac5703f4bfe6f64$export$4b3baebc16f89880).GENERIC;
            if (nextErrorSubtype === (0, $fac5703f4bfe6f64$export$4b3baebc16f89880).POPUP_BLOCKED) {
                setErrorSubtype(nextErrorSubtype);
                emitLifecycleEvent({
                    type: 'auth-aborted',
                    reason: (0, $fac5703f4bfe6f64$export$266b3d969839d15e).POPUP_BLOCKED
                });
            } else {
                emitLifecycleEvent({
                    type: 'auth-error-observed',
                    error: error
                });
                setErrorSubtype(nextErrorSubtype);
            }
            setStatusAndRef((0, $fac5703f4bfe6f64$export$863e19ab03ac3107).ERROR);
            emitLifecycleEvent({
                type: 'auth-failed',
                durationMs: Date.now() - authStartTime,
                error: error,
                errorSubtype: nextErrorSubtype
            });
            throw error;
        }
        if (isMountedRef.current) {
            setErrorSubtype(null);
            setStatusAndRef((0, $fac5703f4bfe6f64$export$863e19ab03ac3107).CONNECTED);
            emitLifecycleEvent({
                type: 'auth-succeeded',
                durationMs: Date.now() - authStartTime
            });
        } else emitLifecycleEvent({
            type: 'auth-aborted',
            reason: (0, $fac5703f4bfe6f64$export$266b3d969839d15e).RESOLVED_AFTER_UNMOUNT
        });
        if (!resourceType) return;
        try {
            await (0, $i9pyX.update3pConfigCacheEntry)(userId, cloudId, (config)=>$3c744fefcee877cb$var$markConnectorAsAuthed(config, resourceType));
        } catch (cacheError) {
            emitLifecycleEvent({
                type: 'cache-update-failed',
                error: $3c744fefcee877cb$var$getError(cacheError)
            });
        }
    }, [
        cloudId,
        emitLifecycleEvent,
        outboundAuthUrl,
        resourceType,
        setStatusAndRef,
        transitionToIdleFromCancel,
        userId
    ]);
    return {
        status: status,
        errorSubtype: errorSubtype,
        remountKey: remountKey,
        connect: connect
    };
};






var $5ZqQS = parcelRequire("5ZqQS");


var $lj5ER = parcelRequire("lj5ER");


var $lPAGb = parcelRequire("lPAGb");

const $87c3cd286c83c90c$var$NOTHING_RESOLVED = {
    authUrl: undefined,
    connectorType: null,
    userNeedsOAuth: undefined
};
const $87c3cd286c83c90c$var$markConnectedInCombinedConfig = (connectorName)=>(config)=>({
            ...config,
            thirdPartyProducts: config.thirdPartyProducts?.map((product)=>product.name === connectorName ? {
                    ...product,
                    isUserOAuthed: true
                } : product)
        });
const $87c3cd286c83c90c$var$resolveConnector = (connectorRows, appId)=>{
    // Only the full connector carries the address the button needs. The Smart Links
    // row for the same product proves the grant and has its own unrelated address.
    const fullConnectorRow = connectorRows.find((row)=>Boolean(row.outboundAuthUrl) && (0, $lj5ER.classifyConnectorRow)(row) === (0, $aoy1P.FULL_CONNECTOR_SOURCE) && (0, $lPAGb.resolveAppIdForConnectorName)(row.name) === appId);
    if (!fullConnectorRow) return $87c3cd286c83c90c$var$NOTHING_RESOLVED;
    return {
        authUrl: fullConnectorRow.outboundAuthUrl ?? undefined,
        connectorType: fullConnectorRow.name,
        userNeedsOAuth: !fullConnectorRow.isUserOAuthed
    };
};
function $87c3cd286c83c90c$export$96821027d858745d({ appId: appId, connectorRows: connectorRows, cloudId: cloudId, userId: userId, analytics: analytics }) {
    const { authUrl: authUrl, connectorType: connectorType, userNeedsOAuth: userNeedsOAuth } = $87c3cd286c83c90c$var$resolveConnector(connectorRows, appId);
    const [failureReason, setFailureReason] = (0, $cozmU.useState)(null);
    const [isPromptHidden, setIsPromptHidden] = (0, $cozmU.useState)(false);
    const analyticsRef = (0, $cozmU.useRef)(analytics);
    analyticsRef.current = analytics;
    const reportFailure = (0, $cozmU.useCallback)((reason)=>{
        analyticsRef.current?.onConnectFailed?.({
            appId: appId,
            connectorType: connectorType,
            reason: reason
        });
        // analytics is optional, so monitoring is the only signal a consumer cannot drop.
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Third-party connect failed for ${appId}: ${reason}`), {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        setFailureReason(reason);
    }, [
        appId,
        connectorType
    ]);
    const completeSuccess = (0, $cozmU.useCallback)(()=>{
        (0, $jjosg.dispatchSmartLinkExternalAuthEvent)(appId);
        if (connectorType && cloudId && userId) {
            const markConnected = $87c3cd286c83c90c$var$markConnectedInCombinedConfig(connectorType);
            // Detection re-reads this config, so the prompt returns on the next page without this.
            // Two cache entries back it and the reader picks one at runtime, so patch both.
            Promise.all([
                (0, $kQgL7.updateCombinedConfigCacheEntry)(userId, cloudId, markConnected),
                (0, $kQgL7.updateBaseCombinedConfigCacheEntry)(cloudId, markConnected)
            ]).then((didUpdate)=>{
                if (!didUpdate.some(Boolean)) (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Third-party connect did not update the combined config for ${appId}`), {
                    attribution: (0, $3IBnw.Attribution).INTEGRATIONS
                });
            });
        }
        setFailureReason(null);
        setIsPromptHidden(true);
    }, [
        appId,
        connectorType,
        cloudId,
        userId
    ]);
    const onLifecycleEvent = (0, $cozmU.useCallback)((event)=>{
        const context = {
            appId: appId,
            connectorType: connectorType
        };
        switch(event.type){
            case 'auth-started':
                analyticsRef.current?.onConnectStarted?.(context);
                break;
            case 'auth-succeeded':
                // Before the analytics call, so a consumer that throws cannot stop the dispatch.
                completeSuccess();
                analyticsRef.current?.onConnectSucceeded?.({
                    ...context,
                    durationMs: event.durationMs
                });
                break;
            case 'auth-cancelled':
                analyticsRef.current?.onConnectCancelled?.(context);
                break;
            case 'auth-failed':
                // Carries the popup-blocked subtype too, so auth-aborted needs no handling.
                reportFailure(event.errorSubtype);
                break;
            default:
                break;
        }
    }, [
        appId,
        completeSuccess,
        connectorType,
        reportFailure
    ]);
    const { status: status, connect: startConnectorOAuth } = (0, $3c744fefcee877cb$export$251c4f89f010321a)({
        connector: {
            productKey: appId,
            resourceType: connectorType ?? undefined,
            outboundAuthUrl: authUrl,
            userNeedsOAuth: userNeedsOAuth
        },
        cloudId: cloudId,
        userId: userId,
        onLifecycleEvent: onLifecycleEvent
    });
    const connect = (0, $cozmU.useCallback)(async ()=>{
        setFailureReason(null);
        if (!authUrl || !cloudId || !userId) {
            reportFailure('unavailable');
            return;
        }
        try {
            // Awaited so the caller can show a spinner. onLifecycleEvent handles the outcome.
            await startConnectorOAuth();
        } catch  {
        // onLifecycleEvent already recorded the precise reason.
        }
    }, [
        authUrl,
        cloudId,
        reportFailure,
        startConnectorOAuth,
        userId
    ]);
    return {
        status: status,
        failureReason: failureReason,
        isPromptHidden: isPromptHidden,
        connect: connect
    };
}


const $b40774f273b94663$var$promptIsGone = (status, isPromptHidden)=>isPromptHidden || status === (0, $fac5703f4bfe6f64$export$863e19ab03ac3107).CONNECTED;
/**
 * Mounted once the product is known. `status` is the outcome, not promise settlement: `connect`
 * resolves on a cancelled popup too, so awaiting it would report success when the reader closed the
 * window. The promo card stays mounted after connect so its CONNECTING → CONNECTED flag can fire;
 * `children` is the dropped rec that fills the same cell.
 */ const $b40774f273b94663$var$ConnectedPromptCard = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { product: product, children: children } = t0;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const t1 = userId ?? "";
    let t2;
    if ($[0] !== cloudId || $[1] !== t1) {
        t2 = (0, $bcpTP.readConnectorRowsFromLocalStorage)({
            userId: t1,
            cloudId: cloudId
        });
        $[0] = cloudId;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const connectorRows = t2.rows;
    let t3;
    if ($[3] !== cloudId || $[4] !== connectorRows || $[5] !== product.appId || $[6] !== userId) {
        t3 = {
            appId: product.appId,
            connectorRows: connectorRows,
            cloudId: cloudId,
            userId: userId
        };
        $[3] = cloudId;
        $[4] = connectorRows;
        $[5] = product.appId;
        $[6] = userId;
        $[7] = t3;
    } else t3 = $[7];
    const { status: status, connect: connect, isPromptHidden: isPromptHidden } = (0, $87c3cd286c83c90c$export$96821027d858745d)(t3);
    let t4;
    if ($[8] !== connect) {
        t4 = ()=>{
            connect();
        };
        $[8] = connect;
        $[9] = t4;
    } else t4 = $[9];
    const startConnect = t4;
    let t5;
    if ($[10] !== product || $[11] !== startConnect || $[12] !== status) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9f4b8ce466873861$export$58286e4ca8c16000), {
            product: product,
            status: status,
            onConnect: startConnect,
            showCardAsListitem: false
        });
        $[10] = product;
        $[11] = startConnect;
        $[12] = status;
        $[13] = t5;
    } else t5 = $[13];
    const t6 = $b40774f273b94663$var$promptIsGone(status, isPromptHidden) ? children : null;
    let t7;
    if ($[14] !== t5 || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t5, t6);
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
};
const $b40774f273b94663$export$56f90ec8f1c93bbe = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { product: product, isResolved: isResolved, children: children } = t0;
    if (!isResolved) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3ddbe371db1d7d75$export$da0df8956ee4e28a), null);
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    if (product) {
        let t1;
        if ($[1] !== children || $[2] !== product) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b40774f273b94663$var$ConnectedPromptCard, {
                product: product
            }, children);
            $[1] = children;
            $[2] = product;
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    let t1;
    if ($[4] !== children) {
        t1 = children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children) : null;
        $[4] = children;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};












var $bnSPF = parcelRequire("bnSPF");


var $5J49L = parcelRequire("5J49L");








var $3tIUC = parcelRequire("3tIUC");


var $iLuzG = parcelRequire("iLuzG");

/** How often and how early the page's Atlassian Document Format references each product. */ const $a0892af6593ffb7f$var$tallyByAppId = (links)=>{
    const referencesByAppId = new Map();
    for (const { url: url, count: count, occurrenceIndex: occurrenceIndex } of links){
        const providerKey = (0, $3tIUC.matchProviderKey)(url);
        const appId = providerKey ? (0, $iLuzG.resolveProviderKeyToAppId)(providerKey) : undefined;
        if (appId) {
            const references = referencesByAppId.get(appId);
            referencesByAppId.set(appId, {
                count: (references?.count ?? 0) + count,
                firstOccurrenceIndex: references ? Math.min(references.firstOccurrenceIndex, occurrenceIndex) : occurrenceIndex
            });
        }
    }
    return referencesByAppId;
};
const $a0892af6593ffb7f$export$fc2da474d7470345 = (candidates, links)=>{
    const referencesByAppId = $a0892af6593ffb7f$var$tallyByAppId(links);
    let winner;
    let bestCount = 0;
    let bestOccurrenceIndex = Number.POSITIVE_INFINITY;
    candidates.forEach((candidate)=>{
        const references = referencesByAppId.get(candidate.appId);
        if (!references) return;
        const winsTieByPageOrder = references.count === bestCount && references.firstOccurrenceIndex < bestOccurrenceIndex;
        if (references.count > bestCount || winsTieByPageOrder) {
            winner = candidate;
            bestCount = references.count;
            bestOccurrenceIndex = references.firstOccurrenceIndex;
        }
    });
    return winner;
};


const $6a0e11e180bf4e62$var$UNRESOLVED = {
    product: undefined,
    isResolved: false
};
const $6a0e11e180bf4e62$var$NO_SLOT = {
    product: undefined,
    isResolved: true
};
const $6a0e11e180bf4e62$var$ADF_WAIT_TIMEOUT_MS = 10000;
const $6a0e11e180bf4e62$export$322ea08f1df1f7cb = (state, contentId)=>{
    const { adf: adf } = (0, $5J49L.usePageAdf)(contentId);
    const [slot, setSlot] = (0, $cozmU.useState)();
    // Detection runs on every render, so its result is read through a ref. Keeping it out of the deps
    // is what stops an ancestor re-render, on scroll for example, re-walking the document and flashing
    // the skeleton back. Follows useSmartLinks.ts:81.
    const stateRef = (0, $cozmU.useRef)(state);
    stateRef.current = state;
    const { kind: kind } = state;
    (0, $cozmU.useEffect)(()=>{
        if (kind !== 'many') return;
        const resolve = (product)=>{
            setSlot({
                contentId: contentId,
                product: product,
                isResolved: true
            });
        };
        const current = stateRef.current;
        if (current.kind !== 'many') return;
        if (!adf) {
            const timeoutId = setTimeout(()=>resolve(), $6a0e11e180bf4e62$var$ADF_WAIT_TIMEOUT_MS);
            return ()=>clearTimeout(timeoutId);
        }
        // `true` includes link marks. Without it the walk finds card nodes only and misses every plain
        // hyperlink, which is the whole reason this feature needs the walk.
        try {
            const links = (0, $bnSPF.extractSmartLinksFromAdf)(adf, true);
            resolve((0, $a0892af6593ffb7f$export$fc2da474d7470345)(current.candidates, links));
        } catch (error) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error instanceof Error ? error : new Error(String(error)), {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            resolve();
        }
    }, [
        adf,
        contentId,
        kind
    ]);
    if (kind === 'none') return $6a0e11e180bf4e62$var$NO_SLOT;
    if (kind === 'single') return {
        product: state.product,
        isResolved: true
    };
    return kind === 'pending' || slot?.contentId !== contentId ? $6a0e11e180bf4e62$var$UNRESOLVED : {
        product: slot.product,
        isResolved: slot.isResolved
    };
};



var $4bm59 = parcelRequire("4bm59");

const $900ad963234a0f2c$export$f9fceee1fdd1cd1e = (entityId)=>{
    const $ = (0, $bDgLe.c)(9);
    const { state: state } = (0, $4bm59.useThirdPartyPromptState)(entityId);
    const { product: product, isResolved: isResolved } = (0, $6a0e11e180bf4e62$export$322ea08f1df1f7cb)(state, entityId);
    if (state.kind === "pending") {
        let t0;
        if ($[0] !== isResolved || $[1] !== product) {
            t0 = {
                placement: "holding",
                product: product,
                isResolved: isResolved
            };
            $[0] = isResolved;
            $[1] = product;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    const shouldReserveSlot = state.kind !== "none";
    if (!shouldReserveSlot) {
        let t0;
        if ($[3] !== isResolved || $[4] !== product) {
            t0 = {
                placement: "none",
                product: product,
                isResolved: isResolved
            };
            $[3] = isResolved;
            $[4] = product;
            $[5] = t0;
        } else t0 = $[5];
        return t0;
    }
    let t0;
    if ($[6] !== isResolved || $[7] !== product) {
        t0 = {
            placement: (0, $6mKj3.expValEquals)("confluence_3p_in_related_content", "isEnabled", true) ? "first" : "none",
            product: product,
            isResolved: isResolved
        };
        $[6] = isResolved;
        $[7] = product;
        $[8] = t0;
    } else t0 = $[8];
    return t0;
};


const $13370343b41cb5f6$var$GRID_CARD_LIMIT = 6;
const $13370343b41cb5f6$var$LIVE_PAGE_GRID_CARD_LIMIT = 4;
const $13370343b41cb5f6$var$TwoCardWrapperWidth = (0, $buxP3.xcss)({
    maxWidth: '480px'
});
const $13370343b41cb5f6$var$ThreeCardWrapperWidth = (0, $buxP3.xcss)({
    maxWidth: '320px'
});
const $13370343b41cb5f6$var$BigCardHeight = (0, $buxP3.xcss)({
    height: '128px'
});
const $13370343b41cb5f6$var$getColumnsBasedOnNumberOfCards = (totalCards)=>{
    const fixedTwoColumns = '1fr 1fr';
    const autoFitColumns = 'repeat(auto-fit, minmax(320px, 1fr))';
    switch(totalCards){
        case 1:
        case 2:
            return fixedTwoColumns;
        default:
            return autoFitColumns;
    }
};
const $13370343b41cb5f6$var$getCardStyles = (totalCards)=>{
    let stylesArray;
    switch(totalCards){
        case 1:
        case 2:
        case 4:
            stylesArray = [
                $13370343b41cb5f6$var$TwoCardWrapperWidth
            ];
            break;
        default:
            stylesArray = [
                $13370343b41cb5f6$var$ThreeCardWrapperWidth
            ];
            break;
    }
    stylesArray.push($13370343b41cb5f6$var$BigCardHeight);
    return stylesArray;
};
const $13370343b41cb5f6$export$13667717607c1973 = (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { pageCardData: pageCardData, pageRecStrategy: pageRecStrategy, entityId: entityId, isCompact: isCompact } = t0;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const cardLimit = isLivePage ? $13370343b41cb5f6$var$LIVE_PAGE_GRID_CARD_LIMIT : $13370343b41cb5f6$var$GRID_CARD_LIMIT;
    const { placement: placement, product: product, isResolved: isResolved } = (0, $900ad963234a0f2c$export$f9fceee1fdd1cd1e)(entityId);
    if (placement === "holding") return null;
    const shouldRestoreDroppedRec = placement === "first" && isResolved && !product;
    const shouldDropLastRec = placement === "first" && (pageCardData.length >= cardLimit || shouldRestoreDroppedRec);
    let t1;
    if ($[0] !== pageCardData || $[1] !== shouldDropLastRec) {
        t1 = shouldDropLastRec ? pageCardData.slice(0, -1) : pageCardData;
        $[0] = pageCardData;
        $[1] = shouldDropLastRec;
        $[2] = t1;
    } else t1 = $[2];
    const recs = t1;
    const droppedRec = shouldDropLastRec ? pageCardData[pageCardData.length - 1] : undefined;
    const totalCards = placement === "first" ? Math.min(pageCardData.length + 1, cardLimit) : pageCardData.length;
    let t2;
    if ($[3] !== totalCards) {
        t2 = $13370343b41cb5f6$var$getColumnsBasedOnNumberOfCards(totalCards);
        $[3] = totalCards;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== droppedRec || $[6] !== entityId || $[7] !== isCompact || $[8] !== isResolved || $[9] !== pageCardData.length || $[10] !== pageRecStrategy || $[11] !== placement || $[12] !== product || $[13] !== totalCards) {
        t3 = placement === "first" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            key: "third-party-related-content-prompt",
            xcss: ()=>$13370343b41cb5f6$var$getCardStyles(totalCards),
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b40774f273b94663$export$56f90ec8f1c93bbe), {
            product: product,
            isResolved: isResolved
        }, droppedRec ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cbfa55b3be44c29a$export$8da2c1e40d5a0791), {
            data: droppedRec,
            ranking: pageCardData.length - 1,
            analyticsData: {
                source: "endOfPageRecommendations",
                attributes: {
                    strategy: pageRecStrategy ? pageRecStrategy[(pageCardData.length - 1) % pageRecStrategy.length] : null,
                    mainContentId: entityId
                }
            },
            isCompactView: isCompact,
            showCardsAsListitem: false
        }) : null)) : null;
        $[5] = droppedRec;
        $[6] = entityId;
        $[7] = isCompact;
        $[8] = isResolved;
        $[9] = pageCardData.length;
        $[10] = pageRecStrategy;
        $[11] = placement;
        $[12] = product;
        $[13] = totalCards;
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== entityId || $[16] !== isCompact || $[17] !== pageRecStrategy || $[18] !== recs || $[19] !== totalCards) {
        let t5;
        if ($[21] !== entityId || $[22] !== isCompact || $[23] !== pageRecStrategy || $[24] !== totalCards) {
            t5 = (node, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                    key: node.id,
                    xcss: ()=>$13370343b41cb5f6$var$getCardStyles(totalCards),
                    role: "listitem"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cbfa55b3be44c29a$export$8da2c1e40d5a0791), {
                    data: node,
                    ranking: i,
                    analyticsData: {
                        source: "endOfPageRecommendations",
                        attributes: {
                            strategy: pageRecStrategy ? pageRecStrategy[i % pageRecStrategy.length] : null,
                            mainContentId: entityId
                        }
                    },
                    isCompactView: isCompact,
                    showCardsAsListitem: false
                }));
            $[21] = entityId;
            $[22] = isCompact;
            $[23] = pageRecStrategy;
            $[24] = totalCards;
            $[25] = t5;
        } else t5 = $[25];
        t4 = recs.map(t5);
        $[15] = entityId;
        $[16] = isCompact;
        $[17] = pageRecStrategy;
        $[18] = recs;
        $[19] = totalCards;
        $[20] = t4;
    } else t4 = $[20];
    let t5;
    if ($[26] !== t2 || $[27] !== t3 || $[28] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
            templateColumns: t2,
            gap: "space.200",
            role: "list"
        }, t3, t4);
        $[26] = t2;
        $[27] = t3;
        $[28] = t4;
        $[29] = t5;
    } else t5 = $[29];
    return t5;
};



const $8d104eedf2f18b6d$var$TwoCardWrapperWidth = (0, $buxP3.xcss)({
    maxWidth: '480px'
});
const $8d104eedf2f18b6d$var$ThreeCardWrapperWidth = (0, $buxP3.xcss)({
    maxWidth: '320px'
});
const $8d104eedf2f18b6d$var$BigCardHeight = (0, $buxP3.xcss)({
    height: '128px'
});
const $8d104eedf2f18b6d$var$getColumnsBasedOnNumberOfCards = (totalCards)=>{
    const fixedTwoColumns = '1fr 1fr';
    const autoFitColumns = 'repeat(auto-fit, minmax(320px, 1fr))';
    switch(totalCards){
        case 1:
        case 2:
            return fixedTwoColumns;
        default:
            return autoFitColumns;
    }
};
const $8d104eedf2f18b6d$var$getCardStyles = (totalCards)=>{
    let stylesArray;
    switch(totalCards){
        case 1:
        case 2:
        case 4:
            stylesArray = [
                $8d104eedf2f18b6d$var$TwoCardWrapperWidth
            ];
            break;
        default:
            stylesArray = [
                $8d104eedf2f18b6d$var$ThreeCardWrapperWidth
            ];
            break;
    }
    stylesArray.push($8d104eedf2f18b6d$var$BigCardHeight);
    return stylesArray;
};
const $8d104eedf2f18b6d$var$EndOfPageRecGridOriginal = (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { pageCardData: pageCardData, pageRecStrategy: pageRecStrategy, entityId: entityId, isCompact: isCompact } = t0;
    let t1;
    if ($[0] !== pageCardData.length) {
        t1 = $8d104eedf2f18b6d$var$getColumnsBasedOnNumberOfCards(pageCardData.length);
        $[0] = pageCardData.length;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== entityId || $[3] !== isCompact || $[4] !== pageCardData || $[5] !== pageRecStrategy) {
        let t3;
        if ($[7] !== entityId || $[8] !== isCompact || $[9] !== pageCardData.length || $[10] !== pageRecStrategy) {
            t3 = (node, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                    key: node.id,
                    xcss: ()=>$8d104eedf2f18b6d$var$getCardStyles(pageCardData.length),
                    role: "listitem"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cbfa55b3be44c29a$export$8da2c1e40d5a0791), {
                    data: node,
                    ranking: i,
                    analyticsData: {
                        source: "endOfPageRecommendations",
                        attributes: {
                            strategy: pageRecStrategy ? pageRecStrategy[i % pageRecStrategy.length] : null,
                            mainContentId: entityId
                        }
                    },
                    isCompactView: isCompact,
                    showCardsAsListitem: false
                }));
            $[7] = entityId;
            $[8] = isCompact;
            $[9] = pageCardData.length;
            $[10] = pageRecStrategy;
            $[11] = t3;
        } else t3 = $[11];
        t2 = pageCardData.map(t3);
        $[2] = entityId;
        $[3] = isCompact;
        $[4] = pageCardData;
        $[5] = pageRecStrategy;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[12] !== t1 || $[13] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
            templateColumns: t1,
            gap: "space.200",
            role: "list"
        }, t2);
        $[12] = t1;
        $[13] = t2;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
};
const $8d104eedf2f18b6d$export$ad5c1ee2c44a1a7f = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_3p_in_related_content", "shouldEvaluate", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13370343b41cb5f6$export$13667717607c1973), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d104eedf2f18b6d$var$EndOfPageRecGridOriginal, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};












var $7akNQ = parcelRequire("7akNQ");


var $4aRua = parcelRequire("4aRua");


var $1l0kj = parcelRequire("1l0kj");








var $6bd6t = parcelRequire("6bd6t");


var $dchHi = parcelRequire("dchHi");














var $7ZB0A = parcelRequire("7ZB0A");


var $1sCHt = parcelRequire("1sCHt");


var $a1ZzW = parcelRequire("a1ZzW");


var $fodiz = parcelRequire("fodiz");


var $lsxnT = parcelRequire("lsxnT");





var $6oZiN = parcelRequire("6oZiN");


var $ihn35 = parcelRequire("ihn35");

const $533af8c3a7fd70b6$export$5194d34db5ab5ce4 = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { toggleInfo: toggleInfo, showFeedbackButton: showFeedbackButton, clickFeedback: clickFeedback, isInfoOpen: isInfoOpen, handleInfoButtonRef: handleInfoButtonRef } = t0;
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== clickFeedback || $[1] !== showFeedbackButton) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihn35.InfoContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6oZiN.i18n).info), showFeedbackButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihn35.FeedbackContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                onClick: clickFeedback
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6oZiN.i18n).feedback))));
        $[0] = clickFeedback;
        $[1] = showFeedbackButton;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== handleInfoButtonRef || $[4] !== isInfoOpen || $[5] !== toggleInfo) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: "subtle",
                onClick: toggleInfo,
                isSelected: isInfoOpen,
                testId: "eop-info-button",
                spacing: (0, $6mKj3.expVal)("confluence_related_pages_remove_feedback_icons", "isEnabled", false) ? "compact" : undefined,
                icon: (0, $6mKj3.expVal)("confluence_related_pages_remove_feedback_icons", "isEnabled", false) ? $533af8c3a7fd70b6$var$_temp : (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6oZiN.i18n).infoButton),
                ...triggerProps,
                ref: handleInfoButtonRef(triggerProps)
            });
        $[3] = handleInfoButtonRef;
        $[4] = isInfoOpen;
        $[5] = toggleInfo;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== Popup || $[8] !== isInfoOpen || $[9] !== t1 || $[10] !== t2 || $[11] !== toggleInfo) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
            shouldRenderToParent: true,
            strategy: "absolute",
            onClose: toggleInfo,
            content: t1,
            isOpen: isInfoOpen,
            placement: "top-start",
            trigger: t2
        });
        $[7] = Popup;
        $[8] = isInfoOpen;
        $[9] = t1;
        $[10] = t2;
        $[11] = toggleInfo;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
};
function $533af8c3a7fd70b6$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
        ...iconProps,
        size: "small"
    });
}


const $e0cc7e4e5e2b854b$var$i18n = (0, $kSwu1.defineMessages)({
    headerTitle: {
        id: "page-recommendations.end-of-page-recommendation-compact-header.title",
        defaultMessage: "Related content"
    },
    feedbackTitle: {
        id: "page-recommendations.end-of-page-recommendation-compact-header.feedback.title",
        defaultMessage: "Help us improve Confluence"
    },
    feedbackSummaryPlaceholder: {
        id: "page-recommendations.end-of-page-recommendation-compact-header.feedback.summary.placeholder",
        defaultMessage: "What did we do well? What could be improved?"
    }
});
const $e0cc7e4e5e2b854b$var$styles = {
    container: "_1wydGW5zaO"
};
const $e0cc7e4e5e2b854b$export$dd7678881b84ee46 = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { toggleInfo: toggleInfo, isInfoOpen: isInfoOpen, handleInfoButtonRef: handleInfoButtonRef, analyticsProperties: analyticsProperties, contentId: contentId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    analyticsProperties?.additionalAnalyticsAttributes?.contentType;
    const t1 = analyticsProperties?.additionalAnalyticsAttributes?.contentType;
    let t2;
    if ($[0] !== contentId || $[1] !== t1) {
        t2 = {
            product: "confluence",
            subproduct: "confluence",
            source: "endOfPageRecommendationHeader",
            aiFeatureName: "endOfPageRecommendation",
            proactiveGeneratedAI: 1,
            userGeneratedAI: 0,
            additionalAttributes: {
                contentId: contentId,
                contentType: t1,
                from: (0, $71GjD.FeatureCode).EOP_REC
            }
        };
        $[0] = contentId;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const aiAnalyticsConfig = t2;
    let t3;
    if ($[3] !== analyticsProperties || $[4] !== contentId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6bd6t.SmartsFeedbackComponent), {
            analyticsProperties: analyticsProperties,
            contentId: contentId,
            feedbackTitle: $e0cc7e4e5e2b854b$var$i18n.feedbackTitle,
            feedbackSummaryPlaceholder: $e0cc7e4e5e2b854b$var$i18n.feedbackSummaryPlaceholder,
            aiContentType: "suggestion"
        });
        $[3] = analyticsProperties;
        $[4] = contentId;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== aiAnalyticsConfig || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dchHi.FeedbackCollectorPropertiesProvider), {
            entrypointId: "d15eac98-e451-452a-84ce-dcf70888cb52"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
            config: aiAnalyticsConfig
        }, t3)));
        $[6] = aiAnalyticsConfig;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    const feedbackComponent = t4;
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($e0cc7e4e5e2b854b$var$i18n.headerTitle);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium"
        }, t5);
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== handleInfoButtonRef || $[14] !== isInfoOpen || $[15] !== toggleInfo) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $533af8c3a7fd70b6$export$5194d34db5ab5ce4), {
            toggleInfo: toggleInfo,
            showFeedbackButton: false,
            isInfoOpen: isInfoOpen,
            handleInfoButtonRef: handleInfoButtonRef
        });
        $[13] = handleInfoButtonRef;
        $[14] = isInfoOpen;
        $[15] = toggleInfo;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== feedbackComponent) {
        t8 = (0, $6mKj3.expVal)("confluence_related_pages_remove_feedback_icons", "isEnabled", false) ? null : feedbackComponent;
        $[17] = feedbackComponent;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            xcss: $e0cc7e4e5e2b854b$var$styles.container,
            testId: "eop-compact-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t6, t7, t8));
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};



var $3dOiI = parcelRequire("3dOiI");














var $gnKXs = parcelRequire("gnKXs");

const $58aae0f847bd3c55$var$endOfPageRecContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingBottom: 'space.250',
    margin: 'auto',
    width: '87.5%',
    [(0, $gnKXs.media).above.lg]: {
        maxWidth: '1000px'
    }
});
const $58aae0f847bd3c55$var$relatedPagesSpecSectionSpacingStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.300'
});
const $58aae0f847bd3c55$var$maxWidthStyles = (0, $buxP3.xcss)({
    width: 'unset',
    maxWidth: 'unset'
});
const $58aae0f847bd3c55$export$762e81e2e5e5fd21 = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, ssrPlaceholderIdProp: ssrPlaceholderIdProp, isDefaultWidth: isDefaultWidth, isCompactRelatedContentSpecSpacing: isCompactRelatedContentSpecSpacing } = t0;
    const componentRef = (0, $cozmU.useRef)(null);
    const t1 = isCompactRelatedContentSpecSpacing && $58aae0f847bd3c55$var$relatedPagesSpecSectionSpacingStyles;
    const t2 = !isDefaultWidth && $58aae0f847bd3c55$var$maxWidthStyles;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = [
            $58aae0f847bd3c55$var$endOfPageRecContainerStyles,
            t1,
            t2
        ];
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== children || $[4] !== ssrPlaceholderIdProp || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            "data-testid": "test-rec",
            "data-vc": "end-of-page-recommendation-component",
            ref: componentRef,
            testId: "test-rec",
            xcss: t3,
            ...ssrPlaceholderIdProp
        }, children);
        $[3] = children;
        $[4] = ssrPlaceholderIdProp;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
};


const $e559508598822550$var$GRID_CARD_LIMIT = 6;
const $e559508598822550$var$GRID_CARD_LIMIT_LIVE_PAGES = 4;
const $e559508598822550$export$4cd5fff7a629299d = (t0)=>{
    const $ = (0, $bDgLe.c)(55);
    const { entityId: entityId, entityType: entityType, pageCardData: pageCardData, data: data, pageWidthType: pageWidthType, isLivePage: isLivePage, spaceKey: spaceKey, spaceIdOverride: spaceIdOverride, recommendationStrategyLabel: recommendationStrategyLabel } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isInfoOpen, setInfoOpen] = (0, $cozmU.useState)(false);
    const compRef = (0, $cozmU.useRef)(null);
    const infoButtonRef = (0, $cozmU.useRef)(null);
    const [, actions] = (0, $isEtk.useContentState)();
    const gridCardLimit = isLivePage ? $e559508598822550$var$GRID_CARD_LIMIT_LIVE_PAGES : $e559508598822550$var$GRID_CARD_LIMIT;
    let t1;
    if ($[0] !== gridCardLimit || $[1] !== pageCardData) {
        t1 = pageCardData?.slice(0, gridCardLimit).map($e559508598822550$var$_temp);
        $[0] = gridCardLimit;
        $[1] = pageCardData;
        $[2] = t1;
    } else t1 = $[2];
    const pageRecIds = t1;
    let t2;
    bb0: {
        if (recommendationStrategyLabel) {
            let strategiesArray;
            if ($[3] !== gridCardLimit || $[4] !== pageCardData?.length || $[5] !== recommendationStrategyLabel) {
                strategiesArray = Array(gridCardLimit).fill("NULL");
                const recCount = Math.min(pageCardData?.length ?? 0, gridCardLimit);
                for(let index = 0; index < recCount; index++)strategiesArray[index] = recommendationStrategyLabel;
                $[3] = gridCardLimit;
                $[4] = pageCardData?.length;
                $[5] = recommendationStrategyLabel;
                $[6] = strategiesArray;
            } else strategiesArray = $[6];
            t2 = strategiesArray;
            break bb0;
        }
        let strategiesArray_0;
        if ($[7] !== data?.getRecommendedPages?.recommendedPages || $[8] !== gridCardLimit) {
            const recommendations = data?.getRecommendedPages?.recommendedPages?.slice(0, gridCardLimit) || [];
            strategiesArray_0 = Array(gridCardLimit).fill("NULL");
            recommendations.forEach((rec, index_0)=>{
                strategiesArray_0[index_0] = rec.strategy.map($e559508598822550$var$_temp2).sort().join("");
            });
            $[7] = data?.getRecommendedPages?.recommendedPages;
            $[8] = gridCardLimit;
            $[9] = strategiesArray_0;
        } else strategiesArray_0 = $[9];
        t2 = strategiesArray_0;
    }
    const contentRecsStrategies = t2;
    const spaceId = spaceIdOverride ?? data?.space?.id;
    let t3;
    if ($[10] !== createAnalyticsEvent || $[11] !== entityId || $[12] !== entityType || $[13] !== isInfoOpen) {
        t3 = ()=>{
            if (!isInfoOpen) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: entityType,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "endOfPageRecommendationsInfoButton",
                    attributes: {
                        contentId: entityId
                    }
                }
            }).fire();
            setInfoOpen(!isInfoOpen);
        };
        $[10] = createAnalyticsEvent;
        $[11] = entityId;
        $[12] = entityType;
        $[13] = isInfoOpen;
        $[14] = t3;
    } else t3 = $[14];
    const toggleInfo = t3;
    let t4;
    if ($[15] !== contentRecsStrategies || $[16] !== createAnalyticsEvent || $[17] !== entityId || $[18] !== entityType || $[19] !== spaceId) {
        t4 = ()=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: entityType,
                    action: "observed",
                    actionSubject: "endOfPageRecommendations",
                    attributes: {
                        strategies: contentRecsStrategies
                    },
                    objectId: entityId,
                    containerId: spaceId
                }
            }).fire();
        };
        $[15] = contentRecsStrategies;
        $[16] = createAnalyticsEvent;
        $[17] = entityId;
        $[18] = entityType;
        $[19] = spaceId;
        $[20] = t4;
    } else t4 = $[20];
    const onObserved = t4;
    (0, $fgRQY.useElementSeenCallback)(compRef, onObserved);
    let t5;
    if ($[21] !== contentRecsStrategies || $[22] !== createAnalyticsEvent || $[23] !== entityId || $[24] !== entityType || $[25] !== pageRecIds?.length || $[26] !== spaceId) {
        t5 = ()=>{
            if (!!pageRecIds?.length && pageRecIds?.length > 1) createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: entityType,
                    action: "rendered",
                    actionSubject: "endOfPageRecommendations",
                    attributes: {
                        strategies: contentRecsStrategies
                    },
                    objectId: entityId,
                    containerId: spaceId
                }
            }).fire();
        };
        $[21] = contentRecsStrategies;
        $[22] = createAnalyticsEvent;
        $[23] = entityId;
        $[24] = entityType;
        $[25] = pageRecIds?.length;
        $[26] = spaceId;
        $[27] = t5;
    } else t5 = $[27];
    let t6;
    if ($[28] !== contentRecsStrategies || $[29] !== createAnalyticsEvent || $[30] !== entityId || $[31] !== entityType || $[32] !== pageRecIds || $[33] !== spaceId) {
        t6 = [
            createAnalyticsEvent,
            entityId,
            contentRecsStrategies,
            pageRecIds,
            spaceId,
            entityType
        ];
        $[28] = contentRecsStrategies;
        $[29] = createAnalyticsEvent;
        $[30] = entityId;
        $[31] = entityType;
        $[32] = pageRecIds;
        $[33] = spaceId;
        $[34] = t6;
    } else t6 = $[34];
    (0, $cozmU.useEffect)(t5, t6);
    const isSSRed = window.__SSR_RENDERED__;
    let t7;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (triggerProps)=>(node)=>{
                infoButtonRef.current = node;
                triggerProps.ref(node);
            };
        $[35] = t7;
    } else t7 = $[35];
    const handleInfoButtonRef = t7;
    let t8;
    if ($[36] !== pageWidthType) {
        t8 = pageWidthType ? JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT : false;
        $[36] = pageWidthType;
        $[37] = t8;
    } else t8 = $[37];
    const isDefaultWidth = t8;
    pageCardData?.length;
    const t9 = pageCardData?.length || 0;
    let t10;
    if ($[38] !== contentRecsStrategies || $[39] !== entityType || $[40] !== spaceId || $[41] !== spaceKey || $[42] !== t9) {
        t10 = {
            source: "endOfPageRecommendation",
            additionalAnalyticsAttributes: {
                contentType: entityType,
                strategies: contentRecsStrategies,
                spaceKey: spaceKey,
                spaceId: spaceId,
                recommendationCount: t9
            }
        };
        $[38] = contentRecsStrategies;
        $[39] = entityType;
        $[40] = spaceId;
        $[41] = spaceKey;
        $[42] = t9;
        $[43] = t10;
    } else t10 = $[43];
    const analyticsProperties = t10;
    let t11;
    if ($[44] !== actions || $[45] !== analyticsProperties || $[46] !== contentRecsStrategies || $[47] !== entityId || $[48] !== gridCardLimit || $[49] !== isDefaultWidth || $[50] !== isInfoOpen || $[51] !== pageCardData || $[52] !== ssrPlaceholderIdProp || $[53] !== toggleInfo) {
        t11 = !!pageCardData?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, !isSSRed && (actions?.addContentToBeLoaded("endOfPageRecommendation", "loading"), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58aae0f847bd3c55$export$762e81e2e5e5fd21), {
            isDefaultWidth: isDefaultWidth,
            ssrPlaceholderIdProp: ssrPlaceholderIdProp,
            isCompactRelatedContentSpecSpacing: (0, $6mKj3.expVal)("confluence_related_pages_remove_feedback_icons", "isEnabled", false)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0cc7e4e5e2b854b$export$dd7678881b84ee46), {
            toggleInfo: toggleInfo,
            isInfoOpen: isInfoOpen,
            handleInfoButtonRef: handleInfoButtonRef,
            analyticsProperties: analyticsProperties,
            contentId: entityId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "top",
            exitDirection: "top",
            duration: "medium"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8d104eedf2f18b6d$export$ad5c1ee2c44a1a7f), {
                isCompact: true,
                pageCardData: pageCardData.slice(0, gridCardLimit),
                pageRecStrategy: contentRecsStrategies,
                entityId: entityId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ref: compRef
            }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: entityId,
            metric: (0, $3dOiI.END_OF_PAGE_RECOMMENDATIONS_METRIC)
        }), !isSSRed && (actions?.removeContentFromLoading("endOfPageRecommendation"), null)) : null;
        $[44] = actions;
        $[45] = analyticsProperties;
        $[46] = contentRecsStrategies;
        $[47] = entityId;
        $[48] = gridCardLimit;
        $[49] = isDefaultWidth;
        $[50] = isInfoOpen;
        $[51] = pageCardData;
        $[52] = ssrPlaceholderIdProp;
        $[53] = toggleInfo;
        $[54] = t11;
    } else t11 = $[54];
    return t11;
};
function $e559508598822550$var$_temp(content) {
    return content.id;
}
function $e559508598822550$var$_temp2(s) {
    return s.charAt(0);
}
module.exports["EndOfPageRecommendationComponent"] = $e559508598822550$export$4cd5fff7a629299d;

});

parcelRegister("bcpTP", function(module, exports) {

var $9hMB7 = parcelRequire("9hMB7");


var $1UApO = parcelRequire("1UApO");


var $17wUi = parcelRequire("17wUi");


var $cHST4 = parcelRequire("cHST4");

const $659185fcc2b25ddb$var$fail = (failureReason)=>({
        rows: [],
        failureReason: failureReason
    });
/**
 * The payload can arrive under the GraphQL response envelope or bare. Only `thirdPartyProducts` is
 * checked, because it is the only field read, and `readConnectorRows` validates its contents.
 */ const $659185fcc2b25ddb$var$readCombinedConfig = (result)=>{
    const config = result?.data?.search?.configuration ?? result;
    return typeof config === 'object' && config !== null && 'thirdPartyProducts' in config ? config : null;
};
const $659185fcc2b25ddb$export$b217a637edd6561d = ({ userId: userId, cloudId: cloudId })=>{
    // Both are nullable and neither can be hashed. Reported, not thrown, so the render survives.
    if (!userId || !cloudId) return $659185fcc2b25ddb$var$fail('missing_account_ids');
    const cached = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SEARCH_COMBINED_CONFIG);
    if (!cached) return $659185fcc2b25ddb$var$fail('cache_entry_missing');
    try {
        // `getItem` parses once. A value that was encoded twice comes back as a string.
        const parsedCache = typeof cached === 'string' ? JSON.parse(cached) : cached;
        const cacheKey = String((0, $9hMB7.generateCombinedConfigHash)(userId, cloudId));
        if (typeof parsedCache !== 'object' || parsedCache === null || !(cacheKey in parsedCache)) return $659185fcc2b25ddb$var$fail('cache_key_not_found');
        const payload = $659185fcc2b25ddb$var$readCombinedConfig(parsedCache[cacheKey]?.result);
        if (!payload) return $659185fcc2b25ddb$var$fail('cache_payload_invalid');
        return {
            rows: (0, $cHST4.readConnectorRows)(payload),
            failureReason: null
        };
    } catch  {
        return $659185fcc2b25ddb$var$fail('cache_entry_json_parse_failed');
    }
};
module.exports["readConnectorRowsFromLocalStorage"] = $659185fcc2b25ddb$export$b217a637edd6561d;

});

parcelRegister("lj5ER", function(module, exports) {

var $fd0l2 = parcelRequire("fd0l2");


var $aoy1P = parcelRequire("aoy1P");


var $lPAGb = parcelRequire("lPAGb");

// A resource type is the full-connector name, e.g. `google-drive-connector`.
const $47fe0f4c22649ffd$var$productKeyByResourceType = new Map();
(0, $fd0l2.ThirdPartyConfigsSync).forEach((config, productKey)=>{
    if (config.resourceType) $47fe0f4c22649ffd$var$productKeyByResourceType.set(config.resourceType, productKey);
});
const $47fe0f4c22649ffd$var$isProductKey = (value)=>(0, $fd0l2.ThirdPartyConfigsSync).has(value);
/** Static config for a connector name. Standard names hit the resource-type map; aliases fall back to app id. */ const $47fe0f4c22649ffd$var$staticConfigForName = (connectorName)=>{
    let productKey = $47fe0f4c22649ffd$var$productKeyByResourceType.get(connectorName);
    if (!productKey) {
        const appId = (0, $lPAGb.resolveAppIdForConnectorName)(connectorName);
        productKey = appId && $47fe0f4c22649ffd$var$isProductKey(appId) ? appId : undefined;
    }
    return productKey ? (0, $fd0l2.ThirdPartyConfigsSync).get(productKey) : undefined;
};
const $47fe0f4c22649ffd$export$a204cf921b26b307 = (row)=>{
    if (row.name.startsWith((0, $aoy1P.SMARTLINKS_RESOURCE_TYPE_PREFIX))) return 0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE;
    if (row.name.startsWith((0, $aoy1P.LITE_CONNECTOR_SOURCE_PREFIX))) return 0, $aoy1P.LITE_CONNECTOR_SOURCE;
    const config = $47fe0f4c22649ffd$var$staticConfigForName(row.name);
    if (!config) return undefined;
    if (row.connectorSyncType === (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE) || config.isFederated) return 0, $aoy1P.FEDERATED_CONNECTOR_SOURCE;
    return 0, $aoy1P.FULL_CONNECTOR_SOURCE;
};
module.exports["classifyConnectorRow"] = $47fe0f4c22649ffd$export$a204cf921b26b307;

});

parcelRegister("lPAGb", function(module, exports) {

var $dkZJV = parcelRequire("dkZJV");

/** Names no `AppId` generates; platform keeps the last two as legacy aliases. */ const $1e79d9eb97b5a652$var$CONNECTOR_NAME_ALIASES = [
    [
        'smartlinks-connector-gdrive-rsl',
        'drive'
    ],
    [
        'lite-connector-gdrive',
        'drive'
    ],
    [
        'ai-3p-connector:google-workspace',
        'drive'
    ],
    [
        'ai-3p-connector:sharepoint-domain',
        'sharepoint'
    ]
];
const $1e79d9eb97b5a652$var$appIdByConnectorName = new Map();
// The map is declared `Record<AppId, AppInfo>`, so every key is an `AppId`.
for (const appId of Object.keys((0, $dkZJV.appIdToAppInfoMap))){
    const { smartlinkConnectorType: smartlinkConnectorType, fullConnectorType: fullConnectorType } = (0, $dkZJV.appIdToAppInfoMap)[appId];
    $1e79d9eb97b5a652$var$appIdByConnectorName.set(smartlinkConnectorType ?? `smartlinks-connector-${appId}`, appId);
    $1e79d9eb97b5a652$var$appIdByConnectorName.set(fullConnectorType ?? `${appId}-connector`, appId);
}
// After the generated names, so a legacy alias wins on any collision.
for (const [connectorName, appId] of $1e79d9eb97b5a652$var$CONNECTOR_NAME_ALIASES)$1e79d9eb97b5a652$var$appIdByConnectorName.set(connectorName, appId);
const $1e79d9eb97b5a652$export$4446d8eaf6331224 = (connectorName)=>$1e79d9eb97b5a652$var$appIdByConnectorName.get(connectorName);
module.exports["resolveAppIdForConnectorName"] = $1e79d9eb97b5a652$export$4446d8eaf6331224;

});

parcelRegister("3tIUC", function(module, exports) {
// `regexp` is compiled once, when the table is built. `i` for RFC 3986 host case.
const $0064d1314f8e2606$var$host = (pattern)=>{
    const source = `^https:\\/\\/${pattern}(?:[/?#]|$)`;
    return {
        source: source,
        regexp: new RegExp(source, 'i')
    };
};
const $0064d1314f8e2606$var$hostPath = (pattern, path)=>{
    const source = `^https:\\/\\/${pattern}${path}`;
    return {
        source: source,
        regexp: new RegExp(source, 'i')
    };
};
const $0064d1314f8e2606$export$170e5c14487f23c = [
    {
        key: 'adobe-xd-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('xd\\.adobe\\.com')
        ]
    },
    {
        key: 'airtable-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('airtable\\.com')
        ]
    },
    {
        key: 'amplitude-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('app\\.amplitude\\.com'),
            $0064d1314f8e2606$var$host('analytics\\.amplitude\\.com')
        ]
    },
    {
        key: 'asana-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('app\\.asana\\.com')
        ]
    },
    {
        key: 'azuredevops-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('dev\\.azure\\.com'),
            $0064d1314f8e2606$var$host('[^/]+\\.visualstudio\\.com')
        ]
    },
    {
        key: 'box-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('[^/]+\\.box\\.com')
        ]
    },
    {
        key: 'clickup-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('app\\.clickup\\.com')
        ]
    },
    {
        key: 'docusign-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('apps\\.docusign\\.com')
        ]
    },
    {
        key: 'dovetail-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('[^/]+\\.dovetail(?:app)?\\.com')
        ]
    },
    {
        key: 'dropbox-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('(?:www\\.)?dropbox\\.com')
        ]
    },
    {
        key: 'figma-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('(?:[\\w.-]+\\.)?figma\\.com')
        ]
    },
    {
        key: 'github-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('gist\\.github\\.com'),
            $0064d1314f8e2606$var$host('github\\.com')
        ]
    },
    {
        key: 'gitlab-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('gitlab\\.com')
        ]
    },
    {
        key: 'google-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('docs\\.google\\.com'),
            $0064d1314f8e2606$var$host('drive\\.google\\.com')
        ]
    },
    {
        key: 'hubspot-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('[^/]+\\.hubspot\\.com')
        ]
    },
    {
        key: 'launchdarkly-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('app\\.launchdarkly\\.com')
        ]
    },
    {
        key: 'lucid-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('lucid\\.app')
        ]
    },
    {
        key: 'miro-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('miro\\.com')
        ]
    },
    {
        key: 'monday-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('(?:[^/]+\\.)?monday\\.com')
        ]
    },
    {
        key: 'ms-power-bi-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('app\\.powerbi\\.com')
        ]
    },
    {
        key: 'ms-teams-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('teams\\.cloud\\.microsoft'),
            // microsoft.com serves more than Teams, so match only the deep-link paths.
            $0064d1314f8e2606$var$hostPath('[^/]+\\.microsoft\\.com', '\\/l\\/(?:channel|chat|message)\\/')
        ]
    },
    {
        key: 'mural-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('app\\.mural\\.co')
        ]
    },
    {
        key: 'notion-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('(?:www\\.)?notion\\.so')
        ]
    },
    {
        key: 'onedrive-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('[^/]+\\.sharepoint\\.com'),
            $0064d1314f8e2606$var$host('onedrive\\.live\\.com'),
            $0064d1314f8e2606$var$host('1drv\\.ms'),
            // A customer vanity SharePoint domain ORS ships; not a typo.
            $0064d1314f8e2606$var$host('team\\.amat\\.com')
        ]
    },
    {
        key: 'pagerduty-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('[^/]+\\.pagerduty\\.com')
        ]
    },
    {
        key: 'pipedrive-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('[^/]+\\.pipedrive\\.com')
        ]
    },
    // Exclude sandboxes: they are a separate provider with no app mapping.
    {
        key: 'salesforce-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('(?![^/]+\\.sandbox)[^/]+\\.lightning\\.force\\.com')
        ]
    },
    {
        key: 'sentry-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('[^/]+\\.sentry\\.io'),
            $0064d1314f8e2606$var$host('sentry\\.io')
        ]
    },
    {
        key: 'slack-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('[^/]+\\.slack\\.com'),
            $0064d1314f8e2606$var$host('slack-files\\.com')
        ]
    },
    // `\w{2,}`: Smartsheet serves several TLDs, e.g. `.com`, `.eu`.
    {
        key: 'smartsheet-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('app\\.smartsheet\\.\\w{2,}')
        ]
    },
    {
        key: 'stripe-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('dashboard\\.stripe\\.com')
        ]
    },
    {
        key: 'todoist-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('app\\.todoist\\.com')
        ]
    },
    {
        key: 'webex-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('[^/]+\\.webex\\.com')
        ]
    },
    {
        key: 'zeplin-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('app\\.zeplin\\.io'),
            $0064d1314f8e2606$var$host('zpl\\.io')
        ]
    },
    {
        key: 'zendesk-object-provider',
        patterns: [
            $0064d1314f8e2606$var$host('[^/]+\\.zendesk\\.com')
        ]
    }
];
const $0064d1314f8e2606$export$5af98adab75074e = (url)=>$0064d1314f8e2606$export$170e5c14487f23c.find(({ patterns: patterns })=>patterns.some(({ regexp: regexp })=>regexp.test(url)))?.key;
module.exports["matchProviderKey"] = $0064d1314f8e2606$export$5af98adab75074e;

});

parcelRegister("iLuzG", function(module, exports) {

var $dkZJV = parcelRequire("dkZJV");

const $564eeac70df35f21$export$76c1b9e2d363c586 = (providerKey)=>{
    // A plain object, so an inherited key like `constructor` reads a function rather than an `AppId`.
    const appIds = (0, $dkZJV.smartlinkExtensionKeyToAppIdMap)[providerKey];
    if (Array.isArray(appIds)) return [
        ...appIds
    ];
    return typeof appIds === 'string' ? [
        appIds
    ] : [];
};
const $564eeac70df35f21$export$ad56f29c41a4b8 = (providerKey)=>$564eeac70df35f21$export$76c1b9e2d363c586(providerKey)[0];
module.exports["resolveProviderKeyToAppId"] = $564eeac70df35f21$export$ad56f29c41a4b8;

});

parcelRegister("cHST4", function(module, exports) {
const $656d4fa020025430$var$isNullableString = (value)=>value === undefined || value === null || typeof value === 'string';
// The payload type is what the schema promises. This is a stale cache another surface wrote.
const $656d4fa020025430$var$isConnectorRow = (value)=>{
    if (typeof value !== 'object' || value === null) return false;
    const row = value;
    return typeof row.name === 'string' && typeof row.isUserOAuthed === 'boolean' && $656d4fa020025430$var$isNullableString(row.outboundAuthUrl) && $656d4fa020025430$var$isNullableString(row.providerId) && $656d4fa020025430$var$isNullableString(row.connectorSyncType);
};
const $656d4fa020025430$export$5d5dd73e819f34b9 = (payload)=>{
    const rows = payload.thirdPartyProducts;
    return Array.isArray(rows) ? rows.filter($656d4fa020025430$var$isConnectorRow) : [];
};
module.exports["readConnectorRows"] = $656d4fa020025430$export$5d5dd73e819f34b9;

});


//# sourceMappingURL=EndOfPageRecommendation.b07c218a.js.map
